/* eslint-disable max-len */
/* eslint-disable quotes  */
/* eslint-disable object-curly-newline */
import { ISelectData } from 'components/atoms/SelectComponent';

export const leiElfKodyPermanent: ISelectData[] = [
    {
        labelcz: 'JINY_PRAVNI_KOD',
        labelen: 'JINY_PRAVNI_KOD',
        value: '8888'
    }
];

export const leiElfKodySelect = {
    EU: [],
    XX: [],
    UN: [],
    AG: [
        {
            value: 'CDOV',
            labelcz: 'International Business Corporation',
            labelen: 'International Business Corporation'
        }
    ],
    AR: [
        { value: 'F0A6', labelcz: 'Sociedad Anonima', labelen: 'Sociedad Anonima' },
        {
            value: 'HZ6C',
            labelcz: 'Sociedad Cooperativa',
            labelen: 'Sociedad Cooperativa'
        },
        {
            value: 'WUAZ',
            labelcz: 'Sociedad Anonima Unipersonal',
            labelen: 'Sociedad Anonima Unipersonal'
        }
    ],
    AW: [
        { value: 'CRL9', labelcz: 'Stichting', labelen: 'Stichting' },
        {
            value: 'CYW2',
            labelcz: 'Vennootschap onder firma',
            labelen: 'Vennootschap onder firma'
        },
        {
            value: 'GAJN',
            labelcz: 'Commanditaire vennootschap (1)',
            labelen: 'Commanditaire vennootschap (1)'
        },
        {
            value: 'M27U',
            labelcz: 'Besloten vennootschap',
            labelen: 'Besloten vennootschap'
        },
        { value: 'OLAI', labelcz: 'Vereniging', labelen: 'Vereniging' },
        {
            value: 'P65N',
            labelcz: 'Naamloze vennootschap',
            labelen: 'Naamloze vennootschap'
        },
        {
            value: 'PCRJ',
            labelcz: 'Cooperatieve vereniging',
            labelen: 'Cooperatieve vereniging'
        },
        { value: 'PT6C', labelcz: 'Eenmanszaak', labelen: 'Eenmanszaak' },
        {
            value: 'REUP',
            labelcz: 'Aruba vrijgestelde vennootschap',
            labelen: 'Aruba vrijgestelde vennootschap'
        },
        {
            value: 'T5RL',
            labelcz: 'Vennootschap buitenlands recht',
            labelen: 'Vennootschap buitenlands recht'
        },
        { value: 'UV8T', labelcz: 'Maatschap', labelen: 'Maatschap' },
        {
            value: 'V905',
            labelcz: 'Vennootschap met beperkte aansprakelijkheid',
            labelen: 'Vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'YCV2',
            labelcz: 'Commanditaire vennootschap (1+)',
            labelen: 'Commanditaire vennootschap (1+)'
        }
    ],
    AU: [
        { value: '6W6X', labelcz: 'Co-operative', labelen: 'Co-operative' },
        { value: '7TPC', labelcz: 'Trust', labelen: 'Trust' },
        { value: 'ADXG', labelcz: 'Fund', labelen: 'Fund' },
        {
            value: 'BC38',
            labelcz: 'Incorporated association',
            labelen: 'Incorporated association'
        },
        {
            value: 'J4JC',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'LZFR',
            labelcz: 'Public Company limited by guarantee',
            labelen: 'Public Company limited by guarantee'
        },
        {
            value: 'PQHL',
            labelcz: 'No Liability Company',
            labelen: 'No Liability Company'
        },
        {
            value: 'Q82Q',
            labelcz: 'Unlimited Proprietary Company',
            labelen: 'Unlimited Proprietary Company'
        },
        {
            value: 'R4KK',
            labelcz: 'Public Company limited by shares',
            labelen: 'Public Company limited by shares'
        },
        {
            value: 'TXVC',
            labelcz: 'Limited Proprietary Company',
            labelen: 'Limited Proprietary Company'
        },
        {
            value: 'XHCV',
            labelcz: 'Indigenous Corporation',
            labelen: 'Indigenous Corporation'
        }
    ],
    AT: [
        {
            value: '1NOX',
            labelcz: 'Sonstiger Rechtsträger',
            labelen: 'Sonstiger Rechtsträger'
        },
        { value: '5WWO', labelcz: 'Privatstiftung', labelen: 'Privatstiftung' },
        {
            value: '69H1',
            labelcz: 'Europäische Genossenschaft (SCE)',
            labelen: 'Europäische Genossenschaft (SCE)'
        },
        { value: '8XDW', labelcz: 'Genossenschaft', labelen: 'Genossenschaft' },
        {
            value: 'AAL7',
            labelcz: 'Kommandit-Erwerbsgesellschaft',
            labelen: 'Kommandit-Erwerbsgesellschaft'
        },
        {
            value: 'AXSB',
            labelcz: 'Gesellschaft mit beschränkter Haftung',
            labelen: 'Gesellschaft mit beschränkter Haftung'
        },
        {
            value: 'CAQ1',
            labelcz: 'Versicherungsverein auf Gegenseitigkeit',
            labelen: 'Versicherungsverein auf Gegenseitigkeit'
        },
        {
            value: 'DM88',
            labelcz: 'Europäische wirtschaftliche Interessenvereinigung',
            labelen: 'Europäische wirtschaftliche Interessenvereinigung'
        },
        { value: 'DX6Z', labelcz: 'Verein', labelen: 'Verein' },
        {
            value: 'E9OX',
            labelcz: 'Gemeinnützige Stiftung',
            labelen: 'Gemeinnützige Stiftung'
        },
        {
            value: 'ECWU',
            labelcz: 'Einzelunternehmer',
            labelen: 'Einzelunternehmer'
        },
        {
            value: 'EQOV',
            labelcz: 'Aktiengesellschaft',
            labelen: 'Aktiengesellschaft'
        },
        { value: 'G3R6', labelcz: 'Einzelkaufmann', labelen: 'Einzelkaufmann' },
        {
            value: 'GVPD',
            labelcz: 'Offene Handelsgesellschaft',
            labelen: 'Offene Handelsgesellschaft'
        },
        {
            value: 'JJYT',
            labelcz: 'Körperschaft öffentlichen Rechts',
            labelen: 'Körperschaft öffentlichen Rechts'
        },
        { value: 'JQOI', labelcz: 'Sparkasse', labelen: 'Sparkasse' },
        {
            value: 'JTAV',
            labelcz: 'Offene Gesellschaft',
            labelen: 'Offene Gesellschaft'
        },
        {
            value: 'JUHG',
            labelcz: 'Offene Erwerbsgesellschaft',
            labelen: 'Offene Erwerbsgesellschaft'
        },
        {
            value: 'NIJH',
            labelcz: 'Erwerbs- und Wirtschaftsgenossenschaft',
            labelen: 'Erwerbs- und Wirtschaftsgenossenschaft'
        },
        {
            value: 'NNLI',
            labelcz: 'stille Gesellschaft',
            labelen: 'stille Gesellschaft'
        },
        {
            value: 'O65B',
            labelcz: 'Europäische Gesellschaft (SE)',
            labelen: 'Europäische Gesellschaft (SE)'
        },
        {
            value: 'ONF1',
            labelcz: 'Kommanditgesellschaft',
            labelen: 'Kommanditgesellschaft'
        },
        {
            value: 'UI81',
            labelcz: 'Gesellschaft des bürgerlichen Rechts',
            labelen: 'Gesellschaft des bürgerlichen Rechts'
        }
    ],
    AZ: [
        {
            value: '52TH',
            labelcz: 'Törəmə təsərrüfat cəmiyyəti',
            labelen: 'Törəmə təsərrüfat cəmiyyəti'
        },
        {
            value: '6JHZ',
            labelcz: 'Məhdud məsuliyyətli cəmiyyəti',
            labelen: 'Məhdud məsuliyyətli cəmiyyəti'
        },
        { value: 'DWEA', labelcz: 'Kooperativlər', labelen: 'Kooperativlər' },
        {
            value: 'HKL3',
            labelcz: 'Əlavə məsuliyyətli cəmiyyət',
            labelen: 'Əlavə məsuliyyətli cəmiyyət'
        },
        {
            value: 'K81Q',
            labelcz: 'Açıq səhmdar cəmiyyəti',
            labelen: 'Açıq səhmdar cəmiyyəti'
        },
        {
            value: 'M4LU',
            labelcz: 'Qapalı səhmdar cəmiyyəti',
            labelen: 'Qapalı səhmdar cəmiyyəti'
        },
        { value: 'MEJT', labelcz: 'Tam ortaqlıq', labelen: 'Tam ortaqlıq' },
        {
            value: 'PITR',
            labelcz: 'Hüquqi şəxslərin ittifaqları',
            labelen: 'Hüquqi şəxslərin ittifaqları'
        },
        {
            value: 'SLXJ',
            labelcz: 'Asılı təsərrüfat cəmiyyəti',
            labelen: 'Asılı təsərrüfat cəmiyyəti'
        },
        {
            value: 'TD56',
            labelcz: 'Komandit ortaqlıq',
            labelen: 'Komandit ortaqlıq'
        },
        {
            value: 'U0SP',
            labelcz: 'İctimai birliklər',
            labelen: 'İctimai birliklər'
        },
        { value: 'ZD74', labelcz: 'Fondlar', labelen: 'Fondlar' }
    ],
    BS: [
        {
            value: '1W6I',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: '78QF', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: '98A8',
            labelcz: 'Company Limited by Shares',
            labelen: 'Company Limited by Shares'
        },
        {
            value: 'A9N4',
            labelcz: 'International Business Company',
            labelen: 'International Business Company'
        },
        {
            value: 'DAEG',
            labelcz: 'Unlimited Liability Company',
            labelen: 'Unlimited Liability Company'
        },
        {
            value: 'HNSU',
            labelcz: 'Public Company Limited by Shares',
            labelen: 'Public Company Limited by Shares'
        },
        {
            value: 'HP0B',
            labelcz: 'Company Limited both by Shares and by Guarantee',
            labelen: 'Company Limited both by Shares and by Guarantee'
        },
        {
            value: 'PB7W',
            labelcz: 'Company Limited by Guarantee',
            labelen: 'Company Limited by Guarantee'
        },
        {
            value: 'PICJ',
            labelcz: 'Non-Profit Company',
            labelen: 'Non-Profit Company'
        },
        {
            value: 'SQ8U',
            labelcz: 'Exempted Limited Partnership',
            labelen: 'Exempted Limited Partnership'
        },
        { value: 'VVOW', labelcz: 'Foundation', labelen: 'Foundation' },
        { value: 'XDKS', labelcz: 'Sole Proprietor', labelen: 'Sole Proprietor' }
    ],
    BY: [
        {
            value: '106J',
            labelcz: 'Zakrytae akcyyanernae tavarystva',
            labelen: 'Zakrytae akcyyanernae tavarystva'
        },
        {
            value: '9X63',
            labelcz: 'Unіtarnae pradpryemstva',
            labelen: 'Unіtarnae pradpryemstva'
        },
        {
            value: 'AABD',
            labelcz: 'Tavarystva z abmezhavanaj adkaznascyu',
            labelen: 'Tavarystva z abmezhavanaj adkaznascyu'
        },
        {
            value: 'JLR3',
            labelcz: 'Tavarystva z dadatkovaj adkaznascyu',
            labelen: 'Tavarystva z dadatkovaj adkaznascyu'
        },
        {
            value: 'MR85',
            labelcz: 'Adkrytae akcyyanernae tavarystva',
            labelen: 'Adkrytae akcyyanernae tavarystva'
        }
    ],
    BE: [
        {
            value: '1TX8',
            labelcz: 'Commanditaire vennootschap op aandelen met een sociaal oogmerk',
            labelen: 'Commanditaire vennootschap op aandelen met een sociaal oogmerk'
        },
        {
            value: '28FE',
            labelcz: 'Coöperatieve vennootschap',
            labelen: 'Coöperatieve vennootschap'
        },
        {
            value: '2QSA',
            labelcz: 'Coöperatieve vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
            labelen: 'Coöperatieve vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: '36KV',
            labelcz: 'Europese vennootschap (Societas Europaea)',
            labelen: 'Europese vennootschap (Societas Europaea)'
        },
        {
            value: '3LMA',
            labelcz: 'Buitenlandse onderneming',
            labelen: 'Buitenlandse onderneming'
        },
        {
            value: '3N94',
            labelcz: 'Onderneming-natuurlijk persoon',
            labelen: 'Onderneming-natuurlijk persoon'
        },
        {
            value: '3W7E',
            labelcz: 'Besloten Vennootschap',
            labelen: 'Besloten Vennootschap'
        },
        {
            value: '4E5P',
            labelcz: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid met een sociaal oogmerk',
            labelen: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: '7SJP',
            labelcz: 'Europees economisch samenwerkingsverband',
            labelen: 'Europees economisch samenwerkingsverband'
        },
        {
            value: '8E2A',
            labelcz: 'Coöperatieve vennootschap met beperkte aansprakelijkheid',
            labelen: 'Coöperatieve vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: '8YLB',
            labelcz: 'Instelling zonder winstoogmerk',
            labelen: 'Instelling zonder winstoogmerk'
        },
        {
            value: 'B910',
            labelcz: 'Vennootschap onder firma met een sociaal oogmerk',
            labelen: 'Vennootschap onder firma met een sociaal oogmerk'
        },
        {
            value: 'C609',
            labelcz: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid',
            labelen: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'CFH5',
            labelcz: 'Vennootschap of vereniging zonder rechtspersoonlijkheid',
            labelen: 'Vennootschap of vereniging zonder rechtspersoonlijkheid'
        },
        {
            value: 'EDMK',
            labelcz: 'Vereniging zonder winstoogmerk van publiek recht',
            labelen: 'Vereniging zonder winstoogmerk van publiek recht'
        },
        {
            value: 'EXY8',
            labelcz:
                'Coöperatieve vennootschap met onbeperkte aansprakelijkheid, bij wijze van deelneming van publiek recht',
            labelen:
                'Coöperatieve vennootschap met onbeperkte aansprakelijkheid, bij wijze van deelneming van publiek recht'
        },
        {
            value: 'J5OU',
            labelcz: 'Economisch samenwerkingsverband',
            labelen: 'Economisch samenwerkingsverband'
        },
        {
            value: 'JAM3',
            labelcz: 'Coöperatieve vennootschap van publiek recht',
            labelen: 'Coöperatieve vennootschap van publiek recht'
        },
        {
            value: 'JNAD',
            labelcz: 'Besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
            labelen: 'Besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: 'KLBO',
            labelcz: 'Burgerlijke vennootschap onder vorm van commanditaire vennootschap op aandelen',
            labelen: 'Burgerlijke vennootschap onder vorm van commanditaire vennootschap op aandelen'
        },
        { value: 'KM6O', labelcz: 'Maatschap', labelen: 'Maatschap' },
        {
            value: 'L05H',
            labelcz: 'Besloten Vennootschap van publiek recht',
            labelen: 'Besloten Vennootschap van publiek recht'
        },
        {
            value: 'LWHF',
            labelcz: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid',
            labelen: 'Coöperatieve vennootschap met onbeperkte aansprakelijkheid'
        },
        {
            value: 'LWV6',
            labelcz: 'Gewone commanditaire vennootschap',
            labelen: 'Gewone commanditaire vennootschap'
        },
        {
            value: 'MQH3',
            labelcz: 'Commanditaire vennootschap',
            labelen: 'Commanditaire vennootschap'
        },
        {
            value: 'N5NT',
            labelcz: 'Besloten vennootschap met beperkte aansprakelijkheid',
            labelen: 'Besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'O59C',
            labelcz: 'Economisch samenwerkingsverband met een sociaal oogmerk',
            labelen: 'Economisch samenwerkingsverband met een sociaal oogmerk'
        },
        {
            value: 'O5HQ',
            labelcz: 'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met beperkte aansprakelijkheid',
            labelen: 'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'PVT3',
            labelcz: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk',
            labelen: 'Eenpersoons besloten vennootschap met beperkte aansprakelijkheid met een sociaal oogmerk'
        },
        {
            value: 'QZIS',
            labelcz: 'Openbare instelling',
            labelen: 'Openbare instelling'
        },
        {
            value: 'R85P',
            labelcz: 'Naamloze vennootschap',
            labelen: 'Naamloze vennootschap'
        },
        {
            value: 'T922',
            labelcz: 'Burgerlijke vennootschap onder vorm van gewone commanditaire vennootschap',
            labelen: 'Burgerlijke vennootschap onder vorm van gewone commanditaire vennootschap'
        },
        {
            value: 'TPTU',
            labelcz: 'Naamloze vennootschap van publiek recht',
            labelen: 'Naamloze vennootschap van publiek recht'
        },
        {
            value: 'U2PN',
            labelcz: 'Commanditaire vennootschap op aandelen',
            labelen: 'Commanditaire vennootschap op aandelen'
        },
        {
            value: 'U5KF',
            labelcz: 'Burgerlijke vennootschap onder vorm van vennootschap onder firma',
            labelen: 'Burgerlijke vennootschap onder vorm van vennootschap onder firma'
        },
        {
            value: 'UCT9',
            labelcz: 'Burgerlijke Vennootschap onder vorm van Landbouwvennootschap (BV LV)',
            labelen: 'Burgerlijke Vennootschap onder vorm van Landbouwvennootschap (BV LV)'
        },
        {
            value: 'UW1Y',
            labelcz: 'Vennootschap onder firma',
            labelen: 'Vennootschap onder firma'
        },
        {
            value: 'V03J',
            labelcz: 'Internationale vereniging zonder winstoogmerk',
            labelen: 'Internationale vereniging zonder winstoogmerk'
        },
        {
            value: 'V7FT',
            labelcz: 'Naamloze vennootschap met een sociaal oogmerk',
            labelen: 'Naamloze vennootschap met een sociaal oogmerk'
        },
        {
            value: 'V8L7',
            labelcz: 'Burgerlijke vennootschap onder vorm van besloten vennootschap met beperkte aansprakelijkheid',
            labelen: 'Burgerlijke vennootschap onder vorm van besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: 'W3WH',
            labelcz: 'Vereniging zonder winstoogmerk',
            labelen: 'Vereniging zonder winstoogmerk'
        },
        {
            value: 'WTLP',
            labelcz:
                'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met onbeperkte aansprakelijkheid',
            labelen:
                'Burgerlijke vennootschap onder vorm van coöperatieve vennootschap met onbeperkte aansprakelijkheid'
        },
        {
            value: 'X8ZK',
            labelcz: 'Coöperatieve vennootschap met beperkte aansprakelijkheid van publiek recht',
            labelen: 'Coöperatieve vennootschap met beperkte aansprakelijkheid van publiek recht'
        },
        {
            value: 'XLEO',
            labelcz: 'Gewone commanditaire vennootschap met een sociaal oogmerk',
            labelen: 'Gewone commanditaire vennootschap met een sociaal oogmerk'
        },
        {
            value: 'XQZX',
            labelcz: 'Burgerlijke vennootschap onder vorm van naamloze vennootschap',
            labelen: 'Burgerlijke vennootschap onder vorm van naamloze vennootschap'
        },
        {
            value: 'Y1Q4',
            labelcz: 'Private stichting',
            labelen: 'Private stichting'
        },
        {
            value: 'YBHM',
            labelcz: 'Europese Coöperatieve Vennootschap',
            labelen: 'Europese Coöperatieve Vennootschap'
        },
        {
            value: 'ZOK2',
            labelcz: 'Landbouwvennootschap',
            labelen: 'Landbouwvennootschap'
        },
        {
            value: 'ZSFX',
            labelcz: 'Naamloze vennootschap met een sociaal oogmerk',
            labelen: 'Naamloze vennootschap met een sociaal oogmerk'
        },
        {
            value: 'ZUHK',
            labelcz: 'Stichting van openbaar nut',
            labelen: 'Stichting van openbaar nut'
        }
    ],
    BZ: [
        {
            value: '84DD',
            labelcz: 'International Business Company',
            labelen: 'International Business Company'
        },
        {
            value: 'AO0O',
            labelcz: 'Unlimited Company',
            labelen: 'Unlimited Company'
        },
        { value: 'D1SL', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: 'EAD0',
            labelcz: 'Company Limited by Shares',
            labelen: 'Company Limited by Shares'
        },
        { value: 'GJKF', labelcz: 'Association', labelen: 'Association' },
        {
            value: 'ZHT0',
            labelcz: 'Company Limited by Guarantee',
            labelen: 'Company Limited by Guarantee'
        }
    ],
    BM: [
        {
            value: '7AS7',
            labelcz: 'Exempted Companies Limited by Shares',
            labelen: 'Exempted Companies Limited by Shares'
        },
        { value: '7HCE', labelcz: 'Exempted LLC', labelen: 'Exempted LLC' },
        {
            value: '7MGJ',
            labelcz: 'Exempted Limited Partnership',
            labelen: 'Exempted Limited Partnership'
        },
        {
            value: '9TCY',
            labelcz: 'Mutual Company (Part XII)',
            labelen: 'Mutual Company (Part XII)'
        },
        {
            value: 'ASR5',
            labelcz: 'Exempted Partnership',
            labelen: 'Exempted Partnership'
        },
        {
            value: 'CW38',
            labelcz: 'Local Company Limited by Guarantee',
            labelen: 'Local Company Limited by Guarantee'
        },
        {
            value: 'EURM',
            labelcz: 'Local Unlimited Company',
            labelen: 'Local Unlimited Company'
        },
        {
            value: 'LC2L',
            labelcz: 'Exempted Company Limited by Guarantee',
            labelen: 'Exempted Company Limited by Guarantee'
        },
        {
            value: 'MBVS',
            labelcz: 'Exempted Unlimited Company',
            labelen: 'Exempted Unlimited Company'
        },
        {
            value: 'NAQG',
            labelcz: 'Local Company Limited by Shares',
            labelen: 'Local Company Limited by Shares'
        },
        { value: 'UZWE', labelcz: 'Local LLC', labelen: 'Local LLC' },
        {
            value: 'VFXJ',
            labelcz: 'Mutual Fund Company',
            labelen: 'Mutual Fund Company'
        },
        {
            value: 'WF3Q',
            labelcz: 'Permit (Overseas) Company',
            labelen: 'Permit (Overseas) Company'
        },
        {
            value: 'ZLTD',
            labelcz: 'Overseas (Permit) Partnership',
            labelen: 'Overseas (Permit) Partnership'
        }
    ],
    BO: [
        {
            value: '38JQ',
            labelcz: 'Empresa Unipersonal',
            labelen: 'Empresa Unipersonal'
        },
        { value: '5T3W', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' },
        { value: '70BS', labelcz: 'Empresa Estatal ', labelen: 'Empresa Estatal ' },
        {
            value: 'DSML',
            labelcz: 'Institución Financiera De Desarrollo   ',
            labelen: 'Institución Financiera De Desarrollo   '
        },
        {
            value: 'JYAN',
            labelcz: 'Empresa Estatal Intergubernamental     ',
            labelen: 'Empresa Estatal Intergubernamental     '
        },
        {
            value: 'LJYQ',
            labelcz: 'Sociedad Anónima Mixta                 ',
            labelen: 'Sociedad Anónima Mixta                 '
        },
        {
            value: 'LN9O',
            labelcz: 'Entidad Financiera De Vivienda',
            labelen: 'Entidad Financiera De Vivienda'
        },
        {
            value: 'MGOU',
            labelcz: 'Empresa Mixta                         ',
            labelen: 'Empresa Mixta                         '
        },
        {
            value: 'PJ29',
            labelcz: 'Sociedad en Comandita por Acciones. ',
            labelen: 'Sociedad en Comandita por Acciones. '
        },
        {
            value: 'PM48',
            labelcz: 'Sociedad de Responsabilidad Limitada.',
            labelen: 'Sociedad de Responsabilidad Limitada.'
        },
        {
            value: 'RXJN',
            labelcz: 'Empresa Estatal Mixta                  ',
            labelen: 'Empresa Estatal Mixta                  '
        },
        {
            value: 'TNHO',
            labelcz: 'Sociedad Colectiva',
            labelen: 'Sociedad Colectiva'
        },
        {
            value: 'XTCQ',
            labelcz: 'Sociedad en Comandita Simple.',
            labelen: 'Sociedad en Comandita Simple.'
        }
    ],
    BQ: [
        {
            value: '1A0A',
            labelcz: 'Besloten vennootschap',
            labelen: 'Besloten vennootschap'
        },
        {
            value: '3Y5C',
            labelcz: 'Besloten vennootschap naar Nederlands recht',
            labelen: 'Besloten vennootschap naar Nederlands recht'
        },
        {
            value: '4S4Z',
            labelcz: 'Commanditaire vennootschap met meerdere beherende vennoten',
            labelen: 'Commanditaire vennootschap met meerdere beherende vennoten'
        },
        { value: '4ZBE', labelcz: 'Maatschap', labelen: 'Maatschap' },
        {
            value: '51WZ',
            labelcz: 'Vereniging met beperkte rechtsbevoegdheid',
            labelen: 'Vereniging met beperkte rechtsbevoegdheid'
        },
        {
            value: '56MU',
            labelcz: 'Aandeelhouder bestuurde Besloten vennootschap',
            labelen: 'Aandeelhouder bestuurde Besloten vennootschap'
        },
        { value: '92JZ', labelcz: 'Stichting', labelen: 'Stichting' },
        {
            value: 'AS4W',
            labelcz: 'Stichting particulier fonds',
            labelen: 'Stichting particulier fonds'
        },
        {
            value: 'B2UK',
            labelcz: 'Nevenvestiging met hoofdvestiging buiten bonaire',
            labelen: 'Nevenvestiging met hoofdvestiging buiten bonaire'
        },
        {
            value: 'DQMJ',
            labelcz: 'Naamloze vennootschap',
            labelen: 'Naamloze vennootschap'
        },
        {
            value: 'FCPM',
            labelcz: 'Vereniging met volledige rechtsbevoegdheid',
            labelen: 'Vereniging met volledige rechtsbevoegdheid'
        },
        {
            value: 'IPTQ',
            labelcz: 'Eenmanszaak met meerdere eigenaren',
            labelen: 'Eenmanszaak met meerdere eigenaren'
        },
        {
            value: 'JFQ5',
            labelcz: 'Buitenlandse rechtsvorm hoofdvestiging op Bonaire',
            labelen: 'Buitenlandse rechtsvorm hoofdvestiging op Bonaire'
        },
        {
            value: 'KSHL',
            labelcz: 'Commanditaire vennootschap op aandelen',
            labelen: 'Commanditaire vennootschap op aandelen'
        },
        { value: 'NPFB', labelcz: 'Eenmanszaak', labelen: 'Eenmanszaak' },
        {
            value: 'SNRI',
            labelcz: 'Vennootschap onder Firma',
            labelen: 'Vennootschap onder Firma'
        },
        { value: 'VHIY', labelcz: 'Cooperatie', labelen: 'Cooperatie' },
        {
            value: 'X088',
            labelcz: 'Vereniging zonder rechtsbevoegdheid',
            labelen: 'Vereniging zonder rechtsbevoegdheid'
        },
        {
            value: 'XL51',
            labelcz: 'Commanditaire vennootschap met één beherend vennoot',
            labelen: 'Commanditaire vennootschap met één beherend vennoot'
        }
    ],
    BW: [
        { value: '4IXL', labelcz: 'Close Companies ', labelen: 'Close Companies ' },
        {
            value: '771I',
            labelcz: 'Private Limited Liability Companies',
            labelen: 'Private Limited Liability Companies'
        },
        {
            value: 'QK1F',
            labelcz: 'Public Limited Liability Companies',
            labelen: 'Public Limited Liability Companies'
        },
        {
            value: 'Y2L3',
            labelcz: 'Companies limited by Guarantee',
            labelen: 'Companies limited by Guarantee'
        }
    ],
    BR: [
        { value: '4LKN', labelcz: 'Empresa Pública', labelen: 'Empresa Pública' },
        {
            value: '529B',
            labelcz: 'Sociedade em Nome Coletivo',
            labelen: 'Sociedade em Nome Coletivo'
        },
        {
            value: '8GEA',
            labelcz: 'Sociedade Simples',
            labelen: 'Sociedade Simples'
        },
        {
            value: '9BIS',
            labelcz: 'Organização Religiosa',
            labelen: 'Organização Religiosa'
        },
        { value: 'ANHM', labelcz: 'Partido Político', labelen: 'Partido Político' },
        { value: 'I4T1', labelcz: 'Fundação', labelen: 'Fundação' },
        { value: 'J7G9', labelcz: 'Associação', labelen: 'Associação' },
        {
            value: 'OB5J',
            labelcz: 'Empresa Individual de Responsabilidade Limitada',
            labelen: 'Empresa Individual de Responsabilidade Limitada'
        },
        {
            value: 'PC5A',
            labelcz: 'Sociedade Cooperativa',
            labelen: 'Sociedade Cooperativa'
        },
        {
            value: 'QHW1',
            labelcz: 'Sociedade Limitada',
            labelen: 'Sociedade Limitada'
        },
        {
            value: 'WBEC',
            labelcz: 'Sociedade em Comdandita Simples',
            labelen: 'Sociedade em Comdandita Simples'
        },
        {
            value: 'X0SD',
            labelcz: 'Sociedade Anônima',
            labelen: 'Sociedade Anônima'
        },
        {
            value: 'X2ZT',
            labelcz: 'Sociedade em Comandita por Ações',
            labelen: 'Sociedade em Comandita por Ações'
        },
        {
            value: 'XQRI',
            labelcz: 'Sociedade em Conta de Participação',
            labelen: 'Sociedade em Conta de Participação'
        }
    ],
    BN: [
        { value: '2DGO', labelcz: 'Public Company', labelen: 'Public Company' },
        {
            value: 'EULU',
            labelcz: 'Private Limited Company',
            labelen: 'Private Limited Company'
        }
    ],
    BG: [
        {
            value: '3FUP',
            labelcz: 'Evropeysko kooperativno druzhestvo s ogranichena otgovornost',
            labelen: 'Evropeysko kooperativno druzhestvo s ogranichena otgovornost'
        },
        {
            value: '3HLJ',
            labelcz: 'Podelenie na evropeysko obedinenie po ikonomicheski interesi',
            labelen: 'Podelenie na evropeysko obedinenie po ikonomicheski interesi'
        },
        {
            value: '3SHX',
            labelcz: 'Sdruzhenie v obshtestvena polza',
            labelen: 'Sdruzhenie v obshtestvena polza'
        },
        {
            value: '45D7',
            labelcz: 'Klon na chuzhdestranen targovets',
            labelen: 'Klon na chuzhdestranen targovets'
        },
        {
            value: '946C',
            labelcz: 'Ednolichen targovets',
            labelen: 'Ednolichen targovets'
        },
        {
            value: '9F78',
            labelcz: 'Chuzhdestranno druzhestvo - fizichesko litse',
            labelen: 'Chuzhdestranno druzhestvo - fizichesko litse'
        },
        { value: 'CTCH', labelcz: 'Kooperatsia', labelen: 'Kooperatsia' },
        {
            value: 'EJ06',
            labelcz: 'Ednolichno aktsionerno druzhestvo',
            labelen: 'Ednolichno aktsionerno druzhestvo'
        },
        {
            value: 'FPP2',
            labelcz: 'Sabiratelno druzhestvo (SD)/Sadruzhie',
            labelen: 'Sabiratelno druzhestvo (SD)/Sadruzhie'
        },
        {
            value: 'HN63',
            labelcz: 'Komanditno druzhestvo s aktsii',
            labelen: 'Komanditno druzhestvo s aktsii'
        },
        {
            value: 'LECS',
            labelcz: 'Sdruzhenie v chastna polza',
            labelen: 'Sdruzhenie v chastna polza'
        },
        {
            value: 'O15N',
            labelcz: 'Chuzhdestranno druzhestvo - yuridichesko litse',
            labelen: 'Chuzhdestranno druzhestvo - yuridichesko litse'
        },
        {
            value: 'PW3Y',
            labelcz: 'Aktsionerno druzhestvo sas spetsialna investitsionna tsel',
            labelen: 'Aktsionerno druzhestvo sas spetsialna investitsionna tsel'
        },
        {
            value: 'QZAU',
            labelcz: 'Ednolichno aktsionerno druzhestvo sas spetsialna investitsionna tsel',
            labelen: 'Ednolichno aktsionerno druzhestvo sas spetsialna investitsionna tsel'
        },
        {
            value: 'RYDY',
            labelcz: 'Evropeysko obedinenie po ikonomicheski interesi',
            labelen: 'Evropeysko obedinenie po ikonomicheski interesi'
        },
        {
            value: 'S94S',
            labelcz: 'Komanditno druzhestvo',
            labelen: 'Komanditno druzhestvo'
        },
        {
            value: 'SZW0',
            labelcz: 'Evropeysko druzhestvo',
            labelen: 'Evropeysko druzhestvo'
        },
        {
            value: 'TCGV',
            labelcz: 'Druzhestvo uchredeno po Zakona za zadalzheniyata i dogovorite',
            labelen: 'Druzhestvo uchredeno po Zakona za zadalzheniyata i dogovorite'
        },
        {
            value: 'U8LM',
            labelcz: 'Evropeysko kooperativno druzhestvo',
            labelen: 'Evropeysko kooperativno druzhestvo'
        },
        { value: 'UFG8', labelcz: 'Fondatsia', labelen: 'Fondatsia' },
        {
            value: 'VJ3G',
            labelcz: 'Druzhestvo s ogranichena otgovornost',
            labelen: 'Druzhestvo s ogranichena otgovornost'
        },
        {
            value: 'WTK4',
            labelcz: 'Aktsionerno druzhestvo',
            labelen: 'Aktsionerno druzhestvo'
        },
        {
            value: 'WVIN',
            labelcz: 'Ednolichno druzhestvo s ogranichena otgovornost',
            labelen: 'Ednolichno druzhestvo s ogranichena otgovornost'
        }
    ],
    KH: [
        {
            value: '15BP',
            labelcz: 'Private Limited Company',
            labelen: 'Private Limited Company'
        },
        {
            value: 'BQ0P',
            labelcz: 'Public Limited Company',
            labelen: 'Public Limited Company'
        },
        {
            value: 'D3UY',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'KD84',
            labelcz: 'Sole Proprietorship',
            labelen: 'Sole Proprietorship'
        },
        {
            value: 'Z4YC',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        { value: 'ZCFU', labelcz: 'Foreign Company', labelen: 'Foreign Company' }
    ],
    CA: [
        {
            value: '1EQC',
            labelcz: 'trade name/sole proprietorship',
            labelen: 'trade name/sole proprietorship'
        },
        {
            value: '60MF',
            labelcz: 'Alberta trust corporation',
            labelen: 'Alberta trust corporation'
        },
        {
            value: '8ZH8',
            labelcz: 'Alberta Business Corporation',
            labelen: 'Alberta Business Corporation'
        },
        {
            value: '94UQ',
            labelcz: 'public recreation company',
            labelen: 'public recreation company'
        },
        {
            value: 'B69V',
            labelcz: 'Alberta private non-profit company',
            labelen: 'Alberta private non-profit company'
        },
        {
            value: 'BASA',
            labelcz: 'Alberta cooperative',
            labelen: 'Alberta cooperative'
        },
        {
            value: 'BH5D',
            labelcz: 'rural utility cooperative',
            labelen: 'rural utility cooperative'
        },
        {
            value: 'C9KZ',
            labelcz: 'Alberta professional corporation',
            labelen: 'Alberta professional corporation'
        },
        {
            value: 'DK7L',
            labelcz: 'Alberta loan corporation',
            labelen: 'Alberta loan corporation'
        },
        {
            value: 'G65S',
            labelcz: 'Alberta credit union',
            labelen: 'Alberta credit union'
        },
        {
            value: 'J3C5',
            labelcz: 'Alberta unlimited liability corporation',
            labelen: 'Alberta unlimited liability corporation'
        },
        { value: 'K1QX', labelcz: 'Alberta society', labelen: 'Alberta society' },
        {
            value: 'KVC1',
            labelcz: 'general partnership',
            labelen: 'general partnership'
        },
        {
            value: 'PXPK',
            labelcz: 'private recreation company',
            labelen: 'private recreation company'
        },
        {
            value: 'R0KX',
            labelcz: 'private act corporation',
            labelen: 'private act corporation'
        },
        {
            value: 'RHVP',
            labelcz: 'private act non-profit corp',
            labelen: 'private act non-profit corp'
        },
        {
            value: 'RN4K',
            labelcz: 'Alberta limited partnership',
            labelen: 'Alberta limited partnership'
        },
        {
            value: 'TRO6',
            labelcz: 'agricultural society',
            labelen: 'agricultural society'
        },
        {
            value: 'TS9O',
            labelcz: 'religious society',
            labelen: 'religious society'
        },
        {
            value: 'U938',
            labelcz: 'Alberta limited liability partnership',
            labelen: 'Alberta limited liability partnership'
        },
        {
            value: 'VHXN',
            labelcz: 'public non-profit company',
            labelen: 'public non-profit company'
        },
        {
            value: '1CML',
            labelcz: 'Sole proprietorship',
            labelen: 'Sole proprietorship'
        },
        {
            value: '23V9',
            labelcz: 'Limited partnership',
            labelen: 'Limited partnership'
        },
        {
            value: 'AW80',
            labelcz: 'Association (includes housing cooperative and community service cooperative)',
            labelen: 'Association (includes housing cooperative and community service cooperative)'
        },
        {
            value: 'F9J3',
            labelcz: 'Limited partnership formed outside of BC',
            labelen: 'Limited partnership formed outside of BC'
        },
        {
            value: 'HLBQ',
            labelcz: 'Pension fund society',
            labelen: 'Pension fund society'
        },
        {
            value: 'LNBY',
            labelcz: 'Limited liability partnership',
            labelen: 'Limited liability partnership'
        },
        {
            value: 'LRRN',
            labelcz: 'Mutual fire insurance company',
            labelen: 'Mutual fire insurance company'
        },
        {
            value: 'O13B',
            labelcz: 'General partnership',
            labelen: 'General partnership'
        },
        {
            value: 'OTU7',
            labelcz: 'Extraprovincial non-share corporation',
            labelen: 'Extraprovincial non-share corporation'
        },
        {
            value: 'QODJ',
            labelcz: 'Extraprovincial limited liability partnership',
            labelen: 'Extraprovincial limited liability partnership'
        },
        {
            value: 'S3K4',
            labelcz: 'Registered extraprovincial non-share corporation',
            labelen: 'Registered extraprovincial non-share corporation'
        },
        {
            value: 'TGLV',
            labelcz: 'Extraprovincial corporation (registered foreign entity)',
            labelen: 'Extraprovincial corporation (registered foreign entity)'
        },
        {
            value: 'WFPH',
            labelcz: 'Society (includes member-funded society)',
            labelen: 'Society (includes member-funded society)'
        },
        { value: 'XOYI', labelcz: 'Credit union', labelen: 'Credit union' },
        {
            value: 'YG5M',
            labelcz: 'Company (includes community contribution company and unlimited liability company)',
            labelen: 'Company (includes community contribution company and unlimited liability company)'
        },
        { value: '59T2', labelcz: 'board of trade', labelen: 'board of trade' },
        {
            value: '6TRA',
            labelcz: 'corporations enacted by an Act of Parliament',
            labelen: 'corporations enacted by an Act of Parliament'
        },
        {
            value: 'D90J',
            labelcz: 'corporation without share capital',
            labelen: 'corporation without share capital'
        },
        {
            value: 'M4IF',
            labelcz: 'pension fund society',
            labelen: 'pension fund society'
        },
        { value: 'MGE0', labelcz: 'cooperative', labelen: 'cooperative' },
        {
            value: 'UDLA',
            labelcz: 'business corporation',
            labelen: 'business corporation'
        },
        {
            value: '5ONY',
            labelcz: 'Religious Society',
            labelen: 'Religious Society'
        },
        {
            value: '9D1K',
            labelcz: 'non-share corporations',
            labelen: 'non-share corporations'
        },
        {
            value: 'FN6X',
            labelcz: 'Share corporations (including professional corporations)',
            labelen: 'Share corporations (including professional corporations)'
        },
        {
            value: 'G9PJ',
            labelcz: 'Limited Liability Partnership (Manitoba and Extra-provincial, lawyers and accountants only)',
            labelen: 'Limited Liability Partnership (Manitoba and Extra-provincial, lawyers and accountants only)'
        },
        { value: 'GM04', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: 'HBCT',
            labelcz: 'Ukrainian Catholic Parish',
            labelen: 'Ukrainian Catholic Parish'
        },
        {
            value: 'LV28',
            labelcz: 'Condominium Corporation',
            labelen: 'Condominium Corporation'
        },
        {
            value: 'MXLT',
            labelcz: 'Sole Proprietorship',
            labelen: 'Sole Proprietorship'
        },
        {
            value: 'OPRT',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: 'RBBY', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: 'SS1V',
            labelcz: 'registration of extra-provincial corporations',
            labelen: 'registration of extra-provincial corporations'
        },
        {
            value: 'Y485',
            labelcz: 'Credit union or Caisse Populaire',
            labelen: 'Credit union or Caisse Populaire'
        },
        { value: '3Q15', labelcz: 'partnership', labelen: 'partnership' },
        {
            value: '40JO',
            labelcz: 'société en commandite',
            labelen: 'société en commandite'
        },
        {
            value: '44LR',
            labelcz: 'corporation professionnelle',
            labelen: 'corporation professionnelle'
        },
        {
            value: '4M62',
            labelcz: 'compagnie de prêt',
            labelen: 'compagnie de prêt'
        },
        {
            value: '56KZ',
            labelcz: 'agricultural fair association',
            labelen: 'agricultural fair association'
        },
        {
            value: '64XG',
            labelcz: 'association coopérative',
            labelen: 'association coopérative'
        },
        {
            value: '6U2Q',
            labelcz: 'condominium corporation',
            labelen: 'condominium corporation'
        },
        {
            value: '7P8Y',
            labelcz: 'limited partnership',
            labelen: 'limited partnership'
        },
        {
            value: '8MEC',
            labelcz: 'société à responsabilité limitée du Nouveau-Brunswick',
            labelen: 'société à responsabilité limitée du Nouveau-Brunswick'
        },
        {
            value: 'AXW3',
            labelcz: 'selon la loi de la Législature',
            labelen: 'selon la loi de la Législature'
        },
        { value: 'B3RX', labelcz: 'corporation', labelen: 'corporation' },
        {
            value: 'D8UQ',
            labelcz: 'professional corporation',
            labelen: 'professional corporation'
        },
        { value: 'DHGI', labelcz: 'project company', labelen: 'project company' },
        { value: 'EKRT', labelcz: 'loan company', labelen: 'loan company' },
        {
            value: 'EPFN',
            labelcz: 'New Brunswick limited liability partnership',
            labelen: 'New Brunswick limited liability partnership'
        },
        {
            value: 'FGSL',
            labelcz: 'association condominiale',
            labelen: 'association condominiale'
        },
        {
            value: 'GF6X',
            labelcz: 'business name - sole proprietor',
            labelen: 'business name - sole proprietor'
        },
        {
            value: 'GLX2',
            labelcz: 'agricultural society',
            labelen: 'agricultural society'
        },
        { value: 'GPG0', labelcz: 'compagnie', labelen: 'compagnie' },
        {
            value: 'IDBS',
            labelcz: 'compagnie de fiducie',
            labelen: 'compagnie de fiducie'
        },
        {
            value: 'IKMB',
            labelcz: 'co-operative association',
            labelen: 'co-operative association'
        },
        {
            value: 'IKSU',
            labelcz: 'société en nom collectif',
            labelen: 'société en nom collectif'
        },
        { value: 'ILON', labelcz: 'caisse populaire', labelen: 'caisse populaire' },
        { value: 'JBBW', labelcz: 'company', labelen: 'company' },
        {
            value: 'M53U',
            labelcz: 'depends on Act of the Legislature',
            labelen: 'depends on Act of the Legislature'
        },
        { value: 'MY4W', labelcz: 'credit union', labelen: 'credit union' },
        { value: 'NONB', labelcz: 'corporation', labelen: 'corporation' },
        { value: 'QJ3A', labelcz: 'gérant de projet', labelen: 'gérant de projet' },
        {
            value: 'QNSC',
            labelcz: 'personne morale étrangère résidante',
            labelen: 'personne morale étrangère résidante'
        },
        {
            value: 'TSQ7',
            labelcz: 'association de foires agricoles',
            labelen: 'association de foires agricoles'
        },
        { value: 'WI0P', labelcz: 'société agricole', labelen: 'société agricole' },
        { value: 'ZACY', labelcz: 'trust company', labelen: 'trust company' },
        {
            value: 'ZY4E',
            labelcz: 'appellation commerciale - propriétaire unique',
            labelen: 'appellation commerciale - propriétaire unique'
        },
        {
            value: '1E9M',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: '3Y5V', labelcz: 'co-operatives', labelen: 'co-operatives' },
        {
            value: 'ASWX',
            labelcz: 'share corporations',
            labelen: 'share corporations'
        },
        { value: 'EBYQ', labelcz: 'Credit Union', labelen: 'Credit Union' },
        {
            value: 'ER0H',
            labelcz: 'registration of extra-provincial corporations',
            labelen: 'registration of extra-provincial corporations'
        },
        {
            value: 'GTBR',
            labelcz: 'Condominium Corporation',
            labelen: 'Condominium Corporation'
        },
        {
            value: 'IKGM',
            labelcz: 'non-share corporations',
            labelen: 'non-share corporations'
        },
        {
            value: 'SYPT',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '1ADH',
            labelcz: 'Extra-Territorial Corporation(for profit and not-for-profit)',
            labelen: 'Extra-Territorial Corporation(for profit and not-for-profit)'
        },
        {
            value: '85EC',
            labelcz: 'Limited Liability partnership',
            labelen: 'Limited Liability partnership'
        },
        { value: 'CS15', labelcz: 'NT society', labelen: 'NT society' },
        { value: 'KAM9', labelcz: 'co-operative', labelen: 'co-operative' },
        { value: 'PIDT', labelcz: 'NT corporation', labelen: 'NT corporation' },
        {
            value: 'QN8Y',
            labelcz: 'NT Professional Corporation authorized under the Professional Corporations Act',
            labelen: 'NT Professional Corporation authorized under the Professional Corporations Act'
        },
        {
            value: 'QR4F',
            labelcz: 'business name/sole proprietorship',
            labelen: 'business name/sole proprietorship'
        },
        {
            value: 'TA98',
            labelcz: 'Limited partnership',
            labelen: 'Limited partnership'
        },
        {
            value: 'TPZ2',
            labelcz: 'private act corporation',
            labelen: 'private act corporation'
        },
        {
            value: 'VAPN',
            labelcz: 'general partnership',
            labelen: 'general partnership'
        },
        {
            value: 'W126',
            labelcz: 'private act not-for-profit corporation',
            labelen: 'private act not-for-profit corporation'
        },
        { value: '2FHC', labelcz: 'partnerships', labelen: 'partnerships' },
        {
            value: '3M14',
            labelcz:
                'A company formed under the Companies Act may seek designation as a Community Interest Company (a hybrid structure having characteristics of both for profit and non-profit entities)',
            labelen:
                'A company formed under the Companies Act may seek designation as a Community Interest Company (a hybrid structure having characteristics of both for profit and non-profit entities)'
        },
        {
            value: '42GN',
            labelcz: 'unlimited company',
            labelen: 'unlimited company'
        },
        { value: '876U', labelcz: 'Credit Unions', labelen: 'Credit Unions' },
        { value: '8M03', labelcz: 'Condominiums', labelen: 'Condominiums' },
        {
            value: '8OZ0',
            labelcz: 'limited liability partnerships',
            labelen: 'limited liability partnerships'
        },
        { value: '9XHE', labelcz: 'business names', labelen: 'business names' },
        {
            value: 'FQJ9',
            labelcz: 'for profit and not-for profit co-operatives',
            labelen: 'for profit and not-for profit co-operatives'
        },
        {
            value: 'GG0S',
            labelcz: 'company limited by guarantee',
            labelen: 'company limited by guarantee'
        },
        {
            value: 'T0CV',
            labelcz: 'limited partnerships formed in NS',
            labelen: 'limited partnerships formed in NS'
        },
        {
            value: 'TY0S',
            labelcz:
                'A company formed under the Companies Act may seek designation as a Private Investment Holding Company',
            labelen:
                'A company formed under the Companies Act may seek designation as a Private Investment Holding Company'
        },
        {
            value: 'ULJ1',
            labelcz: 'company limited by shares (limited company)',
            labelen: 'company limited by shares (limited company)'
        },
        { value: 'W8XG', labelcz: 'sole proprietors', labelen: 'sole proprietors' },
        {
            value: 'Y80K',
            labelcz: 'Non-profit Corporations',
            labelen: 'Non-profit Corporations'
        },
        {
            value: '1JGX',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '456Q',
            labelcz: 'business name/sole proprietorship',
            labelen: 'business name/sole proprietorship'
        },
        {
            value: '7VKC',
            labelcz: 'Condominium Corporation',
            labelen: 'Condominium Corporation'
        },
        {
            value: 'BOYK',
            labelcz: 'Corporations formed by an Act of the Ontario Legislative Assembly',
            labelen: 'Corporations formed by an Act of the Ontario Legislative Assembly'
        },
        {
            value: 'CMB6',
            labelcz: 'Not-For-Profit corporations',
            labelen: 'Not-For-Profit corporations'
        },
        {
            value: 'EIDL',
            labelcz: 'Insurance Corporations incorporated under Part V of the Corporations Act',
            labelen: 'Insurance Corporations incorporated under Part V of the Corporations Act'
        },
        { value: 'ESVK', labelcz: 'Credit Union', labelen: 'Credit Union' },
        {
            value: 'FBQL',
            labelcz: 'Co-operative Corporation',
            labelen: 'Co-operative Corporation'
        },
        {
            value: 'HQKE',
            labelcz: 'general partnership',
            labelen: 'general partnership'
        },
        {
            value: 'O90R',
            labelcz: 'Business corporations (which includes professional corporations)',
            labelen: 'Business corporations (which includes professional corporations)'
        },
        {
            value: 'PCO0',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '10UR',
            labelcz: 'Syndicat coopératif',
            labelen: 'Syndicat coopératif'
        },
        {
            value: '16GH',
            labelcz: 'Personne morale sans but lucratif par Loi sur les cercles agricoles',
            labelen: 'Personne morale sans but lucratif par Loi sur les cercles agricoles'
        },
        {
            value: '16RL',
            labelcz: 'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles',
            labelen: 'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles'
        },
        {
            value: '1VTA',
            labelcz: 'Personne morale sans but lucratif par Loi sur les évêques catholiques romains',
            labelen: 'Personne morale sans but lucratif par Loi sur les évêques catholiques romains'
        },
        {
            value: '27WJ',
            labelcz: 'Personne morale sans but lucratif par Loi sur les cités et villes',
            labelen: 'Personne morale sans but lucratif par Loi sur les cités et villes'
        },
        {
            value: '2ODA',
            labelcz: 'Personne morale sans but lucratif par Loi sur les sociétés agricoles et laitières',
            labelen: 'Personne morale sans but lucratif par Loi sur les sociétés agricoles et laitières'
        },
        {
            value: '2U3G',
            labelcz: 'Société en nom collectif à responsabilité limitée',
            labelen: 'Société en nom collectif à responsabilité limitée'
        },
        {
            value: '30IT',
            labelcz: 'Société par actions constitué par Loi sur les compagnies minières',
            labelen: 'Société par actions constitué par Loi sur les compagnies minières'
        },
        {
            value: '3C5P',
            labelcz:
                'Personne morale sans but lucratif par Loi sur la probation et sur les établissements de détention',
            labelen: 'Personne morale sans but lucratif par Loi sur la probation et sur les établissements de détention'
        },
        {
            value: '3FP6',
            labelcz: 'Personne morale sans but lucratif par Loi sur les corporations de fonds de sécurité',
            labelen: 'Personne morale sans but lucratif par Loi sur les corporations de fonds de sécurité'
        },
        {
            value: '4B4B',
            labelcz:
                'Société par actions constitué par Loi sur les sociétés de patrons de fabriques de producteurs laitiers',
            labelen:
                'Société par actions constitué par Loi sur les sociétés de patrons de fabriques de producteurs laitiers'
        },
        {
            value: '50Z9',
            labelcz: 'Société par actions constitué par Loi sur les assurances',
            labelen: 'Société par actions constitué par Loi sur les assurances'
        },
        {
            value: '52CK',
            labelcz: 'Personne morale sans but lucratif par Loi sur les villes minières',
            labelen: 'Personne morale sans but lucratif par Loi sur les villes minières'
        },
        {
            value: '6ZCO',
            labelcz:
                'Personne morale sans but lucratif par Loi sur la formation et la qualification professionnelles de la main-d’œuvre',
            labelen:
                'Personne morale sans but lucratif par Loi sur la formation et la qualification professionnelles de la main-d’œuvre'
        },
        {
            value: '702U',
            labelcz: 'Personne morale sans but lucratif par Loi sur les Chevaliers de Colomb de la province de Québec',
            labelen: 'Personne morale sans but lucratif par Loi sur les Chevaliers de Colomb de la province de Québec'
        },
        {
            value: '814Y',
            labelcz: 'Société en participation',
            labelen: 'Société en participation'
        },
        {
            value: '87OW',
            labelcz:
                "Personne morale sans but lucratif par Loi sur les collèges d'enseignement général et professionnel",
            labelen:
                "Personne morale sans but lucratif par Loi sur les collèges d'enseignement général et professionnel"
        },
        {
            value: '95EN',
            labelcz:
                'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux pour les autochtones cris',
            labelen:
                'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux pour les autochtones cris'
        },
        {
            value: '9CB2',
            labelcz: "Société par actions constitué par Loi sur les syndicats d'élevage",
            labelen: "Société par actions constitué par Loi sur les syndicats d'élevage"
        },
        {
            value: '9CEN',
            labelcz: "Société par actions constitué par Loi sur les sociétés d'exploration minière",
            labelen: "Société par actions constitué par Loi sur les sociétés d'exploration minière"
        },
        {
            value: '9IF2',
            labelcz: 'Personne morale sans but lucratif par Loi sur les associations coopératives',
            labelen: 'Personne morale sans but lucratif par Loi sur les associations coopératives'
        },
        {
            value: 'A7KA',
            labelcz: 'Selon la loi par Loi spéciale du Québec à caractère public',
            labelen: 'Selon la loi par Loi spéciale du Québec à caractère public'
        },
        {
            value: 'AS7L',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de gaz, d’eau et d’électricité',
            labelen: 'Société par actions constitué par Loi sur les compagnies de gaz, d’eau et d’électricité'
        },
        {
            value: 'CG81',
            labelcz: 'Personne morale sans but lucratif par Loi sur la Société d’habitation du Québec',
            labelen: 'Personne morale sans but lucratif par Loi sur la Société d’habitation du Québec'
        },
        {
            value: 'CT3J',
            labelcz:
                "Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III), Code des professions, Loi concernant le regroupement et la gestion des commissions scolaires , Loi sur l’aménagement et l’urbanisme, Loi sur l’instruction publique, Loi sur l’organisation municipale de certains territoires, Loi sur la conservation de la faune, Loi sur la conservation et la mise en valeur de la faune, Loi sur la constitution de certaines Églises, Loi sur la Fédération des guides catholiques du Québec , Loi sur la Fédération des scouts catholiques du Québec , Loi sur la formation et la qualification professionnelles de la main-d’œuvre, Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche, Loi sur la mise en marché des produits agricoles, Loi sur la probation et sur les établissements de détention, Loi sur la santé et la sécurité du travail, Loi sur la Société d’habitation du Québec, Loi sur la société Saint-Jean-Baptiste de Trois-Rivières, Loi sur la société Saint-Jean-Baptiste du Québec, Loi sur les associations coopératives, Loi sur les assurances, Loi sur les cercles agricoles, Loi sur les Chevaliers de Colomb de la province de Québec, Loi sur les cités et villes, Loi sur les clubs de chasse et de pêche, Loi sur les clubs de récréation, Loi sur les collèges d'enseignement général et professionnel, Loi sur les compagnies de cimetière, Loi sur les compagnies de cimetières catholiques romains, Loi sur les corporations de fonds de sécurité, Loi sur les corporations religieuses, Loi sur les décrets de convention collective, Loi sur les évêques catholiques romains, Loi sur les fabriques, Loi sur les services correctionnels, Loi sur les services de santé et les services sociaux pour les autochtones cris, Loi sur les services de santé et les services sociaux, Loi sur les sociétés agricoles et laitières, Loi sur les sociétés d'agriculture, Loi sur les sociétés d'horticulture, Loi sur les soci ...",
            labelen:
                "Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III), Code des professions, Loi concernant le regroupement et la gestion des commissions scolaires , Loi sur l’aménagement et l’urbanisme, Loi sur l’instruction publique, Loi sur l’organisation municipale de certains territoires, Loi sur la conservation de la faune, Loi sur la conservation et la mise en valeur de la faune, Loi sur la constitution de certaines Églises, Loi sur la Fédération des guides catholiques du Québec , Loi sur la Fédération des scouts catholiques du Québec , Loi sur la formation et la qualification professionnelles de la main-d’œuvre, Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche, Loi sur la mise en marché des produits agricoles, Loi sur la probation et sur les établissements de détention, Loi sur la santé et la sécurité du travail, Loi sur la Société d’habitation du Québec, Loi sur la société Saint-Jean-Baptiste de Trois-Rivières, Loi sur la société Saint-Jean-Baptiste du Québec, Loi sur les associations coopératives, Loi sur les assurances, Loi sur les cercles agricoles, Loi sur les Chevaliers de Colomb de la province de Québec, Loi sur les cités et villes, Loi sur les clubs de chasse et de pêche, Loi sur les clubs de récréation, Loi sur les collèges d'enseignement général et professionnel, Loi sur les compagnies de cimetière, Loi sur les compagnies de cimetières catholiques romains, Loi sur les corporations de fonds de sécurité, Loi sur les corporations religieuses, Loi sur les décrets de convention collective, Loi sur les évêques catholiques romains, Loi sur les fabriques, Loi sur les services correctionnels, Loi sur les services de santé et les services sociaux pour les autochtones cris, Loi sur les services de santé et les services sociaux, Loi sur les sociétés agricoles et laitières, Loi sur les sociétés d'agriculture, Loi sur les sociétés d'horticulture, Loi sur les soci ..."
        },
        {
            value: 'D2T8',
            labelcz: 'Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III)',
            labelen: 'Personne morale sans but lucratif par Loi sur les compagnies (Partie II et Partie III)'
        },
        {
            value: 'F9CT',
            labelcz: 'Personne morale sans but lucratif par Loi sur l’instruction publique',
            labelen: 'Personne morale sans but lucratif par Loi sur l’instruction publique'
        },
        {
            value: 'GAMO',
            labelcz: 'Personne morale sans but lucratif par Loi sur les sociétés nationales de bienfaisance',
            labelen: 'Personne morale sans but lucratif par Loi sur les sociétés nationales de bienfaisance'
        },
        {
            value: 'HVWR',
            labelcz: 'Personne morale sans but lucratif par Loi sur la constitution de certaines Églises',
            labelen: 'Personne morale sans but lucratif par Loi sur la constitution de certaines Églises'
        },
        {
            value: 'I3UX',
            labelcz: 'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux',
            labelen: 'Personne morale sans but lucratif par Loi sur les services de santé et les services sociaux'
        },
        {
            value: 'J5SC',
            labelcz: 'Personne morale sans but lucratif par Loi sur la conservation et la mise en valeur de la faune',
            labelen: 'Personne morale sans but lucratif par Loi sur la conservation et la mise en valeur de la faune'
        },
        {
            value: 'JBU2',
            labelcz: 'Personne morale sans but lucratif par Loi sur les clubs de chasse et de pêche',
            labelen: 'Personne morale sans but lucratif par Loi sur les clubs de chasse et de pêche'
        },
        {
            value: 'JI4V',
            labelcz:
                'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche',
            labelen:
                'Personne morale sans but lucratif par Loi sur la mise en marché des produits agricoles, alimentaires et de la pêche'
        },
        {
            value: 'JLE0',
            labelcz: 'Personne morale sans but lucratif par Loi sur la conservation de la faune',
            labelen: 'Personne morale sans but lucratif par Loi sur la conservation de la faune'
        },
        {
            value: 'JLZW',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de fidéicommis',
            labelen: 'Société par actions constitué par Loi sur les compagnies de fidéicommis'
        },
        {
            value: 'JQNA',
            labelcz:
                'Personne morale sans but lucratif par Loi sur les sociétés préventives de cruauté envers les animaux',
            labelen:
                'Personne morale sans but lucratif par Loi sur les sociétés préventives de cruauté envers les animaux'
        },
        {
            value: 'JVMD',
            labelcz:
                "Société par actions par Fonds mutuel constitué par acte de fiducie, Loi sur les assurances, Loi sur les compagnies de fidéicommis, Loi sur les compagnies de flottage, Loi sur les compagnies de gaz, d’eau et d’électricité, Loi sur les compagnies de télégraphe et de téléphone, Loi sur les compagnies minières, Loi sur les sociétés de construction, Loi sur les sociétés de développement de l'entreprise québécoise, Loi sur les sociétés de fiducie et les sociétés d'épargne, Loi sur les sociétés de patrons de fabriques de producteurs laitiers, Loi sur les sociétés d'entraide économique, Loi sur les sociétés d'exploration minière, Loi sur les syndicats d'élevage",
            labelen:
                "Société par actions par Fonds mutuel constitué par acte de fiducie, Loi sur les assurances, Loi sur les compagnies de fidéicommis, Loi sur les compagnies de flottage, Loi sur les compagnies de gaz, d’eau et d’électricité, Loi sur les compagnies de télégraphe et de téléphone, Loi sur les compagnies minières, Loi sur les sociétés de construction, Loi sur les sociétés de développement de l'entreprise québécoise, Loi sur les sociétés de fiducie et les sociétés d'épargne, Loi sur les sociétés de patrons de fabriques de producteurs laitiers, Loi sur les sociétés d'entraide économique, Loi sur les sociétés d'exploration minière, Loi sur les syndicats d'élevage"
        },
        {
            value: 'JXO5',
            labelcz: "Société par actions constitué par Loi sur les sociétés de fiducie et les sociétés d'épargne",
            labelen: "Société par actions constitué par Loi sur les sociétés de fiducie et les sociétés d'épargne"
        },
        {
            value: 'K08P',
            labelcz: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetière',
            labelen: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetière'
        },
        {
            value: 'L26C',
            labelcz: 'Société par actions par Fonds mutuel constitué par acte de fiducie',
            labelen: 'Société par actions par Fonds mutuel constitué par acte de fiducie'
        },
        {
            value: 'L3XH',
            labelcz: "Personne morale sans but lucratif par Loi sur les sociétés d'horticulture",
            labelen: "Personne morale sans but lucratif par Loi sur les sociétés d'horticulture"
        },
        {
            value: 'LN3N',
            labelcz: 'Personne morale sans but lucratif par Loi sur les villages miniers',
            labelen: 'Personne morale sans but lucratif par Loi sur les villages miniers'
        },
        {
            value: 'MCY8',
            labelcz: "Personne morale sans but lucratif par Loi sur les sociétés d'agriculture",
            labelen: "Personne morale sans but lucratif par Loi sur les sociétés d'agriculture"
        },
        {
            value: 'MK1I',
            labelcz: "Société par actions constitué par Loi sur les sociétés d'entraide économique",
            labelen: "Société par actions constitué par Loi sur les sociétés d'entraide économique"
        },
        {
            value: 'MQT7',
            labelcz: 'Personne morale sans but lucratif par Loi sur la santé et la sécurité du travail',
            labelen: 'Personne morale sans but lucratif par Loi sur la santé et la sécurité du travail'
        },
        {
            value: 'MR95',
            labelcz: 'Personne morale sans but lucratif par Loi sur les décrets de convention collective',
            labelen: 'Personne morale sans but lucratif par Loi sur les décrets de convention collective'
        },
        {
            value: 'NVXN',
            labelcz: "Personne morale sans but lucratif par Loi sur l'organisation territoriale municipale",
            labelen: "Personne morale sans but lucratif par Loi sur l'organisation territoriale municipale"
        },
        {
            value: 'OMUP',
            labelcz: 'Personne morale sans but lucratif par Loi sur les clubs de récréation',
            labelen: 'Personne morale sans but lucratif par Loi sur les clubs de récréation'
        },
        {
            value: 'Q8NY',
            labelcz: 'Personne morale sans but lucratif par Loi sur les syndicats professionnels',
            labelen: 'Personne morale sans but lucratif par Loi sur les syndicats professionnels'
        },
        { value: 'QB2W', labelcz: 'Coopérative', labelen: 'Coopérative' },
        {
            value: 'RC3D',
            labelcz:
                'Personne morale sans but lucratif par Loi sur les villages nordiques et l’Administration régionale Kativik',
            labelen:
                'Personne morale sans but lucratif par Loi sur les villages nordiques et l’Administration régionale Kativik'
        },
        {
            value: 'RPGT',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de télégraphe et de téléphone',
            labelen: 'Société par actions constitué par Loi sur les compagnies de télégraphe et de téléphone'
        },
        {
            value: 'RQIC',
            labelcz: 'Société en commandite',
            labelen: 'Société en commandite'
        },
        {
            value: 'S72N',
            labelcz: 'Personne morale sans but lucratif par Loi sur la Fédération des scouts catholiques du Québec',
            labelen: 'Personne morale sans but lucratif par Loi sur la Fédération des scouts catholiques du Québec'
        },
        {
            value: 'T1LR',
            labelcz: 'Syndicat de copropriété',
            labelen: 'Syndicat de copropriété'
        },
        {
            value: 'TA7J',
            labelcz: 'Société par actions constitué par Loi sur les compagnies de flottage',
            labelen: 'Société par actions constitué par Loi sur les compagnies de flottage'
        },
        {
            value: 'TKAB',
            labelcz:
                "Société par actions constitué par Loi sur les sociétés de développement de l'entreprise québécoise",
            labelen:
                "Société par actions constitué par Loi sur les sociétés de développement de l'entreprise québécoise"
        },
        { value: 'TWLR', labelcz: 'Association', labelen: 'Association' },
        {
            value: 'UG3Z',
            labelcz: 'Société par actions par Loi sur les sociétés par actions',
            labelen: 'Société par actions par Loi sur les sociétés par actions'
        },
        {
            value: 'UVCG',
            labelcz: 'Société par actions constitué par Loi sur les sociétés de construction',
            labelen: 'Société par actions constitué par Loi sur les sociétés de construction'
        },
        {
            value: 'V5IH',
            labelcz: 'Personne morale sans but lucratif par Loi sur l’aménagement et l’urbanisme',
            labelen: 'Personne morale sans but lucratif par Loi sur l’aménagement et l’urbanisme'
        },
        {
            value: 'V9GU',
            labelcz: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste de Trois-Rivières',
            labelen: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste de Trois-Rivières'
        },
        {
            value: 'VGP6',
            labelcz: 'Personne morale sans but lucratif par Loi sur les fabriques',
            labelen: 'Personne morale sans but lucratif par Loi sur les fabriques'
        },
        {
            value: 'VRVJ',
            labelcz: 'Personne morale sans but lucratif par Code des professions',
            labelen: 'Personne morale sans but lucratif par Code des professions'
        },
        {
            value: 'WGEA',
            labelcz: 'Personne morale sans but lucratif par Loi sur l’organisation municipale de certains territoires',
            labelen: 'Personne morale sans but lucratif par Loi sur l’organisation municipale de certains territoires'
        },
        {
            value: 'XS49',
            labelcz:
                'Personne morale sans but lucratif par Loi concernant le regroupement et la gestion des commissions scolaires',
            labelen:
                'Personne morale sans but lucratif par Loi concernant le regroupement et la gestion des commissions scolaires'
        },
        {
            value: 'XW5K',
            labelcz: 'Personne morale sans but lucratif par Loi sur la Fédération des guides catholiques du Québec',
            labelen: 'Personne morale sans but lucratif par Loi sur la Fédération des guides catholiques du Québec'
        },
        {
            value: 'YBMJ',
            labelcz: 'Personne morale sans but lucratif par Loi sur les assurances',
            labelen: 'Personne morale sans but lucratif par Loi sur les assurances'
        },
        {
            value: 'YIIS',
            labelcz: 'Personne morale sans but lucratif par Loi sur les corporations religieuses',
            labelen: 'Personne morale sans but lucratif par Loi sur les corporations religieuses'
        },
        {
            value: 'YRUJ',
            labelcz: 'Société en nom collectif',
            labelen: 'Société en nom collectif'
        },
        {
            value: 'Z6MF',
            labelcz: 'Selon la loi par Loi spéciale du Québec à caractère privé',
            labelen: 'Selon la loi par Loi spéciale du Québec à caractère privé'
        },
        {
            value: 'ZGEX',
            labelcz: 'Personne morale sans but lucratif par Loi sur les services correctionnels',
            labelen: 'Personne morale sans but lucratif par Loi sur les services correctionnels'
        },
        {
            value: 'ZQQU',
            labelcz: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste du Québec',
            labelen: 'Personne morale sans but lucratif par Loi sur la société Saint-Jean-Baptiste du Québec'
        },
        {
            value: 'ZX1F',
            labelcz: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetières catholiques romains',
            labelen: 'Personne morale sans but lucratif par Loi sur les compagnies de cimetières catholiques romains'
        },
        {
            value: '3OVJ',
            labelcz: 'Non-profit Corporations',
            labelen: 'Non-profit Corporations'
        },
        {
            value: '5D9I',
            labelcz: 'Limited Liabilty Partnerships',
            labelen: 'Limited Liabilty Partnerships'
        },
        {
            value: '5EEA',
            labelcz: 'Corporations formed by an Act of the Saskatchewan legislature',
            labelen: 'Corporations formed by an Act of the Saskatchewan legislature'
        },
        {
            value: '7IKZ',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '7XZL',
            labelcz: 'New Generation Co-operatives',
            labelen: 'New Generation Co-operatives'
        },
        {
            value: '8KL5',
            labelcz: 'Condominium Corporations',
            labelen: 'Condominium Corporations'
        },
        { value: 'FYYY', labelcz: 'Credit Unions', labelen: 'Credit Unions' },
        { value: 'I8VP', labelcz: 'Sole Proprietors', labelen: 'Sole Proprietors' },
        { value: 'JNCJ', labelcz: 'Co-operatives', labelen: 'Co-operatives' },
        { value: 'KZDW', labelcz: 'Syndicates', labelen: 'Syndicates' },
        { value: 'L2NN', labelcz: 'Joint Ventures', labelen: 'Joint Ventures' },
        { value: 'LMSY', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: 'UWMY',
            labelcz: 'Business Corporations',
            labelen: 'Business Corporations'
        }
    ],
    KY: [
        {
            value: '4XP8',
            labelcz: 'company limited by guarantee',
            labelen: 'company limited by guarantee'
        },
        {
            value: '6XB7',
            labelcz: 'exempted limited partnership',
            labelen: 'exempted limited partnership'
        },
        {
            value: '8HR7',
            labelcz: 'unlimited company',
            labelen: 'unlimited company'
        },
        {
            value: 'JDX6',
            labelcz: 'special economic zone company',
            labelen: 'special economic zone company'
        },
        {
            value: 'K575',
            labelcz: 'foundation company',
            labelen: 'foundation company'
        },
        {
            value: 'MP7S',
            labelcz: 'segregated portfolio company',
            labelen: 'segregated portfolio company'
        },
        {
            value: 'MPUG',
            labelcz: 'limited liability company',
            labelen: 'limited liability company'
        },
        {
            value: 'OSBR',
            labelcz: 'company limited by shares',
            labelen: 'company limited by shares'
        },
        { value: 'SNUK', labelcz: 'association', labelen: 'association' },
        {
            value: 'T5UM',
            labelcz: 'exempted limited duration company',
            labelen: 'exempted limited duration company'
        },
        {
            value: 'XAQA',
            labelcz: 'limited partnership',
            labelen: 'limited partnership'
        }
    ],
    CN: [
        {
            value: '1IWK',
            labelcz: 'wai guo chang zhu xin wen ji gou',
            labelen: 'wai guo chang zhu xin wen ji gou'
        },
        { value: '2M6Y', labelcz: 'ji jin hui', labelen: 'ji jin hui' },
        {
            value: '5A9K',
            labelcz: 'jun dui shi ye dan wei',
            labelen: 'jun dui shi ye dan wei'
        },
        {
            value: '5GXA',
            labelcz: 'cun ji ji ti jing ji zu zhi',
            labelen: 'cun ji ji ti jing ji zu zhi'
        },
        {
            value: '6KC0',
            labelcz: 'zong jiao yuan xiao',
            labelen: 'zong jiao yuan xiao'
        },
        {
            value: '6NSC',
            labelcz: 'lv shi zhi ye ji gou',
            labelen: 'lv shi zhi ye ji gou'
        },
        {
            value: '8XAW',
            labelcz: 'wai guo zai hua wen hua zhong xin',
            labelen: 'wai guo zai hua wen hua zhong xin'
        },
        { value: 'B5UZ', labelcz: 'shi ye dan wei', labelen: 'shi ye dan wei' },
        {
            value: 'BDTI',
            labelcz: 'bian ban zhi jie guan li ji gou bian zhi de qun zhong tuan ti',
            labelen: 'bian ban zhi jie guan li ji gou bian zhi de qun zhong tuan ti'
        },
        {
            value: 'C38B',
            labelcz: 'qi ta（ wai jiao ）',
            labelen: 'qi ta（ wai jiao ）'
        },
        {
            value: 'CYV6',
            labelcz: 'qi ta（ zhong yang jun wei gai ge he bian zhi ban gong shi ）',
            labelen: 'qi ta（ zhong yang jun wei gai ge he bian zhi ban gong shi ）'
        },
        {
            value: 'DLEK',
            labelcz: 'xiang zhen ji ji ti jing ji zu zhi',
            labelen: 'xiang zhen ji ji ti jing ji zu zhi'
        },
        {
            value: 'E4FG',
            labelcz: 'min ban fei qi ye dan wei',
            labelen: 'min ban fei qi ye dan wei'
        },
        {
            value: 'E4YV',
            labelcz: 'gang ao tai di qu lv you bu men chang zhu nei di ( da lu ) dai biao ji gou',
            labelen: 'gang ao tai di qu lv you bu men chang zhu nei di ( da lu ) dai biao ji gou'
        },
        { value: 'E88S', labelcz: 'gong zheng chu', labelen: 'gong zheng chu' },
        { value: 'ECAK', labelcz: 'qi ye', labelen: 'qi ye' },
        {
            value: 'ESZ8',
            labelcz: 'qi ta（ nong ye ）',
            labelen: 'qi ta（ nong ye ）'
        },
        { value: 'GGZ5', labelcz: 'she hui tuan ti', labelen: 'she hui tuan ti' },
        {
            value: 'GPHT',
            labelcz: 'qi ta（ wen hua ）',
            labelen: 'qi ta（ wen hua ）'
        },
        { value: 'I39S', labelcz: 'ji guan', labelen: 'ji guan' },
        {
            value: 'IBEM',
            labelcz: 'ji ceng fa lv fu wu suo',
            labelen: 'ji ceng fa lv fu wu suo'
        },
        {
            value: 'LURL',
            labelcz: 'qi ta（ shi yong yu wu deng ji ji gou de de qing kuang ）',
            labelen: 'qi ta（ shi yong yu wu deng ji ji gou de de qing kuang ）'
        },
        {
            value: 'NWJX',
            labelcz: 'qi ta（ si fa xing zheng ）',
            labelen: 'qi ta（ si fa xing zheng ）'
        },
        { value: 'OH9O', labelcz: 'ji ceng gong hui', labelen: 'ji ceng gong hui' },
        {
            value: 'OMUD',
            labelcz: 'qi ta（ lv you ）',
            labelen: 'qi ta（ lv you ）'
        },
        {
            value: 'R3O0',
            labelcz: 'qi ta（ gong hui ）',
            labelen: 'qi ta（ gong hui ）'
        },
        {
            value: 'RV48',
            labelcz: 'ge ti gong shang hu',
            labelen: 'ge ti gong shang hu'
        },
        {
            value: 'S9UH',
            labelcz: 'si fa jian ding ji gou',
            labelen: 'si fa jian ding ji gou'
        },
        {
            value: 'SH05',
            labelcz: 'qi ta（ ji gou bian zhi ）',
            labelen: 'qi ta（ ji gou bian zhi ）'
        },
        {
            value: 'T0KK',
            labelcz: 'qi ta（ zong jiao ）',
            labelen: 'qi ta（ zong jiao ）'
        },
        {
            value: 'TBG2',
            labelcz: 'wai guo lv you bu men chang zhu dai biao ji gou',
            labelen: 'wai guo lv you bu men chang zhu dai biao ji gou'
        },
        {
            value: 'UMCR',
            labelcz: 'nong min zhuan ye he zuo she',
            labelen: 'nong min zhuan ye he zuo she'
        },
        {
            value: 'V251',
            labelcz: 'zhong cai wei yuan hui',
            labelen: 'zhong cai wei yuan hui'
        },
        {
            value: 'V816',
            labelcz: 'zu ji ji ti jing ji zu zhi',
            labelen: 'zu ji ji ti jing ji zu zhi'
        },
        {
            value: 'WEUX',
            labelcz: 'qi ta（ min zheng ）',
            labelen: 'qi ta（ min zheng ）'
        },
        {
            value: 'YXJ5',
            labelcz: 'zong jiao huo dong chang suo',
            labelen: 'zong jiao huo dong chang suo'
        }
    ],
    CO: [
        {
            value: '1PAD',
            labelcz: 'Empresa Unipersonal',
            labelen: 'Empresa Unipersonal'
        },
        { value: '3RHN', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' },
        {
            value: '4OYE',
            labelcz: 'Persona natural comerciante',
            labelen: 'Persona natural comerciante'
        },
        {
            value: '6Z8B',
            labelcz: 'Sucursal de Sociedad Extranjera',
            labelen: 'Sucursal de Sociedad Extranjera'
        },
        {
            value: 'D2T3',
            labelcz: 'Empresa Asociativa de Trabajo',
            labelen: 'Empresa Asociativa de Trabajo'
        },
        {
            value: 'DEJ0',
            labelcz: 'Sociedad Colectiva',
            labelen: 'Sociedad Colectiva'
        },
        {
            value: 'IUIY',
            labelcz: 'Sociedad en comandita simple',
            labelen: 'Sociedad en comandita simple'
        },
        {
            value: 'KC51',
            labelcz: 'Sociedad de Economía Mixta',
            labelen: 'Sociedad de Economía Mixta'
        },
        {
            value: 'KYVO',
            labelcz: 'Sociedad por Acciones Simplificada',
            labelen: 'Sociedad por Acciones Simplificada'
        },
        {
            value: 'N1TE',
            labelcz: 'Sociedad en comandita por acciones',
            labelen: 'Sociedad en comandita por acciones'
        },
        {
            value: 'SJB8',
            labelcz: 'Sociedades Agrarias de Transformación',
            labelen: 'Sociedades Agrarias de Transformación'
        },
        {
            value: 'WX45',
            labelcz: 'Sociedad de Responsabilidad Limitada',
            labelen: 'Sociedad de Responsabilidad Limitada'
        }
    ],
    CK: [
        {
            value: '70NZ',
            labelcz: 'International Company',
            labelen: 'International Company'
        },
        {
            value: 'A7G6',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'KNIC',
            labelcz: 'International Partnership',
            labelen: 'International Partnership'
        },
        { value: 'N00R', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: 'YCQM',
            labelcz: 'International Trust',
            labelen: 'International Trust'
        },
        { value: 'Z3Y2', labelcz: 'Foreign Company', labelen: 'Foreign Company' }
    ],
    CR: [
        {
            value: '4SFS',
            labelcz: 'Institución Autónoma',
            labelen: 'Institución Autónoma'
        },
        {
            value: '4Y4D',
            labelcz: 'Entidad Creada por Ley Especial',
            labelen: 'Entidad Creada por Ley Especial'
        },
        {
            value: '72BT',
            labelcz: 'Organismo Internacional',
            labelen: 'Organismo Internacional'
        },
        {
            value: 'DUXT',
            labelcz: 'Junta de Educación y Junta Administrativa de Patronatos Escolares',
            labelen: 'Junta de Educación y Junta Administrativa de Patronatos Escolares'
        },
        {
            value: 'E26K',
            labelcz: 'Sociedad Profesional',
            labelen: 'Sociedad Profesional'
        },
        { value: 'EFE3', labelcz: 'Municipalidad', labelen: 'Municipalidad' },
        { value: 'G5RR', labelcz: 'Fundación', labelen: 'Fundación' },
        { value: 'H2BW', labelcz: 'Sociedad civil', labelen: 'Sociedad civil' },
        {
            value: 'HSX9',
            labelcz: 'Temporalidad de la Iglesia',
            labelen: 'Temporalidad de la Iglesia'
        },
        {
            value: 'KZMF',
            labelcz: 'Sociedad de usuarios de aguas',
            labelen: 'Sociedad de usuarios de aguas'
        },
        {
            value: 'LQVG',
            labelcz: 'Sucesión Indivisa',
            labelen: 'Sucesión Indivisa'
        },
        { value: 'M0X8', labelcz: 'Condominio', labelen: 'Condominio' },
        {
            value: 'O4X3',
            labelcz: 'Asociación civil, Asociación deportiva, Federación',
            labelen: 'Asociación civil, Asociación deportiva, Federación'
        },
        {
            value: 'P864',
            labelcz: 'Sociedad de Responsabilidad Limitada o Sociedad Limitada',
            labelen: 'Sociedad de Responsabilidad Limitada o Sociedad Limitada'
        },
        {
            value: 'Q4J1',
            labelcz: 'Mutual de Ahorro y Préstamo',
            labelen: 'Mutual de Ahorro y Préstamo'
        },
        {
            value: 'SBQF',
            labelcz: 'Sociedad colectiva',
            labelen: 'Sociedad colectiva'
        },
        {
            value: 'SMWM',
            labelcz: 'Sindicato y su Federación',
            labelen: 'Sindicato y su Federación'
        },
        {
            value: 'YFZL',
            labelcz: 'Fideicomiso de Partidos Políticos',
            labelen: 'Fideicomiso de Partidos Políticos'
        },
        { value: 'YOIW', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' },
        {
            value: 'YP63',
            labelcz: 'Sociedad en comandita',
            labelen: 'Sociedad en comandita'
        },
        {
            value: 'YW6W',
            labelcz: 'Empresa Individual de Responsabilidad Limitada',
            labelen: 'Empresa Individual de Responsabilidad Limitada'
        },
        {
            value: 'YYZO',
            labelcz: 'Asociación Cooperativa',
            labelen: 'Asociación Cooperativa'
        }
    ],
    HR: [
        { value: '24EG', labelcz: 'Kreditna unija', labelen: 'Kreditna unija' },
        { value: '274G', labelcz: 'Udruga', labelen: 'Udruga' },
        { value: '28RA', labelcz: 'Fond', labelen: 'Fond' },
        {
            value: '2FED',
            labelcz: 'Gospodarsko interesno udruženje',
            labelen: 'Gospodarsko interesno udruženje'
        },
        {
            value: '3OW3',
            labelcz: 'Europsko gospodarsko interesno udruženje (skraćeno EGIU)',
            labelen: 'Europsko gospodarsko interesno udruženje (skraćeno EGIU)'
        },
        {
            value: '6Q6D',
            labelcz: 'Pravna osoba Katoličke Crkve',
            labelen: 'Pravna osoba Katoličke Crkve'
        },
        {
            value: '6RD2',
            labelcz: 'Agencije I druge samostalne pravne osobe s javnim ovlastima',
            labelen: 'Agencije I druge samostalne pravne osobe s javnim ovlastima'
        },
        {
            value: '8VRU',
            labelcz: 'Europska zadruga (Societas Cooperativa Europaea, skraćeno SCE)',
            labelen: 'Europska zadruga (Societas Cooperativa Europaea, skraćeno SCE)'
        },
        {
            value: '9D9U',
            labelcz: 'Trgovac pojedinac',
            labelen: 'Trgovac pojedinac'
        },
        { value: '9PZC', labelcz: 'Fundacija', labelen: 'Fundacija' },
        {
            value: 'E9CM',
            labelcz: 'Europsko društvo (Societas Europaea, skraćeno SE)',
            labelen: 'Europsko društvo (Societas Europaea, skraćeno SE)'
        },
        { value: 'EYKU', labelcz: 'Stečajna masa', labelen: 'Stečajna masa' },
        { value: 'G5RH', labelcz: 'Zadruge', labelen: 'Zadruge' },
        { value: 'IVVD', labelcz: 'Savez zadruga', labelen: 'Savez zadruga' },
        {
            value: 'KP34',
            labelcz: 'Javno trgovačko društvo',
            labelen: 'Javno trgovačko društvo'
        },
        { value: 'LUMA', labelcz: 'Dioničko društvo', labelen: 'Dioničko društvo' },
        {
            value: 'MF7P',
            labelcz: 'Komanditno društvo',
            labelen: 'Komanditno društvo'
        },
        { value: 'NRTG', labelcz: 'Podružnica', labelen: 'Podružnica' },
        {
            value: 'OQWO',
            labelcz: 'Društvo s ograničenom odgovornošću',
            labelen: 'Društvo s ograničenom odgovornošću'
        },
        {
            value: 'SPJ7',
            labelcz: 'Vjerska zajednica',
            labelen: 'Vjerska zajednica'
        },
        {
            value: 'TSA0',
            labelcz: 'Tijelo državne uprave',
            labelen: 'Tijelo državne uprave'
        },
        {
            value: 'XQLW',
            labelcz: 'Jedinica lokalne ili područne (regionalne) samouprave',
            labelen: 'Jedinica lokalne ili područne (regionalne) samouprave'
        },
        {
            value: 'YA9S',
            labelcz: 'Zajednica ustanova',
            labelen: 'Zajednica ustanova'
        },
        { value: 'ZFQS', labelcz: 'Ustanova', labelen: 'Ustanova' },
        { value: 'ZMY8', labelcz: 'Zaklada', labelen: 'Zaklada' }
    ],
    CW: [
        {
            value: '1SVL',
            labelcz: 'Stille vennootschap',
            labelen: 'Stille vennootschap'
        },
        { value: '1T06', labelcz: 'Stichting', labelen: 'Stichting' },
        {
            value: '2J66',
            labelcz: 'Stichting Particulier Fonds',
            labelen: 'Stichting Particulier Fonds'
        },
        {
            value: '36AO',
            labelcz: 'Naamloze Vennootschap',
            labelen: 'Naamloze Vennootschap'
        },
        { value: '5OZV', labelcz: 'Eenmanszaak', labelen: 'Eenmanszaak' },
        {
            value: '9E0Q',
            labelcz: 'Commanditaire vennootschap',
            labelen: 'Commanditaire vennootschap'
        },
        { value: 'ADF8', labelcz: 'Coöperatie', labelen: 'Coöperatie' },
        { value: 'IHD0', labelcz: 'Rederij', labelen: 'Rederij' },
        {
            value: 'KM1T',
            labelcz: 'Openbare vennootschap',
            labelen: 'Openbare vennootschap'
        },
        {
            value: 'MZB1',
            labelcz: 'Besloten Vennootschap',
            labelen: 'Besloten Vennootschap'
        },
        {
            value: 'SS3A',
            labelcz: 'Onderlinge waarborgmaatschappij',
            labelen: 'Onderlinge waarborgmaatschappij'
        },
        { value: 'WV3I', labelcz: 'Vereniging', labelen: 'Vereniging' },
        { value: 'ZKTC', labelcz: 'Trust', labelen: 'Trust' }
    ],
    CY: [
        {
            value: '1MBR',
            labelcz: 'Alli nomiki morfi',
            labelen: 'Alli nomiki morfi'
        },
        {
            value: 'P5JT',
            labelcz: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού',
            labelen: 'Ευρωπαϊκός Όμιλος Οικονομικού Σκοπού'
        },
        { value: '233U', labelcz: 'Synetairismos', labelen: 'Synetairismos' },
        {
            value: '8BL9',
            labelcz: 'Evropaiki Dimosia Etaireia Periorismenis Efthynis',
            labelen: 'Evropaiki Dimosia Etaireia Periorismenis Efthynis'
        },
        { value: '8VZ0', labelcz: 'Trust', labelen: 'Trust' },
        {
            value: 'BCF5',
            labelcz: 'Dimosia Etaireia Periorismenis Efthynis me metoches',
            labelen: 'Dimosia Etaireia Periorismenis Efthynis me metoches'
        },
        {
            value: 'FV0K',
            labelcz: 'Emporiki Eponymia',
            labelen: 'Emporiki Eponymia'
        },
        {
            value: 'GLCH',
            labelcz: 'Somateia kai Idrymata',
            labelen: 'Somateia kai Idrymata'
        },
        {
            value: 'HIL6',
            labelcz: 'Allodapi Etaireia',
            labelen: 'Allodapi Etaireia'
        },
        {
            value: 'I8RE',
            labelcz: 'Aftotelos ergazomenos',
            labelen: 'Aftotelos ergazomenos'
        },
        {
            value: 'INTY',
            labelcz: 'Etaireia Periorismenis Efthynis me engyisi, kai pou echei metochiko kefalaio',
            labelen: 'Etaireia Periorismenis Efthynis me engyisi, kai pou echei metochiko kefalaio'
        },
        {
            value: 'K9L6',
            labelcz: 'Idiotiki Etaireia Periorismenis Efthynis me metoches',
            labelen: 'Idiotiki Etaireia Periorismenis Efthynis me metoches'
        },
        { value: 'MYKG', labelcz: 'Dimosia Etaireia', labelen: 'Dimosia Etaireia' },
        {
            value: 'P12B',
            labelcz: 'Tameia Pronoias/ Syntaxeos',
            labelen: 'Tameia Pronoias/ Syntaxeos'
        },
        {
            value: 'RCPI',
            labelcz: 'Idiotiki Etaireia',
            labelen: 'Idiotiki Etaireia'
        },
        {
            value: 'T1JS',
            labelcz: 'Ontotites pou diepontai apo to dimosio dikaio',
            labelen: 'Ontotites pou diepontai apo to dimosio dikaio'
        },
        {
            value: 'U24X',
            labelcz: 'Synergatika Pistotika Idrymata',
            labelen: 'Synergatika Pistotika Idrymata'
        },
        {
            value: 'W86L',
            labelcz: 'Etaireia Periorismenis Efthynis me engyisi, choris metochiko kefalaio',
            labelen: 'Etaireia Periorismenis Efthynis me engyisi, choris metochiko kefalaio'
        }
    ],
    CZ: [
        {
            value: '6D9L',
            labelcz: 'Svěřenský fond',
            labelen: 'Svěřenský fond'
        },
        {
            value: 'SNWJ',
            labelcz: 'Podílový, penzijní fond',
            labelen: 'Podílový, penzijní fond'
        },
        {
            value: '1JK6',
            labelcz: 'Svépomocné zemědělské družstvo',
            labelen: 'Svépomocné zemědělské družstvo'
        },
        {
            value: '2DK3',
            labelcz: 'Podnik nebo hospodářské zařízení politické strany',
            labelen: 'Podnik nebo hospodářské zařízení politické strany'
        },
        {
            value: '2N9X',
            labelcz: 'Česká konsolidační agentura',
            labelen: 'Česká konsolidační agentura'
        },
        {
            value: '3BX3',
            labelcz: 'Evropské seskupení pro územní spolupráci',
            labelen: 'Evropské seskupení pro územní spolupráci'
        },
        { value: '3G3D', labelcz: 'Nadace', labelen: 'Nadace' },
        {
            value: '3RMA',
            labelcz: 'Státní fond ze zákona',
            labelen: 'Státní fond ze zákona'
        },
        {
            value: '4A26',
            labelcz: 'Zájmová organizace družstev',
            labelen: 'Zájmová organizace družstev'
        },
        {
            value: '4OTK',
            labelcz: 'Regionální rada regionu soudržnosti',
            labelen: 'Regionální rada regionu soudržnosti'
        },
        {
            value: '4UB2',
            labelcz: 'Garanční fond obchodníků s cennými papíry',
            labelen: 'Garanční fond obchodníků s cennými papíry'
        },
        {
            value: '4YAK',
            labelcz: 'Stálý rozhodčí soud',
            labelen: 'Stálý rozhodčí soud'
        },
        {
            value: '5AP3',
            labelcz: 'Pobočná mezinárodní organizace zaměstnavatelů',
            labelen: 'Pobočná mezinárodní organizace zaměstnavatelů'
        },
        {
            value: '5KU5',
            labelcz: 'Veřejná obchodní společnost',
            labelen: 'Veřejná obchodní společnost'
        },
        {
            value: '6CQN',
            labelcz: 'Akciová společnost',
            labelen: 'Akciová společnost'
        },
        { value: '6FAI', labelcz: 'Státní podnik', labelen: 'Státní podnik' },
        {
            value: '6OMW',
            labelcz: 'Organizační jednotka občanského sdružení',
            labelen: 'Organizační jednotka občanského sdružení'
        },
        {
            value: '747U',
            labelcz: 'Společnost komanditní na akcie',
            labelen: 'Společnost komanditní na akcie'
        },
        {
            value: '74W6',
            labelcz: 'Státní příspěvková organizace ostatní',
            labelen: 'Státní příspěvková organizace ostatní'
        },
        { value: '7OZQ', labelcz: 'Zájmové sdružení', labelen: 'Zájmové sdružení' },
        {
            value: '84J8',
            labelcz: 'Státní hospodářská organizace řízená okresním úřadem',
            labelen: 'Státní hospodářská organizace řízená okresním úřadem'
        },
        {
            value: '8K5T',
            labelcz: 'Spotřební družstvo',
            labelen: 'Spotřební družstvo'
        },
        {
            value: '917C',
            labelcz: 'Česká tisková kancelář',
            labelen: 'Česká tisková kancelář'
        },
        {
            value: '95G8',
            labelcz: 'Podnikající fyzická osoba tuzemská',
            labelen: 'Podnikající fyzická osoba tuzemská'
        },
        {
            value: '971Y',
            labelcz: 'Podnik nebo hospodářské zařízení sdružení',
            labelen: 'Podnik nebo hospodářské zařízení sdružení'
        },
        {
            value: '9HLU',
            labelcz: 'Společnost s ručením omezeným',
            labelen: 'Společnost s ručením omezeným'
        },
        { value: '9RVC', labelcz: 'Družstvo', labelen: 'Družstvo' },
        {
            value: '9XDB',
            labelcz: 'Občanské sdružení',
            labelen: 'Občanské sdružení'
        },
        {
            value: 'AM3T',
            labelcz: 'Státní fond ze zákona nezapisující se do obchodního rejstříku',
            labelen: 'Státní fond ze zákona nezapisující se do obchodního rejstříku'
        },
        {
            value: 'APEN',
            labelcz: 'Správa železniční dopravní cesty, státní organizace',
            labelen: 'Správa železniční dopravní cesty, státní organizace'
        },
        {
            value: 'BL4B',
            labelcz: 'Obecně prospěšná společnost',
            labelen: 'Obecně prospěšná společnost'
        },
        {
            value: 'C4Q2',
            labelcz: 'Všeobecná zdravotní pojišťovna',
            labelen: 'Všeobecná zdravotní pojišťovna'
        },
        {
            value: 'C5FE',
            labelcz: 'Samostatná drobná provozovna (obecního úřadu)',
            labelen: 'Samostatná drobná provozovna (obecního úřadu)'
        },
        { value: 'C7GZ', labelcz: 'Výrobní družstvo', labelen: 'Výrobní družstvo' },
        { value: 'CATU', labelcz: 'Spolek', labelen: 'Spolek' },
        {
            value: 'CD28',
            labelcz: 'Společnost komanditní',
            labelen: 'Společnost komanditní'
        },
        {
            value: 'CHJR',
            labelcz: 'Podnik se zahraniční majetkovou účastí',
            labelen: 'Podnik se zahraniční majetkovou účastí'
        },
        {
            value: 'CIO8',
            labelcz: 'Veřejná výzkumná instituce',
            labelen: 'Veřejná výzkumná instituce'
        },
        {
            value: 'CUKQ',
            labelcz: 'Mezinárodní organizace zaměstnavatelů',
            labelen: 'Mezinárodní organizace zaměstnavatelů'
        },
        {
            value: 'CZUA',
            labelcz: 'Zahraniční fyzická osoba',
            labelen: 'Zahraniční fyzická osoba'
        },
        {
            value: 'D1VK',
            labelcz: 'Školská právnická osoba',
            labelen: 'Školská právnická osoba'
        },
        {
            value: 'D35X',
            labelcz: 'Zahraniční spolek',
            labelen: 'Zahraniční spolek'
        },
        {
            value: 'ET6Z',
            labelcz: 'Svazy církví a náboženských společností',
            labelen: 'Svazy církví a náboženských společností'
        },
        {
            value: 'FIPS',
            labelcz: 'Banka-státní peněžní ústav',
            labelen: 'Banka-státní peněžní ústav'
        },
        {
            value: 'FY1B',
            labelcz: 'Církve a náboženské společnosti',
            labelen: 'Církve a náboženské společnosti'
        },
        { value: 'G2I3', labelcz: 'Pobočný spolek', labelen: 'Pobočný spolek' },
        {
            value: 'H4XQ',
            labelcz: 'Veřejné neziskové ústavní zdravotnické zařízení',
            labelen: 'Veřejné neziskové ústavní zdravotnické zařízení'
        },
        {
            value: 'H6WW',
            labelcz: 'Státní příspěvková organizace',
            labelen: 'Státní příspěvková organizace'
        },
        {
            value: 'HQPK',
            labelcz: 'Komora (hospodářská, agrární)',
            labelen: 'Komora (hospodářská, agrární)'
        },
        {
            value: 'HS5W',
            labelcz: 'Vnitřní organizační jednotka organizační složky státu',
            labelen: 'Vnitřní organizační jednotka organizační složky státu'
        },
        {
            value: 'HSNC',
            labelcz: 'Podnik zahraničního obchodu',
            labelen: 'Podnik zahraničního obchodu'
        },
        {
            value: 'HY6K',
            labelcz: 'Organizační složka zahraničního nadačního fondu',
            labelen: 'Organizační složka zahraničního nadačního fondu'
        },
        {
            value: 'I32F',
            labelcz: 'Sdružení mezinárodního obchodu',
            labelen: 'Sdružení mezinárodního obchodu'
        },
        {
            value: 'I68R',
            labelcz:
                'Organizační jednotka zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
            labelen:
                'Organizační jednotka zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích'
        },
        {
            value: 'IQ9O',
            labelcz: 'Společenství vlastníků jednotek',
            labelen: 'Společenství vlastníků jednotek'
        },
        { value: 'J8PB', labelcz: 'Obec', labelen: 'Obec' },
        {
            value: 'JCAD',
            labelcz: 'Evidované církevní právnické osoby',
            labelen: 'Evidované církevní právnické osoby'
        },
        {
            value: 'JJYB',
            labelcz: 'Zahraniční pobočný spolek',
            labelen: 'Zahraniční pobočný spolek'
        },
        {
            value: 'KM6Z',
            labelcz: 'Státní banka československá',
            labelen: 'Státní banka československá'
        },
        {
            value: 'LEDI',
            labelcz: 'Honební společenstvo',
            labelen: 'Honební společenstvo'
        },
        {
            value: 'LJ92',
            labelcz: 'Československé státní dráhy-státní organizace',
            labelen: 'Československé státní dráhy-státní organizace'
        },
        {
            value: 'LJL0',
            labelcz: 'Organizační složka státu',
            labelen: 'Organizační složka státu'
        },
        {
            value: 'LPCQ',
            labelcz: 'Mezinárodní odborová organizace',
            labelen: 'Mezinárodní odborová organizace'
        },
        {
            value: 'MAVU',
            labelcz: 'Dobrovolný svazek obcí',
            labelen: 'Dobrovolný svazek obcí'
        },
        {
            value: 'MBUU',
            labelcz: 'Příspěvková organizace zřízená územním samosprávným celkem',
            labelen: 'Příspěvková organizace zřízená územním samosprávným celkem'
        },
        {
            value: 'NI3I',
            labelcz: 'Veřejnoprávní instituce',
            labelen: 'Veřejnoprávní instituce'
        },
        {
            value: 'NJ87',
            labelcz: 'Společný podnik (s více zakladateli)',
            labelen: 'Společný podnik (s více zakladateli)'
        },
        {
            value: 'NPH3',
            labelcz: 'Česká národní banka',
            labelen: 'Česká národní banka'
        },
        { value: 'NQHQ', labelcz: 'Komoditní burza', labelen: 'Komoditní burza' },
        {
            value: 'O9PW',
            labelcz: 'Samosprávná stavovská organizace (profesní komora)',
            labelen: 'Samosprávná stavovská organizace (profesní komora)'
        },
        {
            value: 'OVKW',
            labelcz: 'Vysoká škola (veřejná, státní)',
            labelen: 'Vysoká škola (veřejná, státní)'
        },
        {
            value: 'P3YF',
            labelcz: 'Pobočná odborová organizace a organizace zaměstnavatelů',
            labelen: 'Pobočná odborová organizace a organizace zaměstnavatelů'
        },
        {
            value: 'PFE5',
            labelcz: 'Městská část, městský obvod',
            labelen: 'Městská část, městský obvod'
        },
        {
            value: 'PQJE',
            labelcz: 'Mezinárodní nevládní organizace',
            labelen: 'Mezinárodní nevládní organizace'
        },
        {
            value: 'Q25I',
            labelcz: 'Odborová organizace a organizace zaměstnavatelů',
            labelen: 'Odborová organizace a organizace zaměstnavatelů'
        },
        { value: 'QIEL', labelcz: 'Kraj', labelen: 'Kraj' },
        { value: 'QJ0F', labelcz: 'Ústav', labelen: 'Ústav' },
        {
            value: 'QJWK',
            labelcz: 'Rada pro veřejný dohled nad auditem',
            labelen: 'Rada pro veřejný dohled nad auditem'
        },
        {
            value: 'QQ49',
            labelcz: 'Zdravotní pojišťovna (mimo VZP)',
            labelen: 'Zdravotní pojišťovna (mimo VZP)'
        },
        { value: 'QS6A', labelcz: 'Nadační fond', labelen: 'Nadační fond' },
        {
            value: 'R2XE',
            labelcz: 'Organizační jednotka mezinárodní nevládní organizace',
            labelen: 'Organizační jednotka mezinárodní nevládní organizace'
        },
        {
            value: 'RBGQ',
            labelcz: 'Evropské hospodářské zájmové sdružení',
            labelen: 'Evropské hospodářské zájmové sdružení'
        },
        {
            value: 'RHFQ',
            labelcz: 'Družstevní podnik (s 1 zakladatelem)',
            labelen: 'Družstevní podnik (s 1 zakladatelem)'
        },
        { value: 'RP0E', labelcz: 'Obecní podnik', labelen: 'Obecní podnik' },
        {
            value: 'T1FT',
            labelcz: 'Evropská družstevní společnost',
            labelen: 'Evropská družstevní společnost'
        },
        { value: 'T3Q1', labelcz: 'Bytové družstvo', labelen: 'Bytové družstvo' },
        {
            value: 'TNBA',
            labelcz: 'Odštěpný závod zahraniční právnické osoby',
            labelen: 'Odštěpný závod zahraniční právnické osoby'
        },
        {
            value: 'U95A',
            labelcz: 'Odštěpný závod zahraniční fyzické osoby',
            labelen: 'Odštěpný závod zahraniční fyzické osoby'
        },
        { value: 'UFDA', labelcz: 'Národní podnik', labelen: 'Národní podnik' },
        {
            value: 'V6YH',
            labelcz: 'Společná zájmová organizace družstev',
            labelen: 'Společná zájmová organizace družstev'
        },
        {
            value: 'VIE3',
            labelcz: 'Zájmové sdružení právnických osob',
            labelen: 'Zájmové sdružení právnických osob'
        },
        {
            value: 'VQU7',
            labelcz: 'Organizační složka zahraniční nadace',
            labelen: 'Organizační složka zahraniční nadace'
        },
        {
            value: 'WJ30',
            labelcz: 'Družstevní podnik zemědělský',
            labelen: 'Družstevní podnik zemědělský'
        },
        {
            value: 'WL83',
            labelcz: 'Zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích',
            labelen: 'Zvláštní organizace pro zastoupení českých zájmů v mezinárodních nevládních organizacích'
        },
        {
            value: 'WO0T',
            labelcz: 'Pobočná mezinárodní odborová organizace',
            labelen: 'Pobočná mezinárodní odborová organizace'
        },
        { value: 'WUFK', labelcz: 'Odštěpný závod', labelen: 'Odštěpný závod' },
        {
            value: 'WVZF',
            labelcz: 'Účelová zahraničně obchodní organizace',
            labelen: 'Účelová zahraničně obchodní organizace'
        },
        {
            value: 'XG70',
            labelcz: 'Právnikcá osoba zřízená zvláštním zákonem zapisovaná do veřejného rejstříku',
            labelen: 'Právnikcá osoba zřízená zvláštním zákonem zapisovaná do veřejného rejstříku'
        },
        {
            value: 'XRK7',
            labelcz: 'Politická strana, politické hnutí',
            labelen: 'Politická strana, politické hnutí'
        },
        { value: 'Y18E', labelcz: 'Společný podnik', labelen: 'Společný podnik' },
        {
            value: 'Z3BF',
            labelcz: 'Zemědělské družstvo',
            labelen: 'Zemědělské družstvo'
        },
        {
            value: 'ZQO8',
            labelcz: 'Evropská společnost',
            labelen: 'Evropská společnost'
        },
        { value: 'ZU32', labelcz: 'Jiné družstvo', labelen: 'Jiné družstvo' }
    ],
    DK: [
        { value: '1MWR', labelcz: 'Fond', labelen: 'Fond' },
        {
            value: '5QS7',
            labelcz: 'Iværksætterselskab',
            labelen: 'Iværksætterselskab'
        },
        { value: '7WRN', labelcz: 'Interessentskab', labelen: 'Interessentskab' },
        { value: '9KSX', labelcz: 'Partnerselskab', labelen: 'Partnerselskab' },
        {
            value: 'FUKI',
            labelcz: 'Enkeltmandsvirksomhed',
            labelen: 'Enkeltmandsvirksomhed'
        },
        {
            value: 'FW7S',
            labelcz: 'Europæisk andelsselskab',
            labelen: 'Europæisk andelsselskab'
        },
        {
            value: 'GULL',
            labelcz: 'Selskab med begrænset ansvar',
            labelen: 'Selskab med begrænset ansvar'
        },
        { value: 'H8VP', labelcz: 'Anpartsselskab', labelen: 'Anpartsselskab' },
        {
            value: 'LWOD',
            labelcz: 'Medarbejderinvesteringsselskab',
            labelen: 'Medarbejderinvesteringsselskab'
        },
        { value: 'NUL8', labelcz: 'Kommanditselskab', labelen: 'Kommanditselskab' },
        {
            value: 'PZ6Y',
            labelcz: 'Andelsselskab med begrænset ansvar',
            labelen: 'Andelsselskab med begrænset ansvar'
        },
        {
            value: 'TB2C',
            labelcz: 'Europæisk økonomisk firmagruppe',
            labelen: 'Europæisk økonomisk firmagruppe'
        },
        {
            value: 'UA1O',
            labelcz: 'Europæisk selskab',
            labelen: 'Europæisk selskab'
        },
        {
            value: 'WU7R',
            labelcz: 'Forening med begrænset ansvar',
            labelen: 'Forening med begrænset ansvar'
        },
        { value: 'ZRPO', labelcz: 'Aktieselskab', labelen: 'Aktieselskab' }
    ],
    DO: [
        { value: '3ZBR', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' },
        {
            value: '8WQ9',
            labelcz: 'Sociedad en Comandita Simple',
            labelen: 'Sociedad en Comandita Simple'
        },
        {
            value: 'B35X',
            labelcz: 'Sociedad en Participación(sin personalidad jurídica)',
            labelen: 'Sociedad en Participación(sin personalidad jurídica)'
        },
        {
            value: 'DQAU',
            labelcz: 'Sociedad Anónima Simplificada',
            labelen: 'Sociedad Anónima Simplificada'
        },
        {
            value: 'K4CD',
            labelcz: 'Empresa Individual de Responsabilidad Limitada ',
            labelen: 'Empresa Individual de Responsabilidad Limitada '
        },
        {
            value: 'LSWY',
            labelcz: 'Sociedad en Nombre Colectivo',
            labelen: 'Sociedad en Nombre Colectivo'
        },
        {
            value: 'SWO8',
            labelcz: 'Sociedad de Responsaibilidad Limitada',
            labelen: 'Sociedad de Responsaibilidad Limitada'
        },
        {
            value: 'T4LC',
            labelcz: 'Sociedad en Comandita por Acciones',
            labelen: 'Sociedad en Comandita por Acciones'
        }
    ],
    EC: [
        {
            value: '6TPE',
            labelcz: 'Compañía en nombre colectivo',
            labelen: 'Compañía en nombre colectivo'
        },
        {
            value: 'FKVG',
            labelcz: 'Compañía en Comandita Simple y dividida por acciones',
            labelen: 'Compañía en Comandita Simple y dividida por acciones'
        },
        { value: 'J3T2', labelcz: 'Compañía Anónima', labelen: 'Compañía Anónima' },
        {
            value: 'N9QH',
            labelcz: 'Compañía de Economía Mixta',
            labelen: 'Compañía de Economía Mixta'
        },
        {
            value: 'XOAD',
            labelcz: 'Compañía de Responsabilidad Limitada',
            labelen: 'Compañía de Responsabilidad Limitada'
        }
    ],
    EE: [
        { value: '1NKP', labelcz: 'Sihtasutus', labelen: 'Sihtasutus' },
        {
            value: '3UPJ',
            labelcz: 'Füüsilisest isikust ettevõtja',
            labelen: 'Füüsilisest isikust ettevõtja'
        },
        { value: '6I0P', labelcz: 'Hooneühistu', labelen: 'Hooneühistu' },
        { value: '752Q', labelcz: 'Euroopa äriühing', labelen: 'Euroopa äriühing' },
        { value: '8ZQE', labelcz: 'Korteriühistu', labelen: 'Korteriühistu' },
        { value: '9LJA', labelcz: 'Aktsiaselts', labelen: 'Aktsiaselts' },
        { value: 'CKOS', labelcz: 'Usuline ühendus', labelen: 'Usuline ühendus' },
        { value: 'GA3A', labelcz: 'Erakond', labelen: 'Erakond' },
        { value: 'I1UP', labelcz: 'Täisühing', labelen: 'Täisühing' },
        { value: 'J34T', labelcz: 'Ametiühing', labelen: 'Ametiühing' },
        { value: 'JC0Y', labelcz: 'Osaühing', labelen: 'Osaühing' },
        {
            value: 'LA47',
            labelcz: 'Euroopa majandushuviühing',
            labelen: 'Euroopa majandushuviühing'
        },
        { value: 'LVEQ', labelcz: 'Usaldusühing', labelen: 'Usaldusühing' },
        { value: 'PMOF', labelcz: 'Loomeliit', labelen: 'Loomeliit' },
        {
            value: 'PRTB',
            labelcz: 'Mittetulundusühing',
            labelen: 'Mittetulundusühing'
        },
        { value: 'RXTT', labelcz: 'Euroopa ühistu', labelen: 'Euroopa ühistu' },
        { value: 'VSEV', labelcz: 'Tulundusühistu', labelen: 'Tulundusühistu' }
    ],
    FI: [
        { value: '1AFG', labelcz: 'Muu yhtiö', labelen: 'Muu yhtiö' },
        {
            value: '1YIR',
            labelcz: 'Metsänhoitoyhdistys',
            labelen: 'Metsänhoitoyhdistys'
        },
        { value: '2RK5', labelcz: 'Kunta', labelen: 'Kunta' },
        { value: '37GR', labelcz: 'Elinkeinoyhtymä', labelen: 'Elinkeinoyhtymä' },
        {
            value: '4H61',
            labelcz: 'Keskinäinen vakuutusyhtiö',
            labelen: 'Keskinäinen vakuutusyhtiö'
        },
        { value: '5WI2', labelcz: 'Eläkesäätiö', labelen: 'Eläkesäätiö' },
        { value: '6PEQ', labelcz: 'Paikallisyhteisö', labelen: 'Paikallisyhteisö' },
        { value: '760X', labelcz: 'Muu yhdistys', labelen: 'Muu yhdistys' },
        { value: '883O', labelcz: 'Sivuliike', labelen: 'Sivuliike' },
        {
            value: '8HGS',
            labelcz: 'Erityislainsäädäntöön perustuva yhdistys',
            labelen: 'Erityislainsäädäntöön perustuva yhdistys'
        },
        {
            value: '8WJ7',
            labelcz: 'Keskinäinen kiinteistöosakeyhtiö',
            labelen: 'Keskinäinen kiinteistöosakeyhtiö'
        },
        { value: '97PB', labelcz: 'Vakuutuskassa', labelen: 'Vakuutuskassa' },
        { value: '9AUC', labelcz: 'Vakuutusyhdistys', labelen: 'Vakuutusyhdistys' },
        {
            value: 'BQ19',
            labelcz: 'Laivanisännistöyhtiö',
            labelen: 'Laivanisännistöyhtiö'
        },
        {
            value: 'C51L',
            labelcz: 'Eurooppalainen taloudellinen etuyhtymä sivutoimipaikka',
            labelen: 'Eurooppalainen taloudellinen etuyhtymä sivutoimipaikka'
        },
        {
            value: 'DAFV',
            labelcz: 'Vakuutusosakeyhtiö',
            labelen: 'Vakuutusosakeyhtiö'
        },
        { value: 'DKUW', labelcz: 'Osakeyhtiö', labelen: 'Osakeyhtiö' },
        {
            value: 'DL9Z',
            labelcz: 'Ulkomainen yhteisö',
            labelen: 'Ulkomainen yhteisö'
        },
        { value: 'DMT8', labelcz: 'Työeläkekassa', labelen: 'Työeläkekassa' },
        {
            value: 'EDN7',
            labelcz: 'Taloudellinen yhdistys',
            labelen: 'Taloudellinen yhdistys'
        },
        {
            value: 'EDZP',
            labelcz: 'Ylioppilaskunta tai osakunta',
            labelen: 'Ylioppilaskunta tai osakunta'
        },
        { value: 'EE90', labelcz: 'Osuuskunta', labelen: 'Osuuskunta' },
        {
            value: 'EMC8',
            labelcz: 'Muu taloudellinen yhdistys',
            labelen: 'Muu taloudellinen yhdistys'
        },
        {
            value: 'HBR3',
            labelcz: 'Julkinen keskinäinen vakuutusyhtiö',
            labelen: 'Julkinen keskinäinen vakuutusyhtiö'
        },
        {
            value: 'HEOB',
            labelcz: 'Kommandiittiyhtiö',
            labelen: 'Kommandiittiyhtiö'
        },
        {
            value: 'HNWB',
            labelcz: 'Eurooppalainen taloudellinen etuyhtymä',
            labelen: 'Eurooppalainen taloudellinen etuyhtymä'
        },
        {
            value: 'HTT9',
            labelcz: 'Erillishallinnollinen valtion laitos',
            labelen: 'Erillishallinnollinen valtion laitos'
        },
        {
            value: 'IX7U',
            labelcz: 'Asukashallintoalue',
            labelen: 'Asukashallintoalue'
        },
        {
            value: 'IYF9',
            labelcz: 'Evankelis-luterilainen kirkko',
            labelen: 'Evankelis-luterilainen kirkko'
        },
        {
            value: 'JI3A',
            labelcz: 'Keskinäinen vahinkovakuutusyhdistys',
            labelen: 'Keskinäinen vahinkovakuutusyhdistys'
        },
        {
            value: 'K09E',
            labelcz: 'Yksityinen elinkeinonharjoittaja',
            labelen: 'Yksityinen elinkeinonharjoittaja'
        },
        {
            value: 'K2G8',
            labelcz: 'Muut oikeushenkilöt',
            labelen: 'Muut oikeushenkilöt'
        },
        {
            value: 'K6VE',
            labelcz: 'Julkinen osakeyhtiö',
            labelen: 'Julkinen osakeyhtiö'
        },
        {
            value: 'KHI5',
            labelcz: 'Julkinen vakuutusosakeyhtiö',
            labelen: 'Julkinen vakuutusosakeyhtiö'
        },
        { value: 'L7XJ', labelcz: 'Paliskunta', labelen: 'Paliskunta' },
        {
            value: 'LBQS',
            labelcz: 'Muu yhteisvastuullinen pidätysvelvollinen',
            labelen: 'Muu yhteisvastuullinen pidätysvelvollinen'
        },
        {
            value: 'MBPY',
            labelcz: 'Asumisoikeusyhdistys',
            labelen: 'Asumisoikeusyhdistys'
        },
        {
            value: 'MRW9',
            labelcz: 'Muu julkisoikeudellinen oikeushenkilö',
            labelen: 'Muu julkisoikeudellinen oikeushenkilö'
        },
        {
            value: 'N3LC',
            labelcz: 'Rekisteröity uskonnollinen yhdyskunta',
            labelen: 'Rekisteröity uskonnollinen yhdyskunta'
        },
        { value: 'NV7C', labelcz: 'Muu säätiö', labelen: 'Muu säätiö' },
        {
            value: 'OXLO',
            labelcz: 'Valtion liikelaitos',
            labelen: 'Valtion liikelaitos'
        },
        { value: 'PPMX', labelcz: 'Avoin yhtiö', labelen: 'Avoin yhtiö' },
        { value: 'R39F', labelcz: 'Kauppakamari', labelen: 'Kauppakamari' },
        {
            value: 'R5ZC',
            labelcz: 'Eurooppaosuuskunnan kiinteä toimipaikka',
            labelen: 'Eurooppaosuuskunnan kiinteä toimipaikka'
        },
        { value: 'R6UB', labelcz: 'Verotusyhtymä', labelen: 'Verotusyhtymä' },
        { value: 'SDPE', labelcz: 'Työttömyyskassa', labelen: 'Työttömyyskassa' },
        { value: 'SJL9', labelcz: 'Osuuspankki', labelen: 'Osuuspankki' },
        { value: 'SKGX', labelcz: 'Yhteisetuudet', labelen: 'Yhteisetuudet' },
        {
            value: 'SQS1',
            labelcz: 'Ahvenanmaan maakunta ja sen virastot',
            labelen: 'Ahvenanmaan maakunta ja sen virastot'
        },
        {
            value: 'SUHV',
            labelcz: 'Muu verotuksen yksikkö',
            labelen: 'Muu verotuksen yksikkö'
        },
        {
            value: 'T31U',
            labelcz: 'Kuntainliiton liikelaitos',
            labelen: 'Kuntainliiton liikelaitos'
        },
        {
            value: 'UAV1',
            labelcz: 'Eurooppaosuuskunta',
            labelen: 'Eurooppaosuuskunta'
        },
        { value: 'UMF0', labelcz: 'Konkurssipesä', labelen: 'Konkurssipesä' },
        {
            value: 'UXEW',
            labelcz: 'Aatteellinen yhdistys',
            labelen: 'Aatteellinen yhdistys'
        },
        {
            value: 'V0TJ',
            labelcz: 'Asunto-osakeyhtiö',
            labelen: 'Asunto-osakeyhtiö'
        },
        {
            value: 'V42B',
            labelcz: 'Ortodoksinen kirkko',
            labelen: 'Ortodoksinen kirkko'
        },
        {
            value: 'VKKN',
            labelcz: 'Eurooppaosuuspankki',
            labelen: 'Eurooppaosuuspankki'
        },
        { value: 'VOTI', labelcz: 'Kuntayhtymä', labelen: 'Kuntayhtymä' },
        {
            value: 'XGKW',
            labelcz: 'Ahvenanmaan liikelaitos',
            labelen: 'Ahvenanmaan liikelaitos'
        },
        { value: 'XJH3', labelcz: 'Eurooppayhtiö', labelen: 'Eurooppayhtiö' },
        { value: 'YK5G', labelcz: 'Säätiö', labelen: 'Säätiö' },
        { value: 'Z38E', labelcz: 'Säästöpankki', labelen: 'Säästöpankki' },
        { value: 'ZMTL', labelcz: 'Kuolinpesä', labelen: 'Kuolinpesä' }
    ],
    FR: [
        {
            value: '157O',
            labelcz: "Régie d'une collectivité locale à caractère administratif",
            labelen: "Régie d'une collectivité locale à caractère administratif"
        },
        { value: '1B88', labelcz: 'SCP de médecins', labelen: 'SCP de médecins' },
        {
            value: '1GNM',
            labelcz: 'Syndicat de salariés',
            labelen: 'Syndicat de salariés'
        },
        {
            value: '1L24',
            labelcz: 'Autre société civile',
            labelen: 'Autre société civile'
        },
        {
            value: '1NF1',
            labelcz: "SA nationale à conseil d'administration",
            labelen: "SA nationale à conseil d'administration"
        },
        {
            value: '1Q16',
            labelcz: 'Société créée de fait entre personnes physiques',
            labelen: 'Société créée de fait entre personnes physiques'
        },
        {
            value: '1Y0C',
            labelcz: "SARL d'attribution",
            labelen: "SARL d'attribution"
        },
        {
            value: '211B',
            labelcz: 'Société coopérative agricole',
            labelen: 'Société coopérative agricole'
        },
        {
            value: '29FA',
            labelcz: 'Institution interrégionale ou entente',
            labelen: 'Institution interrégionale ou entente'
        },
        {
            value: '2N4L',
            labelcz: '(Autre) Collectivité territoriale',
            labelen: '(Autre) Collectivité territoriale'
        },
        {
            value: '2NL6',
            labelcz: 'État, collectivité ou établissement public étranger',
            labelen: 'État, collectivité ou établissement public étranger'
        },
        {
            value: '2ONM',
            labelcz: "SA d'attribution à directoire",
            labelen: "SA d'attribution à directoire"
        },
        {
            value: '2WMP',
            labelcz: 'Autre personne morale de droit administratif',
            labelen: 'Autre personne morale de droit administratif'
        },
        { value: '2XIK', labelcz: 'Mutuelle', labelen: 'Mutuelle' },
        {
            value: '34QS',
            labelcz: 'Autre personne morale de droit privé',
            labelen: 'Autre personne morale de droit privé'
        },
        {
            value: '3AZY',
            labelcz: "Coopérative d'utilisation de matériel agricole en commun (CUMA)",
            labelen: "Coopérative d'utilisation de matériel agricole en commun (CUMA)"
        },
        {
            value: '3FCU',
            labelcz: "Société d'exercice libéral par action simplifiée",
            labelen: "Société d'exercice libéral par action simplifiée"
        },
        {
            value: '3NJL',
            labelcz: 'Autre personne de droit privé inscrite au registre du commerce et des sociétés',
            labelen: 'Autre personne de droit privé inscrite au registre du commerce et des sociétés'
        },
        { value: '3OK3', labelcz: 'SCP de notaires', labelen: 'SCP de notaires' },
        {
            value: '3S6E',
            labelcz: "Service départemental d'incendie et de secours (SDIS)",
            labelen: "Service départemental d'incendie et de secours (SDIS)"
        },
        {
            value: '3XTE',
            labelcz: 'SARL coopérative de consommation',
            labelen: 'SARL coopérative de consommation'
        },
        {
            value: '487E',
            labelcz: "Établissement public local d'enseignement",
            labelen: "Établissement public local d'enseignement"
        },
        {
            value: '491H',
            labelcz: 'Association non déclarée',
            labelen: 'Association non déclarée'
        },
        {
            value: '4DZU',
            labelcz: 'Autre SARL coopérative',
            labelen: 'Autre SARL coopérative'
        },
        {
            value: '4H0F',
            labelcz: 'Autre établissement public local de coopération non spécialisé ou entente',
            labelen: 'Autre établissement public local de coopération non spécialisé ou entente'
        },
        {
            value: '4JS0',
            labelcz: 'Association syndicale autorisée',
            labelen: 'Association syndicale autorisée'
        },
        {
            value: '4RT7',
            labelcz: "SA de HLM à conseil d'administration",
            labelen: "SA de HLM à conseil d'administration"
        },
        {
            value: '4TNX',
            labelcz: 'Profession libérale',
            labelen: 'Profession libérale'
        },
        {
            value: '4VD7',
            labelcz: "Pôle d'équilibre territorial et rural (PETR)",
            labelen: "Pôle d'équilibre territorial et rural (PETR)"
        },
        {
            value: '59F9',
            labelcz: 'Groupement foncier agricole',
            labelen: 'Groupement foncier agricole'
        },
        {
            value: '5AJO',
            labelcz: "Caisse d'Épargne et de Prévoyance",
            labelen: "Caisse d'Épargne et de Prévoyance"
        },
        { value: '5H68', labelcz: 'Commerçant', labelen: 'Commerçant' },
        {
            value: '5K0Q',
            labelcz: 'Établissement public local social et médico-social',
            labelen: 'Établissement public local social et médico-social'
        },
        {
            value: '5VCF',
            labelcz: 'SA à directoire (s.a.i.)',
            labelen: 'SA à directoire (s.a.i.)'
        },
        {
            value: '61WE',
            labelcz: 'Institution de retraite supplémentaire',
            labelen: 'Institution de retraite supplémentaire'
        },
        {
            value: '66JQ',
            labelcz: 'Syndicat de copropriété',
            labelen: 'Syndicat de copropriété'
        },
        {
            value: '6CHY',
            labelcz: 'SAS, société par actions simplifiée',
            labelen: 'SAS, société par actions simplifiée'
        },
        {
            value: '6CJJ',
            labelcz: 'SCP de géomètres experts',
            labelen: 'SCP de géomètres experts'
        },
        {
            value: '6DYI',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)',
            labelen:
                'Société de Participations Financières de Profession Libérale Société à responsabilité limitée (SPFPL SARL)'
        },
        {
            value: '6IIE',
            labelcz: "SA coopérative (d'intérêt) maritime à conseil d'administration",
            labelen: "SA coopérative (d'intérêt) maritime à conseil d'administration"
        },
        {
            value: '6KWU',
            labelcz: "Société d'exercice libéral en commandite par actions",
            labelen: "Société d'exercice libéral en commandite par actions"
        },
        {
            value: '6RUE',
            labelcz: "Groupement européen d'intérêt économique (GEIE)",
            labelen: "Groupement européen d'intérêt économique (GEIE)"
        },
        {
            value: '6SYJ',
            labelcz: 'SA de HLM à directoire',
            labelen: 'SA de HLM à directoire'
        },
        {
            value: '6YHU',
            labelcz: "SA d'intérêt collectif agricole (SICA) à conseil d'administration",
            labelen: "SA d'intérêt collectif agricole (SICA) à conseil d'administration"
        },
        {
            value: '74HH',
            labelcz: 'SCP de vétérinaires',
            labelen: 'SCP de vétérinaires'
        },
        {
            value: '7O94',
            labelcz: 'Groupement forestier',
            labelen: 'Groupement forestier'
        },
        {
            value: '7SZH',
            labelcz: 'Autre groupement de droit privé non doté de la personnalité morale',
            labelen: 'Autre groupement de droit privé non doté de la personnalité morale'
        },
        {
            value: '7UHA',
            labelcz: "Collectivité et territoire d'Outre Mer",
            labelen: "Collectivité et territoire d'Outre Mer"
        },
        {
            value: '82QO',
            labelcz: "Service déconcentré de l'État à compétence (inter) départementale",
            labelen: "Service déconcentré de l'État à compétence (inter) départementale"
        },
        {
            value: '87VO',
            labelcz: 'Safer anonyme à directoire',
            labelen: 'Safer anonyme à directoire'
        },
        {
            value: '8FZW',
            labelcz: 'SCP de conseils juridiques',
            labelen: 'SCP de conseils juridiques'
        },
        {
            value: '8G07',
            labelcz: '(Autre) Personne physique',
            labelen: '(Autre) Personne physique'
        },
        {
            value: '8GTU',
            labelcz: "(Autre) Service déconcentré de l'État à compétence territoriale",
            labelen: "(Autre) Service déconcentré de l'État à compétence territoriale"
        },
        {
            value: '8II5',
            labelcz: "Autre SA coopérative à conseil d'administration",
            labelen: "Autre SA coopérative à conseil d'administration"
        },
        {
            value: '8IWA',
            labelcz: 'Commune associée et commune déléguée',
            labelen: 'Commune associée et commune déléguée'
        },
        {
            value: '8LX5',
            labelcz: 'Autre régime de prévoyance sociale',
            labelen: 'Autre régime de prévoyance sociale'
        },
        {
            value: '8OKM',
            labelcz: "Service déconcentré à compétence nationale d'un ministère (hors Défense)",
            labelen: "Service déconcentré à compétence nationale d'un ministère (hors Défense)"
        },
        {
            value: '8R2G',
            labelcz: 'Société civile immobilière de construction-vente',
            labelen: 'Société civile immobilière de construction-vente'
        },
        {
            value: '8TYA',
            labelcz: 'Autre SA coopérative à directoire',
            labelen: 'Autre SA coopérative à directoire'
        },
        {
            value: '8VDW',
            labelcz: "Société d'assurance à forme mutuelle",
            labelen: "Société d'assurance à forme mutuelle"
        },
        {
            value: '8VWR',
            labelcz: "SA d'économie mixte à conseil d'administration",
            labelen: "SA d'économie mixte à conseil d'administration"
        },
        {
            value: '8WH8',
            labelcz: 'Autre personne morale de droit étranger',
            labelen: 'Autre personne morale de droit étranger'
        },
        {
            value: '8XDK',
            labelcz: "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration",
            labelen: "SA d'aménagement foncier et d'équipement rural (SAFER) à conseil d'administration"
        },
        { value: '94WO', labelcz: 'District urbain', labelen: 'District urbain' },
        {
            value: '97PZ',
            labelcz: "SARL coopérative d'intérêt maritime",
            labelen: "SARL coopérative d'intérêt maritime"
        },
        {
            value: '9HC8',
            labelcz: 'Société en participation entre personnes physiques',
            labelen: 'Société en participation entre personnes physiques'
        },
        {
            value: '9KU7',
            labelcz: 'Union de sociétés coopératives agricoles',
            labelen: 'Union de sociétés coopératives agricoles'
        },
        {
            value: '9N1F',
            labelcz: "SA d'intérêt collectif agricole (SICA)",
            labelen: "SA d'intérêt collectif agricole (SICA)"
        },
        {
            value: '9O0S',
            labelcz: 'Association fonciére urbaine',
            labelen: 'Association fonciére urbaine'
        },
        { value: '9T5S', labelcz: 'Fondation', labelen: 'Fondation' },
        {
            value: 'A0VZ',
            labelcz: "SCP d'architectes",
            labelen: "SCP d'architectes"
        },
        {
            value: 'AHBR',
            labelcz: 'SA à participation ouvrière à directoire',
            labelen: 'SA à participation ouvrière à directoire'
        },
        {
            value: 'AMFI',
            labelcz: 'Autorité constitutionnelle',
            labelen: 'Autorité constitutionnelle'
        },
        {
            value: 'B645',
            labelcz: "SA d'attribution à conseil d'administration",
            labelen: "SA d'attribution à conseil d'administration"
        },
        {
            value: 'B7I7',
            labelcz: "SA coopérative artisanale à conseil d'administration",
            labelen: "SA coopérative artisanale à conseil d'administration"
        },
        {
            value: 'BAK2',
            labelcz: 'Exploitation agricole à responsabilité limitée',
            labelen: 'Exploitation agricole à responsabilité limitée'
        },
        {
            value: 'BAUQ',
            labelcz: "SA de crédit immobilier à conseil d'administration",
            labelen: "SA de crédit immobilier à conseil d'administration"
        },
        { value: 'BDDP', labelcz: "SCP d'infirmiers", labelen: "SCP d'infirmiers" },
        {
            value: 'BEWI',
            labelcz: 'Association déclarée',
            labelen: 'Association déclarée'
        },
        {
            value: 'BRGA',
            labelcz: "SA immobilière d'investissement à conseil d'administration",
            labelen: "SA immobilière d'investissement à conseil d'administration"
        },
        {
            value: 'BYZF',
            labelcz: 'Paroisse hors zone concordataire',
            labelen: 'Paroisse hors zone concordataire'
        },
        {
            value: 'C42J',
            labelcz: 'SARL immobilière de gestion',
            labelen: 'SARL immobilière de gestion'
        },
        { value: 'C4D7', labelcz: 'Ensemble urbain', labelen: 'Ensemble urbain' },
        {
            value: 'CAX5',
            labelcz: 'Régime général de la Sécurité Sociale',
            labelen: 'Régime général de la Sécurité Sociale'
        },
        {
            value: 'CBO2',
            labelcz: 'Service du ministère de la Défense',
            labelen: 'Service du ministère de la Défense'
        },
        {
            value: 'CF56',
            labelcz: 'Mutualité sociale agricole',
            labelen: 'Mutualité sociale agricole'
        },
        {
            value: 'CNSS',
            labelcz: 'Société en participation de professions libérales',
            labelen: 'Société en participation de professions libérales'
        },
        {
            value: 'CNXL',
            labelcz: 'Artisan-commerçant',
            labelen: 'Artisan-commerçant'
        },
        { value: 'CQJI', labelcz: 'Région', labelen: 'Région' },
        {
            value: 'CVH6',
            labelcz: "SARL d'aménagement foncier et d'équipement rural (SAFER)",
            labelen: "SARL d'aménagement foncier et d'équipement rural (SAFER)"
        },
        {
            value: 'D2I2',
            labelcz: 'Syndicat intercommunal à vocation multiple (SIVOM)',
            labelen: 'Syndicat intercommunal à vocation multiple (SIVOM)'
        },
        {
            value: 'DEG4',
            labelcz: 'Société en commandite par actions',
            labelen: 'Société en commandite par actions'
        },
        {
            value: 'DRQM',
            labelcz: "SA coopérative de construction à conseil d'administration",
            labelen: "SA coopérative de construction à conseil d'administration"
        },
        {
            value: 'DTAX',
            labelcz: 'Autre organisme mutualiste',
            labelen: 'Autre organisme mutualiste'
        },
        {
            value: 'DWYD',
            labelcz: "Association déclarée d'insertion par l'économique",
            labelen: "Association déclarée d'insertion par l'économique"
        },
        {
            value: 'DXQH',
            labelcz: 'Société civile foncière',
            labelen: 'Société civile foncière'
        },
        {
            value: 'E0YF',
            labelcz: "SA coopérative d'intérêt maritime à directoire",
            labelen: "SA coopérative d'intérêt maritime à directoire"
        },
        {
            value: 'E6YB',
            labelcz: 'Caisse (fédérale) de crédit mutuel',
            labelen: 'Caisse (fédérale) de crédit mutuel'
        },
        {
            value: 'EABD',
            labelcz: 'Société civile coopérative entre médecins',
            labelen: 'Société civile coopérative entre médecins'
        },
        {
            value: 'EAC8',
            labelcz: 'Société coopérative de production de HLM anonyme à directoire',
            labelen: 'Société coopérative de production de HLM anonyme à directoire'
        },
        {
            value: 'ECUL',
            labelcz: 'Secteur de commune',
            labelen: 'Secteur de commune'
        },
        {
            value: 'EVYY',
            labelcz: 'Caisse de crédit maritime mutuel',
            labelen: 'Caisse de crédit maritime mutuel'
        },
        {
            value: 'EYRI',
            labelcz: 'Centre technique industriel ou comité professionnel du développement économique',
            labelen: 'Centre technique industriel ou comité professionnel du développement économique'
        },
        {
            value: 'F0B6',
            labelcz: 'Société en commandite simple coopérative',
            labelen: 'Société en commandite simple coopérative'
        },
        {
            value: 'F6SZ',
            labelcz: 'SA coopérative ouvrière de production (SCOP) à directoire',
            labelen: 'SA coopérative ouvrière de production (SCOP) à directoire'
        },
        {
            value: 'F72Z',
            labelcz: "Établissement public national à caractére industriel ou commercial doté d'un comptable public",
            labelen: "Établissement public national à caractére industriel ou commercial doté d'un comptable public"
        },
        {
            value: 'F8UD',
            labelcz: "SCP d'avoués d'appel",
            labelen: "SCP d'avoués d'appel"
        },
        {
            value: 'F93F',
            labelcz: "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration",
            labelen: "SA immobilière pour le commerce et l'industrie (SICOMI) à conseil d'administration"
        },
        {
            value: 'FBYB',
            labelcz: "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS",
            labelen: "Représentation ou agence commerciale d'état ou organisme public étranger immatriculé au RCS"
        },
        {
            value: 'FEEA',
            labelcz: "Établissement public national ayant fonction d'administration centrale",
            labelen: "Établissement public national ayant fonction d'administration centrale"
        },
        {
            value: 'FFQL',
            labelcz: 'Commune et commune nouvelle',
            labelen: 'Commune et commune nouvelle'
        },
        {
            value: 'FKG2',
            labelcz: 'Organisation internationale',
            labelen: 'Organisation internationale'
        },
        {
            value: 'FOUY',
            labelcz: 'SCP de commissaires aux comptes',
            labelen: 'SCP de commissaires aux comptes'
        },
        {
            value: 'FY0F',
            labelcz: 'Société civile immobilière',
            labelen: 'Société civile immobilière'
        },
        {
            value: 'FYBN',
            labelcz: "SARL mixte d'intérêt agricole (SMIA)",
            labelen: "SARL mixte d'intérêt agricole (SMIA)"
        },
        {
            value: 'G7Z2',
            labelcz: 'SARL coopérative de construction',
            labelen: 'SARL coopérative de construction'
        },
        {
            value: 'G8LP',
            labelcz: 'Sociétés Interprofessionnelles de Soins Ambulatoires ',
            labelen: 'Sociétés Interprofessionnelles de Soins Ambulatoires '
        },
        {
            value: 'G98S',
            labelcz: 'Ordre professionnel ou assimilé',
            labelen: 'Ordre professionnel ou assimilé'
        },
        {
            value: 'GFN6',
            labelcz: "SA coopérative de commerçants-détaillants à conseil d'administration",
            labelen: "SA coopérative de commerçants-détaillants à conseil d'administration"
        },
        {
            value: 'GJJJ',
            labelcz: "Société d'exercice libéral à responsabilité limitée à associé unique",
            labelen: "Société d'exercice libéral à responsabilité limitée à associé unique"
        },
        {
            value: 'GLN8',
            labelcz: "Centre Intercommunal d'action sociale (CIAS)",
            labelen: "Centre Intercommunal d'action sociale (CIAS)"
        },
        {
            value: 'GQV4',
            labelcz: "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire",
            labelen: "SA immobilière pour le commerce et l'industrie (SICOMI) à directoire"
        },
        {
            value: 'GXL6',
            labelcz: "Autre établissement public national d'enseignement",
            labelen: "Autre établissement public national d'enseignement"
        },
        {
            value: 'GZCQ',
            labelcz: 'SCP de greffiers de tribunal de commerce',
            labelen: 'SCP de greffiers de tribunal de commerce'
        },
        {
            value: 'H1U2',
            labelcz: 'Société en nom collectif',
            labelen: 'Société en nom collectif'
        },
        {
            value: 'H3Z4',
            labelcz: 'SA coopérative de transport à directoire',
            labelen: 'SA coopérative de transport à directoire'
        },
        {
            value: 'H3ZD',
            labelcz: "SARL d'intérêt collectif agricole (SICA)",
            labelen: "SARL d'intérêt collectif agricole (SICA)"
        },
        {
            value: 'H4VR',
            labelcz: 'Société civile coopérative de consommation',
            labelen: 'Société civile coopérative de consommation'
        },
        {
            value: 'HA3N',
            labelcz: 'Caisse de crédit municipal',
            labelen: 'Caisse de crédit municipal'
        },
        {
            value: 'HATI',
            labelcz: 'Association intermédiaire',
            labelen: 'Association intermédiaire'
        },
        {
            value: 'HC8N',
            labelcz: 'SARL union de sociétés coopératives',
            labelen: 'SARL union de sociétés coopératives'
        },
        {
            value: 'HF2L',
            labelcz: 'Association de droit local (Bas-Rhin, Haut-Rhin et Moselle)',
            labelen: 'Association de droit local (Bas-Rhin, Haut-Rhin et Moselle)'
        },
        {
            value: 'HMEI',
            labelcz: 'Autre société civile coopérative',
            labelen: 'Autre société civile coopérative'
        },
        {
            value: 'HSYZ',
            labelcz: 'Autre société civile professionnelle',
            labelen: 'Autre société civile professionnelle'
        },
        {
            value: 'I0MH',
            labelcz: 'Société civile coopérative de construction',
            labelen: 'Société civile coopérative de construction'
        },
        {
            value: 'I8TE',
            labelcz: "SA mixte d'intérêt agricole (SMIA)",
            labelen: "SA mixte d'intérêt agricole (SMIA)"
        },
        {
            value: 'IAP3',
            labelcz: 'Syndicat intercommunal à vocation unique (SIVU)',
            labelen: 'Syndicat intercommunal à vocation unique (SIVU)'
        },
        {
            value: 'IC8G',
            labelcz: "SCP d'avocats aux conseils",
            labelen: "SCP d'avocats aux conseils"
        },
        {
            value: 'IC98',
            labelcz: 'SCP de commissaires-priseurs',
            labelen: 'SCP de commissaires-priseurs'
        },
        {
            value: 'IF7H',
            labelcz: "SA coopérative de consommation à conseil d'administration",
            labelen: "SA coopérative de consommation à conseil d'administration"
        },
        {
            value: 'IGSV',
            labelcz: 'Société civile laitière',
            labelen: 'Société civile laitière'
        },
        {
            value: 'IQR2',
            labelcz: "Société civile d'intérêt collectif agricole (SICA)",
            labelen: "Société civile d'intérêt collectif agricole (SICA)"
        },
        {
            value: 'J9OZ',
            labelcz: "Société d'exercice libéral à responsabilité limitée",
            labelen: "Société d'exercice libéral à responsabilité limitée"
        },
        {
            value: 'JBIQ',
            labelcz: 'Institution de prévoyance',
            labelen: 'Institution de prévoyance'
        },
        {
            value: 'JFET',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)',
            labelen:
                'Société de Participations Financières de Profession Libérale Société anonyme à Directoire (SPFPL SA à directoire)'
        },
        {
            value: 'JIYK',
            labelcz: 'Syndicat inter hospitalier',
            labelen: 'Syndicat inter hospitalier'
        },
        { value: 'JM1W', labelcz: 'SCP de dentistes', labelen: 'SCP de dentistes' },
        {
            value: 'JMO0',
            labelcz: 'Commission syndicale pour la gestion des biens indivis des communes',
            labelen: 'Commission syndicale pour la gestion des biens indivis des communes'
        },
        {
            value: 'JN2P',
            labelcz: 'SARL unipersonnelle',
            labelen: 'SARL unipersonnelle'
        },
        { value: 'JR7T', labelcz: 'SARL nationale', labelen: 'SARL nationale' },
        { value: 'JU82', labelcz: 'Ministére', labelen: 'Ministére' },
        {
            value: 'K39X',
            labelcz: "SA union de sociétés coopératives à conseil d'administration",
            labelen: "SA union de sociétés coopératives à conseil d'administration"
        },
        {
            value: 'K5KA',
            labelcz: "Régie d'une collectivité locale à caractère industriel ou commercial",
            labelen: "Régie d'une collectivité locale à caractère industriel ou commercial"
        },
        {
            value: 'K65D',
            labelcz: "SA à conseil d'administration (s.a.i.)",
            labelen: "SA à conseil d'administration (s.a.i.)"
        },
        {
            value: 'K69X',
            labelcz: 'SA de crédit immobilier à directoire',
            labelen: 'SA de crédit immobilier à directoire'
        },
        {
            value: 'K7XQ',
            labelcz: 'Établissement public national à caractére scientifique culturel et professionnel',
            labelen: 'Établissement public national à caractére scientifique culturel et professionnel'
        },
        {
            value: 'K99N',
            labelcz: 'Comité social économique d’établissement',
            labelen: 'Comité social économique d’établissement'
        },
        {
            value: 'KBEQ',
            labelcz: "Société civile immobilière d' accession progressive à la propriété",
            labelen: "Société civile immobilière d' accession progressive à la propriété"
        },
        {
            value: 'KCN5',
            labelcz: 'Etablissement public administratif, cercle et foyer dans les armées',
            labelen: 'Etablissement public administratif, cercle et foyer dans les armées'
        },
        { value: 'KFR1', labelcz: 'Artisan', labelen: 'Artisan' },
        {
            value: 'KMPN',
            labelcz: 'Établissement public national à caractére administratif',
            labelen: 'Établissement public national à caractére administratif'
        },
        {
            value: 'KQH7',
            labelcz: "Société civile d'attribution",
            labelen: "Société civile d'attribution"
        },
        {
            value: 'KS9B',
            labelcz: 'Syndicat patronal',
            labelen: 'Syndicat patronal'
        },
        {
            value: 'KWI4',
            labelcz: 'SCP de masseurs-kinésithérapeutes',
            labelen: 'SCP de masseurs-kinésithérapeutes'
        },
        {
            value: 'L25Z',
            labelcz: "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration",
            labelen: "Société anonyme mixte d'intérêt agricole (SMIA) à conseil d'administration"
        },
        {
            value: 'L6QO',
            labelcz: 'Régime spécial de Sécurité Sociale',
            labelen: 'Régime spécial de Sécurité Sociale'
        },
        {
            value: 'LARO',
            labelcz: 'Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle',
            labelen: 'Société par actions simplifiée à associé unique ou société par actions simplifiée unipersonnelle'
        },
        {
            value: 'LGME',
            labelcz: "SA à participation ouvrière à conseil d'administration",
            labelen: "SA à participation ouvrière à conseil d'administration"
        },
        {
            value: 'LU8S',
            labelcz: 'Associé gérant de Société',
            labelen: 'Associé gérant de Société'
        },
        {
            value: 'LUIN',
            labelcz: "SARL immobilière pour le commerce et l'industrie (SICOMI)",
            labelen: "SARL immobilière pour le commerce et l'industrie (SICOMI)"
        },
        {
            value: 'M1BJ',
            labelcz: 'Société civile de moyens',
            labelen: 'Société civile de moyens'
        },
        {
            value: 'M673',
            labelcz: "Société civile d'exploitation agricole",
            labelen: "Société civile d'exploitation agricole"
        },
        {
            value: 'MG2O',
            labelcz: 'Institution interdépartementale ou entente',
            labelen: 'Institution interdépartementale ou entente'
        },
        {
            value: 'MMA4',
            labelcz: 'SA union de sociétés coopératives à directoire',
            labelen: 'SA union de sociétés coopératives à directoire'
        },
        {
            value: 'MOUL',
            labelcz: 'Assurance mutuelle agricole',
            labelen: 'Assurance mutuelle agricole'
        },
        {
            value: 'MQPZ',
            labelcz: "Caisse d'épargne et de prévoyance à forme coopérative",
            labelen: "Caisse d'épargne et de prévoyance à forme coopérative"
        },
        {
            value: 'MQU9',
            labelcz: 'Organisme de placement collectif en valeurs mobilières sans personnalité morale',
            labelen: 'Organisme de placement collectif en valeurs mobilières sans personnalité morale'
        },
        {
            value: 'MX8J',
            labelcz: 'SA coopérative de commerçants-détaillants à directoire',
            labelen: 'SA coopérative de commerçants-détaillants à directoire'
        },
        {
            value: 'NBA8',
            labelcz: 'Autre établissement public national administratif à compétence territoriale limitée',
            labelen: 'Autre établissement public national administratif à compétence territoriale limitée'
        },
        {
            value: 'NFCV',
            labelcz: 'Association coopérative inscrite (droit local Alsace Moselle)',
            labelen: 'Association coopérative inscrite (droit local Alsace Moselle)'
        },
        {
            value: 'NM07',
            labelcz: "SA immobilière d'investissement à directoire",
            labelen: "SA immobilière d'investissement à directoire"
        },
        {
            value: 'NOI8',
            labelcz: "Communauté d'agglomération",
            labelen: "Communauté d'agglomération"
        },
        {
            value: 'NQCT',
            labelcz: '(Autre) Établissement public administratif local',
            labelen: '(Autre) Établissement public administratif local'
        },
        {
            value: 'NUMY',
            labelcz: 'SA coopérative artisanale à directoire',
            labelen: 'SA coopérative artisanale à directoire'
        },
        {
            value: 'OAGA',
            labelcz: 'Régime vieillesse ne dépendant pas du régime général de la Sécurité Sociale',
            labelen: 'Régime vieillesse ne dépendant pas du régime général de la Sécurité Sociale'
        },
        {
            value: 'OIQA',
            labelcz: 'Autre organisme professionnel',
            labelen: 'Autre organisme professionnel'
        },
        {
            value: 'OLJ1',
            labelcz: 'Syndicat mixte fermé',
            labelen: 'Syndicat mixte fermé'
        },
        {
            value: 'OSLZ',
            labelcz: 'Société coopérative de banque populaire',
            labelen: 'Société coopérative de banque populaire'
        },
        {
            value: 'OWUN',
            labelcz: 'Communauté de communes',
            labelen: 'Communauté de communes'
        },
        {
            value: 'P3J5',
            labelcz: "Centre communal d'action sociale",
            labelen: "Centre communal d'action sociale"
        },
        {
            value: 'P714',
            labelcz: 'Association fonciére de remembrement',
            labelen: 'Association fonciére de remembrement'
        },
        {
            value: 'PESN',
            labelcz: 'Indivision avec personne morale',
            labelen: 'Indivision avec personne morale'
        },
        {
            value: 'PL6V',
            labelcz: 'Établissement public local culturel',
            labelen: 'Établissement public local culturel'
        },
        { value: 'PWKL', labelcz: 'Congrégation', labelen: 'Congrégation' },
        { value: 'PZLG', labelcz: 'Métropole', labelen: 'Métropole' },
        {
            value: 'Q2A1',
            labelcz: 'Société commerciale étrangère immatriculée au RCS',
            labelen: 'Société commerciale étrangère immatriculée au RCS'
        },
        {
            value: 'Q634',
            labelcz: 'Indivision entre personnes physiques',
            labelen: 'Indivision entre personnes physiques'
        },
        {
            value: 'Q8E2',
            labelcz: 'Société en nom collectif coopérative',
            labelen: 'Société en nom collectif coopérative'
        },
        {
            value: 'QCWO',
            labelcz: "Groupement agricole d'exploitation en commun (GAEC)",
            labelen: "Groupement agricole d'exploitation en commun (GAEC)"
        },
        {
            value: 'QU3G',
            labelcz: "SA coopérative de production de HLM à conseil d'administration",
            labelen: "SA coopérative de production de HLM à conseil d'administration"
        },
        {
            value: 'QUB4',
            labelcz: 'Organisme consulaire',
            labelen: 'Organisme consulaire'
        },
        {
            value: 'QV2O',
            labelcz: "Société d'exercice libéral à forme anonyme à directoire",
            labelen: "Société d'exercice libéral à forme anonyme à directoire"
        },
        { value: 'QVPB', labelcz: 'Société anonyme', labelen: 'Société anonyme' },
        {
            value: 'R0B6',
            labelcz: "Groupement d'intérêt économique (GIE)",
            labelen: "Groupement d'intérêt économique (GIE)"
        },
        {
            value: 'R1JO',
            labelcz: 'Communauté urbaine',
            labelen: 'Communauté urbaine'
        },
        {
            value: 'R59A',
            labelcz: 'Société en commandite par actions coopérative',
            labelen: 'Société en commandite par actions coopérative'
        },
        {
            value: 'R6WQ',
            labelcz: 'Groupement de coopération sanitaire à gestion publique',
            labelen: 'Groupement de coopération sanitaire à gestion publique'
        },
        { value: 'RD0Z', labelcz: 'Fiducie', labelen: 'Fiducie' },
        {
            value: 'RFWH',
            labelcz: 'Groupement foncier et rural',
            labelen: 'Groupement foncier et rural'
        },
        {
            value: 'RNJZ',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)',
            labelen:
                'Société de Participations Financières de Profession Libérale Société en commandite par actions (SPFPL SCA)'
        },
        {
            value: 'RNSB',
            labelcz: 'Société étrangère non immatriculée au RCS',
            labelen: 'Société étrangère non immatriculée au RCS'
        },
        {
            value: 'RT39',
            labelcz: 'Société créée de fait avec personne morale',
            labelen: 'Société créée de fait avec personne morale'
        },
        { value: 'RT6Y', labelcz: 'Agent commercial', labelen: 'Agent commercial' },
        {
            value: 'RWMC',
            labelcz: 'Communauté de villes',
            labelen: 'Communauté de villes'
        },
        {
            value: 'S0X8',
            labelcz: 'Caisse de crédit agricole mutuel',
            labelen: 'Caisse de crédit agricole mutuel'
        },
        {
            value: 'S82R',
            labelcz:
                'Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)',
            labelen:
                'Société de Participations Financières de Profession Libérale Société par actions simplifiée (SPFPL SAS)'
        },
        {
            value: 'SMZ6',
            labelcz:
                "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)",
            labelen:
                "Société de Participations Financières de Profession Libérale Société anonyme à conseil d'administration (SPFPL SA à conseil d'administration)"
        },
        {
            value: 'SOXQ',
            labelcz: 'Société en libre partenariat',
            labelen: 'Société en libre partenariat'
        },
        {
            value: 'SSHN',
            labelcz: "Régime d'assurance chômage",
            labelen: "Régime d'assurance chômage"
        },
        {
            value: 'SWPX',
            labelcz: "SA coopérative de transport à conseil d'administration",
            labelen: "SA coopérative de transport à conseil d'administration"
        },
        {
            value: 'SZ63',
            labelcz: "Service déconcentré de l'État à compétence (inter) régionale",
            labelen: "Service déconcentré de l'État à compétence (inter) régionale"
        },
        { value: 'T25Y', labelcz: "SCP d'avocats", labelen: "SCP d'avocats" },
        {
            value: 'TGRE',
            labelcz: 'Caisse des écoles',
            labelen: 'Caisse des écoles'
        },
        {
            value: 'TNPO',
            labelcz: 'Exploitant agricole',
            labelen: 'Exploitant agricole'
        },
        {
            value: 'TOL2',
            labelcz: 'SA nationale à directoire',
            labelen: 'SA nationale à directoire'
        },
        {
            value: 'TPNT',
            labelcz: 'Société européenne',
            labelen: 'Société européenne'
        },
        {
            value: 'TUE5',
            labelcz: "Office public d'habitation à loyer modéré (OPHLM)",
            labelen: "Office public d'habitation à loyer modéré (OPHLM)"
        },
        {
            value: 'UFM7',
            labelcz: 'SA coopérative de construction à directoire',
            labelen: 'SA coopérative de construction à directoire'
        },
        {
            value: 'UHKH',
            labelcz: 'Société de caution mutuelle',
            labelen: 'Société de caution mutuelle'
        },
        {
            value: 'UQRY',
            labelcz: 'Ecole nationale non dotée de la personnalité morale',
            labelen: 'Ecole nationale non dotée de la personnalité morale'
        },
        {
            value: 'UUT8',
            labelcz: "SCP de directeurs de laboratoire d'analyse médicale",
            labelen: "SCP de directeurs de laboratoire d'analyse médicale"
        },
        {
            value: 'UV02',
            labelcz: "Service central d'un ministère",
            labelen: "Service central d'un ministère"
        },
        {
            value: 'UZY3',
            labelcz: "Établissement d'hospitalisation",
            labelen: "Établissement d'hospitalisation"
        },
        {
            value: 'V1Z5',
            labelcz: 'SARL coopérative ouvrière de production (SCOP)',
            labelen: 'SARL coopérative ouvrière de production (SCOP)'
        },
        {
            value: 'V5SV',
            labelcz: "Société civile coopérative d'intérêt maritime",
            labelen: "Société civile coopérative d'intérêt maritime"
        },
        {
            value: 'V6G1',
            labelcz: 'Régime maladie des non-salariés non agricoles',
            labelen: 'Régime maladie des non-salariés non agricoles'
        },
        {
            value: 'V9QP',
            labelcz: 'Société à responsabilité limitée (sans autre indication)',
            labelen: 'Société à responsabilité limitée (sans autre indication)'
        },
        {
            value: 'VBC7',
            labelcz: 'Institution Banque de France',
            labelen: 'Institution Banque de France'
        },
        {
            value: 'VBQP',
            labelcz: 'Fonds à forme sociétale à directoire',
            labelen: 'Fonds à forme sociétale à directoire'
        },
        {
            value: 'VD7Z',
            labelcz: 'Société en commandite simple',
            labelen: 'Société en commandite simple'
        },
        {
            value: 'VJV5',
            labelcz: "SARL d'économie mixte",
            labelen: "SARL d'économie mixte"
        },
        {
            value: 'VO18',
            labelcz: 'Établissement public local à caractére industriel ou commercial',
            labelen: 'Établissement public local à caractére industriel ou commercial'
        },
        {
            value: 'VTFS',
            labelcz: 'SARL coopérative artisanale',
            labelen: 'SARL coopérative artisanale'
        },
        {
            value: 'W3LD',
            labelcz: 'Groupement agricole foncier',
            labelen: 'Groupement agricole foncier'
        },
        {
            value: 'W4G1',
            labelcz: 'SARL coopérative de transport',
            labelen: 'SARL coopérative de transport'
        },
        {
            value: 'WGCY',
            labelcz: "Groupement d'employeurs",
            labelen: "Groupement d'employeurs"
        },
        { value: 'WXNU', labelcz: "SCP d'huissiers", labelen: "SCP d'huissiers" },
        {
            value: 'X78I',
            labelcz: "Fonds à forme sociétale à conseil d'administration",
            labelen: "Fonds à forme sociétale à conseil d'administration"
        },
        {
            value: 'XH8C',
            labelcz: "Association déclarée, reconnue d'utilité publique",
            labelen: "Association déclarée, reconnue d'utilité publique"
        },
        {
            value: 'XK4T',
            labelcz: 'Comité social économique d’entreprise',
            labelen: 'Comité social économique d’entreprise'
        },
        {
            value: 'XPX6',
            labelcz: "SA coopérative ouvrière de production (SCOP) à conseil d'administration",
            labelen: "SA coopérative ouvrière de production (SCOP) à conseil d'administration"
        },
        {
            value: 'XQBA',
            labelcz: 'Société en participation avec personne morale',
            labelen: 'Société en participation avec personne morale'
        },
        {
            value: 'Y1W1',
            labelcz: 'Section de commune',
            labelen: 'Section de commune'
        },
        { value: 'Y4VA', labelcz: 'Département', labelen: 'Département' },
        {
            value: 'Y7G8',
            labelcz: 'Caisse locale de crédit mutuel',
            labelen: 'Caisse locale de crédit mutuel'
        },
        {
            value: 'Y8WC',
            labelcz: 'Groupement de coopération sanitaire à gestion privée',
            labelen: 'Groupement de coopération sanitaire à gestion privée'
        },
        {
            value: 'YADL',
            labelcz: 'Autorité administrative ou publique indépendante',
            labelen: 'Autorité administrative ou publique indépendante'
        },
        {
            value: 'YHI5',
            labelcz: 'Pôle métropolitain',
            labelen: 'Pôle métropolitain'
        },
        {
            value: 'YJM5',
            labelcz: 'Officier public ou ministériel',
            labelen: 'Officier public ou ministériel'
        },
        {
            value: 'YUCL',
            labelcz: 'Institution de retraite complémentaire',
            labelen: 'Institution de retraite complémentaire'
        },
        {
            value: 'YX4E',
            labelcz: 'Société civile de placement collectif immobilier (SCPI)',
            labelen: 'Société civile de placement collectif immobilier (SCPI)'
        },
        {
            value: 'Z0JP',
            labelcz:
                "Établissement public national à caractére industriel ou commercial non doté d'un comptable public",
            labelen: "Établissement public national à caractére industriel ou commercial non doté d'un comptable public"
        },
        {
            value: 'Z2FQ',
            labelcz: "Groupement d'intérêt public (GIP)",
            labelen: "Groupement d'intérêt public (GIP)"
        },
        {
            value: 'Z5WG',
            labelcz: 'Groupement pastoral',
            labelen: 'Groupement pastoral'
        },
        {
            value: 'Z9K8',
            labelcz: "Association d'avocats à responsabilité professionnelle individuelle",
            labelen: "Association d'avocats à responsabilité professionnelle individuelle"
        },
        {
            value: 'ZECH',
            labelcz: 'Syndicat mixte ouvert',
            labelen: 'Syndicat mixte ouvert'
        },
        {
            value: 'ZM5P',
            labelcz: "SA d'économie mixte à directoire",
            labelen: "SA d'économie mixte à directoire"
        },
        {
            value: 'ZPEZ',
            labelcz: 'Association syndicale libre',
            labelen: 'Association syndicale libre'
        },
        {
            value: 'ZQ9B',
            labelcz: 'Exploitant public',
            labelen: 'Exploitant public'
        },
        {
            value: 'ZQIT',
            labelcz: 'SA coopérative de consommation à directoire',
            labelen: 'SA coopérative de consommation à directoire'
        },
        {
            value: 'ZXHJ',
            labelcz: "Société d'exercice libéral à forme anonyme à conseil d'administration",
            labelen: "Société d'exercice libéral à forme anonyme à conseil d'administration"
        },
        {
            value: 'ZY9X',
            labelcz: 'Entrepreneur individuel',
            labelen: 'Entrepreneur individuel'
        },
        {
            value: 'ZZ0X',
            labelcz: "Établissement public des cultes d'Alsace-Lorraine",
            labelen: "Établissement public des cultes d'Alsace-Lorraine"
        }
    ],
    DE: [
        {
            value: '13AV',
            labelcz: 'Versicherungsverein auf Gegenseitigkeit',
            labelen: 'Versicherungsverein auf Gegenseitigkeit'
        },
        {
            value: '2HBR',
            labelcz: 'Gesellschaft mit beschränkter Haftung',
            labelen: 'Gesellschaft mit beschränkter Haftung'
        },
        {
            value: '2YZO',
            labelcz: 'Partnerschaftsgesellschaft mit beschränkter Berufshaftung',
            labelen: 'Partnerschaftsgesellschaft mit beschränkter Berufshaftung'
        },
        {
            value: '40DB',
            labelcz: 'Offene Handelsgesellschaft',
            labelen: 'Offene Handelsgesellschaft'
        },
        {
            value: '63KS',
            labelcz: 'Unternehmergesellschaft',
            labelen: 'Unternehmergesellschaft'
        },
        {
            value: '6QQB',
            labelcz: 'Aktiengesellschaft',
            labelen: 'Aktiengesellschaft'
        },
        {
            value: '79H0',
            labelcz: 'Nicht eingetragener Verein',
            labelen: 'Nicht eingetragener Verein'
        },
        {
            value: '7J3S',
            labelcz: 'Wirtschaftlicher Verein',
            labelen: 'Wirtschaftlicher Verein'
        },
        {
            value: '8CM0',
            labelcz: 'Partnerschaftsgesellschaft',
            labelen: 'Partnerschaftsgesellschaft'
        },
        {
            value: '8Z6G',
            labelcz: 'Kommanditgesellschaft',
            labelen: 'Kommanditgesellschaft'
        },
        {
            value: '9JGX',
            labelcz: 'Landesinnungsverband',
            labelen: 'Landesinnungsverband'
        },
        {
            value: 'AMKW',
            labelcz: 'REIT-Aktiengesellschaft',
            labelen: 'REIT-Aktiengesellschaft'
        },
        {
            value: 'AZFE',
            labelcz: 'Eingetragene Genossenschaft',
            labelen: 'Eingetragene Genossenschaft'
        },
        {
            value: 'D40E',
            labelcz: 'Verein alten Rechts',
            labelen: 'Verein alten Rechts'
        },
        {
            value: 'FR3V',
            labelcz: 'Gesellschaft bürgerlichen Rechts',
            labelen: 'Gesellschaft bürgerlichen Rechts'
        },
        {
            value: 'JMVF',
            labelcz: 'Investmentaktiengesellschaft',
            labelen: 'Investmentaktiengesellschaft'
        },
        {
            value: 'JNDX',
            labelcz: 'Europäische wirtschaftliche Interessenvereinigung',
            labelen: 'Europäische wirtschaftliche Interessenvereinigung'
        },
        {
            value: 'OL20',
            labelcz: 'Einzelunternehmen, eingetragener Kaufmann, eingetragene Kauffrau',
            labelen: 'Einzelunternehmen, eingetragener Kaufmann, eingetragene Kauffrau'
        },
        {
            value: 'QZ3L',
            labelcz: 'eingetragener Verein',
            labelen: 'eingetragener Verein'
        },
        {
            value: 'SCE1',
            labelcz: 'Gemeinnützige Gesellschaft mit beschränkter Haftung',
            labelen: 'Gemeinnützige Gesellschaft mit beschränkter Haftung'
        },
        {
            value: 'SGST',
            labelcz: 'Europäische Aktiengesellschaft',
            labelen: 'Europäische Aktiengesellschaft'
        },
        {
            value: 'SQKS',
            labelcz: 'Körperschaft des öffentlichen Rechts',
            labelen: 'Körperschaft des öffentlichen Rechts'
        },
        {
            value: 'SUA1',
            labelcz: 'Europäische Genossenschaft',
            labelen: 'Europäische Genossenschaft'
        },
        {
            value: 'T0YJ',
            labelcz: 'Kommanditgesellschaft auf Aktien',
            labelen: 'Kommanditgesellschaft auf Aktien'
        },
        { value: 'US8E', labelcz: 'Genossenschaft', labelen: 'Genossenschaft' },
        {
            value: 'V2YH',
            labelcz: 'Stiftung des privaten Rechts',
            labelen: 'Stiftung des privaten Rechts'
        },
        {
            value: 'XLWA',
            labelcz: 'Anstalt des öffentlichen Rechts',
            labelen: 'Anstalt des öffentlichen Rechts'
        },
        {
            value: 'YA01',
            labelcz: 'Gemeinnützige Aktiengesellschaft',
            labelen: 'Gemeinnützige Aktiengesellschaft'
        },
        {
            value: 'YJ4C',
            labelcz: 'Kirchliche Stiftung des öffentlichen Rechts',
            labelen: 'Kirchliche Stiftung des öffentlichen Rechts'
        }
    ],
    GH: [
        {
            value: '4HD1',
            labelcz: 'Sole Proprietorship',
            labelen: 'Sole Proprietorship'
        },
        {
            value: '56NA',
            labelcz: 'Private Limited By Share',
            labelen: 'Private Limited By Share'
        },
        {
            value: 'I0X7',
            labelcz: 'Private Unlimited By Share',
            labelen: 'Private Unlimited By Share'
        },
        {
            value: 'J5RC',
            labelcz: 'Private Limited By Guarantee',
            labelen: 'Private Limited By Guarantee'
        },
        {
            value: 'PH5T',
            labelcz: 'Public Unlimited Company',
            labelen: 'Public Unlimited Company'
        },
        { value: 'T69Z', labelcz: 'External Company', labelen: 'External Company' },
        {
            value: 'VBJW',
            labelcz: 'Public Limited Company',
            labelen: 'Public Limited Company'
        },
        {
            value: 'W9ZD',
            labelcz: 'Public Limited By Guarantee',
            labelen: 'Public Limited By Guarantee'
        },
        { value: 'WP5I', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: 'XWPT',
            labelcz: 'Subsidiary Business Name',
            labelen: 'Subsidiary Business Name'
        }
    ],
    GI: [
        {
            value: '7U4R',
            labelcz: 'European Economic Interest Groupings',
            labelen: 'European Economic Interest Groupings'
        },
        { value: 'CB98', labelcz: 'Foundations', labelen: 'Foundations' },
        {
            value: 'GCCT',
            labelcz: 'Limited Liability Partnerships',
            labelen: 'Limited Liability Partnerships'
        },
        { value: 'M4TI', labelcz: 'Societe Europeas', labelen: 'Societe Europeas' },
        {
            value: 'QFLH',
            labelcz: 'Private Limited by Guarantee',
            labelen: 'Private Limited by Guarantee'
        },
        {
            value: 'TKPE',
            labelcz: 'Private Trust Company',
            labelen: 'Private Trust Company'
        },
        {
            value: 'UUYB',
            labelcz: 'Public Limited Company ',
            labelen: 'Public Limited Company '
        },
        {
            value: 'VJRL',
            labelcz: 'Private Unlimited Company',
            labelen: 'Private Unlimited Company'
        },
        {
            value: 'WBKH',
            labelcz: 'Private Limited Company',
            labelen: 'Private Limited Company'
        },
        {
            value: 'Y8CL',
            labelcz: 'Limited Partnerships',
            labelen: 'Limited Partnerships'
        }
    ],
    GR: [
        { value: '3RHO', labelcz: 'Naftiki eteria', labelen: 'Naftiki eteria' },
        {
            value: '54AL',
            labelcz: 'Eterórithmi Etería',
            labelen: 'Eterórithmi Etería'
        },
        {
            value: 'CQ5X',
            labelcz: 'Εvropaiki Εtaireia',
            labelen: 'Εvropaiki Εtaireia'
        },
        {
            value: 'H6OR',
            labelcz: 'Etería Periorisménis Euthínis',
            labelen: 'Etería Periorisménis Euthínis'
        },
        {
            value: 'HKVP',
            labelcz: 'Astiki (Proswpiki) Eteria',
            labelen: 'Astiki (Proswpiki) Eteria'
        },
        { value: 'J3VJ', labelcz: 'Sinetairismos', labelen: 'Sinetairismos' },
        { value: 'JYKN', labelcz: 'Lipa', labelen: 'Lipa' },
        {
            value: 'L6IY',
            labelcz: 'Nomika Prosopa Dimosiou Dikeou',
            labelen: 'Nomika Prosopa Dimosiou Dikeou'
        },
        { value: 'L8D6', labelcz: 'Afanis Eteria', labelen: 'Afanis Eteria' },
        { value: 'MCWR', labelcz: 'Kinopraxia', labelen: 'Kinopraxia' },
        {
            value: 'QCA0',
            labelcz: 'Idiotiki kefaleouhiki Eteria',
            labelen: 'Idiotiki kefaleouhiki Eteria'
        },
        {
            value: 'QSYQ',
            labelcz: 'Somatia - Idrimata',
            labelen: 'Somatia - Idrimata'
        },
        { value: 'TIZ2', labelcz: 'Omórithmi Etería', labelen: 'Omórithmi Etería' },
        {
            value: 'UCU5',
            labelcz: 'Εterorrythmi kata metoches etaireia',
            labelen: 'Εterorrythmi kata metoches etaireia'
        },
        { value: 'VKSR', labelcz: 'Simplioktisia', labelen: 'Simplioktisia' },
        { value: 'W2NK', labelcz: 'Anónimi Etería', labelen: 'Anónimi Etería' }
    ],
    GT: [
        {
            value: 'F0IC',
            labelcz: 'Sociedad en Comandita por Acciones',
            labelen: 'Sociedad en Comandita por Acciones'
        },
        {
            value: 'GY0L',
            labelcz: 'Sociedad Colectiva',
            labelen: 'Sociedad Colectiva'
        },
        {
            value: 'RK88',
            labelcz: 'Sociedad de Responsabilidad Limitada',
            labelen: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: 'W9T7',
            labelcz: 'Sociedad en Comandita Simple',
            labelen: 'Sociedad en Comandita Simple'
        },
        { value: 'XH5R', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' }
    ],
    GG: [
        { value: '9XFK', labelcz: 'Foundation', labelen: 'Foundation' },
        { value: 'BVOE', labelcz: 'Limited Company', labelen: 'Limited Company' },
        {
            value: 'Q49K',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'UO3D',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        }
    ],
    HN: [
        {
            value: '12F9',
            labelcz: 'Sociedades de Capital Variable',
            labelen: 'Sociedades de Capital Variable'
        },
        {
            value: '6ETM',
            labelcz: 'Sociedad en Comandita por Acciones',
            labelen: 'Sociedad en Comandita por Acciones'
        },
        {
            value: 'E7JZ',
            labelcz: 'Comerciante Individual',
            labelen: 'Comerciante Individual'
        },
        { value: 'JUDZ', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' },
        {
            value: 'O2M6',
            labelcz: 'Sociedad Colectiva',
            labelen: 'Sociedad Colectiva'
        },
        {
            value: 'RF41',
            labelcz: 'Sociedad en Comandita Simple',
            labelen: 'Sociedad en Comandita Simple'
        },
        {
            value: 'XE7O',
            labelcz: 'Sociedad de Responsabilidad Limitada',
            labelen: 'Sociedad de Responsabilidad Limitada'
        }
    ],
    HK: [
        {
            value: '254M',
            labelcz: 'Si ren gu fen you xian gong si',
            labelen: 'Si ren gu fen you xian gong si'
        },
        { value: '2QMJ', labelcz: 'Trust', labelen: 'Trust' },
        {
            value: '85VD',
            labelcz: 'zhu ce shou tuo ren',
            labelen: 'zhu ce shou tuo ren'
        },
        {
            value: 'E1SE',
            labelcz: 'gen ju fa li cheng li de shi ti',
            labelen: 'gen ju fa li cheng li de shi ti'
        },
        {
            value: 'EPG7',
            labelcz: 'Gong zhong gu fen  you xian gong si',
            labelen: 'Gong zhong gu fen  you xian gong si'
        },
        {
            value: 'KSUS',
            labelcz: 'fei xiang gang gong si',
            labelen: 'fei xiang gang gong si'
        },
        {
            value: 'N3VO',
            labelcz: 'You gu ben de gong zhong wu xian gong si',
            labelen: 'You gu ben de gong zhong wu xian gong si'
        },
        {
            value: 'S2E3',
            labelcz: 'Dan bao  you xian gong si',
            labelen: 'Dan bao  you xian gong si'
        },
        {
            value: 'UDG6',
            labelcz: 'You gu ben de si ren wu xian gong si',
            labelen: 'You gu ben de si ren wu xian gong si'
        },
        {
            value: 'XPE5',
            labelcz: 'you xian ze ren he huo',
            labelen: 'you xian ze ren he huo'
        }
    ],
    HU: [
        { value: '2A44', labelcz: 'Egyéni cég', labelen: 'Egyéni cég' },
        {
            value: '2LB5',
            labelcz: 'Munkavállalói Résztulajdonosi Program szervezet',
            labelen: 'Munkavállalói Résztulajdonosi Program szervezet'
        },
        { value: '4C5L', labelcz: 'Ügyvédi Iroda', labelen: 'Ügyvédi Iroda' },
        { value: '4QRE', labelcz: 'Önkormányzat', labelen: 'Önkormányzat' },
        { value: '8UMK', labelcz: 'Európai gazdasági egyesülés', labelen: 'Európai gazdasági egyesülés' },
        { value: 'BJ8Q', labelcz: 'Egyéni vállalkozás', labelen: 'Egyéni vállalkozás' },
        { value: 'BSK1', labelcz: 'Oktatási intézmények', labelen: 'Oktatási intézmények' },
        { value: 'ESTU', labelcz: 'Társasház', labelen: 'Társasház' },
        { value: 'LNY0', labelcz: 'Egyházi szervezetek', labelen: 'Egyházi szervezetek' },
        { value: 'OII5', labelcz: 'Egyéni ügyvéd', labelen: 'Egyéni ügyvéd' },
        { value: 'QYV5', labelcz: 'Költségvetési szerv', labelen: 'Költségvetési szerv' },
        { value: 'V3LT', labelcz: 'Erdőbirtokossági Társulat', labelen: 'Erdőbirtokossági Társulat' },
        { value: 'ZQAQ', labelcz: 'Közjegyzői iroda', labelen: 'Közjegyzői iroda' },
        {
            value: '4WV7',
            labelcz: 'Egyéb köztestület',
            labelen: 'Egyéb köztestület'
        },
        { value: '876R', labelcz: 'Egyéb egyesület', labelen: 'Egyéb egyesület' },
        {
            value: '8UEG',
            labelcz: 'Nyilvánosan működő részvénytársaság',
            labelen: 'Nyilvánosan működő részvénytársaság'
        },
        { value: '8VH3', labelcz: 'Befektetési alap', labelen: 'Befektetési alap' },
        {
            value: '995K',
            labelcz: 'Magánnyugdíjpénztár',
            labelen: 'Magánnyugdíjpénztár'
        },
        {
            value: 'BKUX',
            labelcz: 'Zártkörűen működő részvénytársaság',
            labelen: 'Zártkörűen működő részvénytársaság'
        },
        { value: 'BMYJ', labelcz: 'Egyéb alapítvány', labelen: 'Egyéb alapítvány' },
        {
            value: 'DN6F',
            labelcz: 'Kölcsönös biztosító egyesület',
            labelen: 'Kölcsönös biztosító egyesület'
        },
        {
            value: 'DPY1',
            labelcz: 'Egyéb szövetkezet',
            labelen: 'Egyéb szövetkezet'
        },
        { value: 'EO9F', labelcz: 'Részvénytársaság', labelen: 'Részvénytársaság' },
        {
            value: 'HTJD',
            labelcz: 'Közhasznú társaság',
            labelen: 'Közhasznú társaság'
        },
        {
            value: 'J6MO',
            labelcz: 'Közkereseti társaság',
            labelen: 'Közkereseti társaság'
        },
        {
            value: 'M1DW',
            labelcz: 'Önkéntes kölcsönös biztosítópénztár',
            labelen: 'Önkéntes kölcsönös biztosítópénztár'
        },
        {
            value: 'NZAI',
            labelcz: 'Külföldi székhelyű vállalkozás kereskedelmi képviselete',
            labelen: 'Külföldi székhelyű vállalkozás kereskedelmi képviselete'
        },
        {
            value: 'P9F2',
            labelcz: 'Korlátolt felelősségű társaság',
            labelen: 'Korlátolt felelősségű társaság'
        },
        { value: 'S3DA', labelcz: 'Betéti társaság', labelen: 'Betéti társaság' },
        {
            value: 'TQ3O',
            labelcz: 'Egyéb, máshova nem sorolt jogi személyiségű vállalkozás',
            labelen: 'Egyéb, máshova nem sorolt jogi személyiségű vállalkozás'
        },
        {
            value: 'TSVO',
            labelcz: 'Szövetség (kivéve sportszövetség)',
            labelen: 'Szövetség (kivéve sportszövetség)'
        },
        {
            value: 'UD8K',
            labelcz: 'Külföldi székhelyű vállalkozás fióktelepe',
            labelen: 'Külföldi székhelyű vállalkozás fióktelepe'
        },
        {
            value: 'X0SX',
            labelcz: 'Takarék- és hitelszövetkezet',
            labelen: 'Takarék- és hitelszövetkezet'
        },
        {
            value: 'XW5U',
            labelcz: 'Európai részvénytársaság',
            labelen: 'Európai részvénytársaság'
        },
        {
            value: 'Y64R',
            labelcz: 'Országos betétbiztosítási alap',
            labelen: 'Országos betétbiztosítási alap'
        }
    ],
    IS: [
        {
            value: '2OJP',
            labelcz: 'Samlagshlutafélag',
            labelen: 'Samlagshlutafélag'
        },
        { value: '8T79', labelcz: 'Samlagsfélag', labelen: 'Samlagsfélag' },
        { value: 'CMHQ', labelcz: 'Evrópufélag', labelen: 'Evrópufélag' },
        { value: 'E4KB', labelcz: 'Hlutafélag', labelen: 'Hlutafélag' },
        { value: 'M8SS', labelcz: 'Einkahlutafélag', labelen: 'Einkahlutafélag' }
    ],
    IN: [
        {
            value: '180P',
            labelcz: 'Stand Alone Primary Dealer',
            labelen: 'Stand Alone Primary Dealer'
        },
        {
            value: '2DVA',
            labelcz: 'Cooperative Society',
            labelen: 'Cooperative Society'
        },
        {
            value: '2Y95',
            labelcz: 'Special Purpose Vehicle - Company',
            labelen: 'Special Purpose Vehicle - Company'
        },
        {
            value: '36YD',
            labelcz: 'Unlimited Company',
            labelen: 'Unlimited Company'
        },
        {
            value: '3VSP',
            labelcz: 'Public Financial Institutions',
            labelen: 'Public Financial Institutions'
        },
        {
            value: '4QIE',
            labelcz: 'Sole Proprietorship',
            labelen: 'Sole Proprietorship'
        },
        {
            value: '70GJ',
            labelcz: 'Government Organization',
            labelen: 'Government Organization'
        },
        {
            value: '8ZLF',
            labelcz: 'Special Purpose Vehicle - Trust',
            labelen: 'Special Purpose Vehicle - Trust'
        },
        {
            value: '9ME5',
            labelcz: 'Non profit company',
            labelen: 'Non profit company'
        },
        { value: 'A0PS', labelcz: 'Partnership Firm', labelen: 'Partnership Firm' },
        {
            value: 'DDKQ',
            labelcz: 'Public Limited Company',
            labelen: 'Public Limited Company'
        },
        {
            value: 'DW2W',
            labelcz: 'Company Limited by Guarantee',
            labelen: 'Company Limited by Guarantee'
        },
        {
            value: 'EX8U',
            labelcz: 'Alternative Investment Fund',
            labelen: 'Alternative Investment Fund'
        },
        {
            value: 'FC7L',
            labelcz: 'Housing Finance Company',
            labelen: 'Housing Finance Company'
        },
        {
            value: 'FPZK',
            labelcz: 'Banking Company - Scheduled Urban Cooperative Bank',
            labelen: 'Banking Company - Scheduled Urban Cooperative Bank'
        },
        {
            value: 'HBQK',
            labelcz: 'Alternate Investment Fund - Sub scheme',
            labelen: 'Alternate Investment Fund - Sub scheme'
        },
        {
            value: 'I47Z',
            labelcz: 'One Person Company',
            labelen: 'One Person Company'
        },
        {
            value: 'JKJX',
            labelcz: 'Provident fund / Superannuation fund / Gratuity fund / Insurance Fund',
            labelen: 'Provident fund / Superannuation fund / Gratuity fund / Insurance Fund'
        },
        {
            value: 'K361',
            labelcz: 'Special Purpose Vehicle-Coop  / Multistate Coop Society',
            labelen: 'Special Purpose Vehicle-Coop  / Multistate Coop Society'
        },
        {
            value: 'K4OX',
            labelcz: 'Special Purpose Vehicle - Partnership Firm',
            labelen: 'Special Purpose Vehicle - Partnership Firm'
        },
        {
            value: 'KJ0B',
            labelcz: 'Insurance Company',
            labelen: 'Insurance Company'
        },
        {
            value: 'NBCI',
            labelcz: 'Banking Company - Others',
            labelen: 'Banking Company - Others'
        },
        {
            value: 'NFPC',
            labelcz: 'Non-Banking Finance Company',
            labelen: 'Non-Banking Finance Company'
        },
        { value: 'OYDA', labelcz: 'Pension Funds', labelen: 'Pension Funds' },
        {
            value: 'QCSO',
            labelcz: 'Multistate Cooperative Society',
            labelen: 'Multistate Cooperative Society'
        },
        {
            value: 'U5S6',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: 'U8NM', labelcz: 'Mutual Fund', labelen: 'Mutual Fund' },
        {
            value: 'VX5J',
            labelcz: 'Mutual Fund-Sub Scheme',
            labelen: 'Mutual Fund-Sub Scheme'
        },
        {
            value: 'W0G7',
            labelcz: 'Pension Funds-Sub Scheme',
            labelen: 'Pension Funds-Sub Scheme'
        },
        { value: 'W9FI', labelcz: 'Trust', labelen: 'Trust' },
        {
            value: 'X4IT',
            labelcz: 'Government Company',
            labelen: 'Government Company'
        },
        {
            value: 'XTZG',
            labelcz: 'Banking Company - Nationalised Bank',
            labelen: 'Banking Company - Nationalised Bank'
        },
        {
            value: 'YSP9',
            labelcz: 'Private Limited Company',
            labelen: 'Private Limited Company'
        }
    ],
    IE: [
        {
            value: '2GV9',
            labelcz: 'Irish Collective Asset-management Vehicle',
            labelen: 'Irish Collective Asset-management Vehicle'
        },
        {
            value: '363J',
            labelcz: 'European Economic Interest Grouping',
            labelen: 'European Economic Interest Grouping'
        },
        { value: '54SK', labelcz: 'Friendly Society', labelen: 'Friendly Society' },
        {
            value: '5AX8',
            labelcz: 'Designated Activity Company Limited by Guarantee',
            labelen: 'Designated Activity Company Limited by Guarantee'
        },
        { value: '9BPE', labelcz: 'Credit Union', labelen: 'Credit Union' },
        {
            value: 'C58S',
            labelcz: 'Company Limited by Guarantee',
            labelen: 'Company Limited by Guarantee'
        },
        {
            value: 'DWS3',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'FF1D',
            labelcz: 'Public Unlimited Company that has no share capital',
            labelen: 'Public Unlimited Company that has no share capital'
        },
        {
            value: 'HNJK',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'JXDX',
            labelcz: 'Societas Europaea',
            labelen: 'Societas Europaea'
        },
        {
            value: 'KMFX',
            labelcz: 'Private Unlimited Company',
            labelen: 'Private Unlimited Company'
        },
        {
            value: 'LGWG',
            labelcz: 'Designated Activity Company',
            labelen: 'Designated Activity Company'
        },
        { value: 'LMIM', labelcz: 'Limited company', labelen: 'Limited company' },
        {
            value: 'LZIC',
            labelcz: 'Investment Limited Partnership',
            labelen: 'Investment Limited Partnership'
        },
        {
            value: 'MNQ7',
            labelcz: 'Private Company Limited by Shares',
            labelen: 'Private Company Limited by Shares'
        },
        {
            value: 'URQH',
            labelcz: 'Public Unlimited Company',
            labelen: 'Public Unlimited Company'
        },
        {
            value: 'VYAX',
            labelcz: 'Public Limited Company',
            labelen: 'Public Limited Company'
        },
        {
            value: 'ZJS8',
            labelcz: 'Industrial and Provident Society',
            labelen: 'Industrial and Provident Society'
        }
    ],
    IM: [
        {
            value: '1G26',
            labelcz: 'Public Limited by Guarantee and not having a Share Capital (1931 Act)',
            labelen: 'Public Limited by Guarantee and not having a Share Capital (1931 Act)'
        },
        {
            value: '5ABK',
            labelcz: 'Unlimited with Shares (2006 Act)',
            labelen: 'Unlimited with Shares (2006 Act)'
        },
        {
            value: 'CDXK',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'EMLA',
            labelcz: 'Limited Partnership - without Legal Personality',
            labelen: 'Limited Partnership - without Legal Personality'
        },
        {
            value: 'FI4M',
            labelcz: 'Industrial and Building Society',
            labelen: 'Industrial and Building Society'
        },
        {
            value: 'FMPL',
            labelcz: 'Private Limited by Guarantee and not having a Share Capital (1931 Act)',
            labelen: 'Private Limited by Guarantee and not having a Share Capital (1931 Act)'
        },
        {
            value: 'G4V6',
            labelcz: 'Public Unlimited and having a Share Capital (1931 Act)',
            labelen: 'Public Unlimited and having a Share Capital (1931 Act)'
        },
        { value: 'JHC4', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: 'M44Y',
            labelcz: 'Limited by Shares and by Guarantee (2006 Act)',
            labelen: 'Limited by Shares and by Guarantee (2006 Act)'
        },
        {
            value: 'OESH',
            labelcz: 'Public Limited by Guarantee and having a Share Capital (1931 Act)',
            labelen: 'Public Limited by Guarantee and having a Share Capital (1931 Act)'
        },
        {
            value: 'QZTT',
            labelcz: 'Private Limited by shares (1931 Act)',
            labelen: 'Private Limited by shares (1931 Act)'
        },
        {
            value: 'SAI8',
            labelcz: 'Private Unlimited and having a Share Capital (1931 Act)',
            labelen: 'Private Unlimited and having a Share Capital (1931 Act)'
        },
        {
            value: 'SP9F',
            labelcz: 'Limited by Guarantee (2006 Act)',
            labelen: 'Limited by Guarantee (2006 Act)'
        },
        {
            value: 'TE79',
            labelcz: 'Limited Partnership - with Legal Personality',
            labelen: 'Limited Partnership - with Legal Personality'
        },
        {
            value: 'TQ3Z',
            labelcz: 'Limited by Shares (2006 Act)',
            labelen: 'Limited by Shares (2006 Act)'
        },
        {
            value: 'TV5P',
            labelcz: 'Unlimited without Shares (2006 Act)',
            labelen: 'Unlimited without Shares (2006 Act)'
        },
        {
            value: 'VC3E',
            labelcz: 'Private Limited by Guarantee and having a Share Capital (1931 Act)',
            labelen: 'Private Limited by Guarantee and having a Share Capital (1931 Act)'
        },
        {
            value: 'ZGPY',
            labelcz: 'Public Limited by Shares (1931 Act)',
            labelen: 'Public Limited by Shares (1931 Act)'
        }
    ],
    IT: [
        {
            value: '135L',
            labelcz: "Societa' Costituita In Base A Leggi Di Altro Stato",
            labelen: "Societa' Costituita In Base A Leggi Di Altro Stato"
        },
        {
            value: '1RI9',
            labelcz: 'Ente Ecclesiastico Civilmente Riconosciuto',
            labelen: 'Ente Ecclesiastico Civilmente Riconosciuto'
        },
        { value: '1TON', labelcz: 'Associazione', labelen: 'Associazione' },
        {
            value: '2J7Z',
            labelcz: "Consorzio con attivita' Esterna",
            labelen: "Consorzio con attivita' Esterna"
        },
        { value: '2SZI', labelcz: 'Ente Sociale', labelen: 'Ente Sociale' },
        {
            value: '2XXH',
            labelcz: "Societa' Semplice",
            labelen: "Societa' Semplice"
        },
        {
            value: '5ODO',
            labelcz: 'Ente Diritto Pubblico',
            labelen: 'Ente Diritto Pubblico'
        },
        {
            value: '634M',
            labelcz: 'Gruppo Europeo Di Interesse Economico',
            labelen: 'Gruppo Europeo Di Interesse Economico'
        },
        {
            value: '70X0',
            labelcz: 'Fondazione Impresa',
            labelen: 'Fondazione Impresa'
        },
        { value: '75WC', labelcz: 'Fondazione', labelen: 'Fondazione' },
        {
            value: '8AXV',
            labelcz: "Societa' Consortile Cooperativa a Responsabilita' Limitata",
            labelen: "Societa' Consortile Cooperativa a Responsabilita' Limitata"
        },
        {
            value: '8GU1',
            labelcz: "Societa' A Responsabilita' Limitata Semplificata",
            labelen: "Societa' A Responsabilita' Limitata Semplificata"
        },
        {
            value: '9KGS',
            labelcz: "Societa' Cooperativa Europea",
            labelen: "Societa' Cooperativa Europea"
        },
        {
            value: 'ADAZ',
            labelcz: 'Istituto Religioso',
            labelen: 'Istituto Religioso'
        },
        { value: 'ARJF', labelcz: 'Ente Morale', labelen: 'Ente Morale' },
        {
            value: 'B5TO',
            labelcz: "Societa' a Responsabilita' Limitata con Unico Socio",
            labelen: "Societa' a Responsabilita' Limitata con Unico Socio"
        },
        {
            value: 'BL52',
            labelcz: "Societa' Consortile A Responsabilita' Limitata",
            labelen: "Societa' Consortile A Responsabilita' Limitata"
        },
        {
            value: 'C1IC',
            labelcz: "Societa' Cooperativa Consortile",
            labelen: "Societa' Cooperativa Consortile"
        },
        {
            value: 'CGSO',
            labelcz: "Societa' in Accomandita Semplice",
            labelen: "Societa' in Accomandita Semplice"
        },
        {
            value: 'CTNS',
            labelcz: "Societa' Cooperativa a Responsabilita' Limitata",
            labelen: "Societa' Cooperativa a Responsabilita' Limitata"
        },
        { value: 'DCRK', labelcz: 'Consorzio Fidi', labelen: 'Consorzio Fidi' },
        {
            value: 'DLS4',
            labelcz: "Societa' in Accomandita per Azioni",
            labelen: "Societa' in Accomandita per Azioni"
        },
        {
            value: 'DSSD',
            labelcz: 'Azienda Autonoma Statale',
            labelen: 'Azienda Autonoma Statale'
        },
        { value: 'H7D4', labelcz: 'Soggetto Estero', labelen: 'Soggetto Estero' },
        { value: 'HN75', labelcz: 'Consorzio', labelen: 'Consorzio' },
        {
            value: 'IMHA',
            labelcz: 'Ente Ecclesiastico',
            labelen: 'Ente Ecclesiastico'
        },
        {
            value: 'K021',
            labelcz: "Contratto Di Rete Dotato Di Soggettivita' Giuridica",
            labelen: "Contratto Di Rete Dotato Di Soggettivita' Giuridica"
        },
        { value: 'K26L', labelcz: 'Ente', labelen: 'Ente' },
        {
            value: 'KCHO',
            labelcz: 'Azienda Speciale Di Cui Al Dlgs 267/2000',
            labelen: 'Azienda Speciale Di Cui Al Dlgs 267/2000'
        },
        { value: 'KCSG', labelcz: 'Ente Impresa', labelen: 'Ente Impresa' },
        { value: 'KXZT', labelcz: 'Azienda Speciale', labelen: 'Azienda Speciale' },
        {
            value: 'L1ZJ',
            labelcz: 'Azienda Municipale',
            labelen: 'Azienda Municipale'
        },
        {
            value: 'LHBB',
            labelcz: 'Impresa Individuale',
            labelen: 'Impresa Individuale'
        },
        {
            value: 'LZZD',
            labelcz: "Societa' Consortile Per Azioni",
            labelen: "Societa' Consortile Per Azioni"
        },
        {
            value: 'NDEW',
            labelcz: "Societa' Consortile Cooperativa",
            labelen: "Societa' Consortile Cooperativa"
        },
        { value: 'OQ8C', labelcz: 'Fondo Pensione', labelen: 'Fondo Pensione' },
        {
            value: 'OV32',
            labelcz: "Societa' A Responsabilita' Limitata",
            labelen: "Societa' A Responsabilita' Limitata"
        },
        {
            value: 'P418',
            labelcz: "Societa' Per Azioni",
            labelen: "Societa' Per Azioni"
        },
        {
            value: 'PHMS',
            labelcz: 'Cooperativa Sociale',
            labelen: 'Cooperativa Sociale'
        },
        {
            value: 'QRZJ',
            labelcz: "Societa' Cooperativa",
            labelen: "Societa' Cooperativa"
        },
        { value: 'RWZD', labelcz: 'Altre Forme', labelen: 'Altre Forme' },
        {
            value: 'SBQN',
            labelcz: "Consorzio senza Attivita' Esterna",
            labelen: "Consorzio senza Attivita' Esterna"
        },
        {
            value: 'SSP9',
            labelcz: 'Azienda Speciale Rea',
            labelen: 'Azienda Speciale Rea'
        },
        {
            value: 'T2X1',
            labelcz: "Societa' In Nome Collettivo",
            labelen: "Societa' In Nome Collettivo"
        },
        {
            value: 'VA1V',
            labelcz: "Societa' Di Mutuo Soccorso",
            labelen: "Societa' Di Mutuo Soccorso"
        },
        {
            value: 'VDRB',
            labelcz: 'Consorzio Municipale',
            labelen: 'Consorzio Municipale'
        },
        { value: 'VUPE', labelcz: "Societa' Europea", labelen: "Societa' Europea" },
        {
            value: 'W2PE',
            labelcz: "Societa' non prevista dalla Legislazione Italiana",
            labelen: "Societa' non prevista dalla Legislazione Italiana"
        },
        {
            value: 'W9SC',
            labelcz: 'Mutua Assicurazione',
            labelen: 'Mutua Assicurazione'
        },
        {
            value: 'WPED',
            labelcz: 'Associazione Impresa',
            labelen: 'Associazione Impresa'
        },
        {
            value: 'WRU2',
            labelcz: "Societa' Consortile in Accomandita Semplice",
            labelen: "Societa' Consortile in Accomandita Semplice"
        },
        {
            value: 'X32V',
            labelcz: "Societa' per Azioni con Socio Unico",
            labelen: "Societa' per Azioni con Socio Unico"
        },
        {
            value: 'X62Z',
            labelcz: 'Consorzio Di Cui Alla Dlgs 267/2000',
            labelen: 'Consorzio Di Cui Alla Dlgs 267/2000'
        },
        {
            value: 'ZG6S',
            labelcz: 'Ente Pubblico Economico',
            labelen: 'Ente Pubblico Economico'
        },
        {
            value: 'ZU9S',
            labelcz: "Piccola Societa' Cooperativa a Responsabilita' Limitata",
            labelen: "Piccola Societa' Cooperativa a Responsabilita' Limitata"
        },
        {
            value: 'ZZOG',
            labelcz: "Societa' Tra Professionisti",
            labelen: "Societa' Tra Professionisti"
        }
    ],
    JP: [
        {
            value: '2NRQ',
            labelcz: 'chihokokyoudantai',
            labelen: 'chihokokyoudantai'
        },
        { value: '5MVV', labelcz: 'gousigaisya', labelen: 'gousigaisya' },
        { value: '7QQ0', labelcz: 'goudougaisya', labelen: 'goudougaisya' },
        { value: 'DYQK', labelcz: 'yugengaisya', labelen: 'yugengaisya' },
        { value: 'IUVI', labelcz: 'goumeigaisya', labelen: 'goumeigaisya' },
        { value: 'MXMH', labelcz: 'gaikokugaisyatou', labelen: 'gaikokugaisyatou' },
        {
            value: 'N3JU',
            labelcz: 'sonotaseturitutoukihouzin',
            labelen: 'sonotaseturitutoukihouzin'
        },
        { value: 'R4LR', labelcz: 'kuninokikan', labelen: 'kuninokikan' },
        { value: 'T417', labelcz: 'kabusikigaisya', labelen: 'kabusikigaisya' },
        { value: 'VQLD', labelcz: 'sonota', labelen: 'sonota' }
    ],
    JE: [
        {
            value: '21F4',
            labelcz: 'Separate Limited Partnerships',
            labelen: 'Separate Limited Partnerships'
        },
        {
            value: '33IP',
            labelcz: 'Incorporated Limited Partnerships',
            labelen: 'Incorporated Limited Partnerships'
        },
        { value: '40A7', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: '7RZH',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'JOX1',
            labelcz: 'Public Limited Company',
            labelen: 'Public Limited Company'
        },
        {
            value: 'LO9A',
            labelcz: 'Private Limited by Guarantee',
            labelen: 'Private Limited by Guarantee'
        },
        {
            value: 'SQXV',
            labelcz: 'Private Limited Company',
            labelen: 'Private Limited Company'
        },
        {
            value: 'UBWU',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        }
    ],
    JO: [
        {
            value: '2R82',
            labelcz: 'sharikat raas almal almughamir',
            labelen: 'sharikat raas almal almughamir'
        },
        {
            value: '6B39',
            labelcz: 'alsharika zat almasuwliat almahduda',
            labelen: 'alsharika zat almasuwliat almahduda'
        },
        {
            value: '6KSC',
            labelcz: 'sharikat altawsia albasita',
            labelen: 'sharikat altawsia albasita'
        },
        {
            value: '9NBN',
            labelcz: 'sharikat altadamun',
            labelen: 'sharikat altadamun'
        },
        {
            value: 'BL60',
            labelcz: 'alsharika almusahama aleama',
            labelen: 'alsharika almusahama aleama'
        },
        {
            value: 'FZAC',
            labelcz: 'alsharika almusahama alkhasa',
            labelen: 'alsharika almusahama alkhasa'
        },
        {
            value: 'IXQK',
            labelcz: "sharikat altawsia bial'ashum",
            labelen: "sharikat altawsia bial'ashum"
        },
        {
            value: 'SAST',
            labelcz: 'alsharika alty la tahdof litahqiq alribh',
            labelen: 'alsharika alty la tahdof litahqiq alribh'
        }
    ],
    KR: [
        { value: '12KO', labelcz: 'HoeSaHyeong', labelen: 'HoeSaHyeong' },
        { value: '5RCH', labelcz: 'JuSikHoeSa', labelen: 'JuSikHoeSa' },
        { value: 'AHJG', labelcz: 'JoHabHyeong', labelen: 'JoHabHyeong' },
        { value: 'AKF5', labelcz: 'JaeDanBeobIn', labelen: 'JaeDanBeobIn' },
        { value: 'AXEQ', labelcz: 'HabMyeongHoeSa', labelen: 'HabMyeongHoeSa' },
        { value: 'BW92', labelcz: 'HabJaHoeSa', labelen: 'HabJaHoeSa' },
        { value: 'J3U5', labelcz: 'YuHanHoeSa', labelen: 'YuHanHoeSa' },
        { value: 'QU16', labelcz: 'GukGa(JeoungBu)', labelen: 'GukGa(JeoungBu)' },
        {
            value: 'UDJG',
            labelcz: 'YuHanChaekImHoeSa',
            labelen: 'YuHanChaekImHoeSa'
        },
        { value: 'UGVB', labelcz: 'SinTakHyeong', labelen: 'SinTakHyeong' },
        {
            value: 'VTH4',
            labelcz: 'BiYeongRi SaDanBeobIn',
            labelen: 'BiYeongRi SaDanBeobIn'
        },
        { value: 'WUJC', labelcz: 'GongGongDanChe', labelen: 'GongGongDanChe' }
    ],
    XK: [
        {
            value: '3YUD',
            labelcz: 'Ndërmarrjet shoqërore nën administrimin e Agjencisë Kosovare të Privatizimit',
            labelen: 'Ndërmarrjet shoqërore nën administrimin e Agjencisë Kosovare të Privatizimit'
        },
        {
            value: 'B56A',
            labelcz: 'Zyra e Përfaqësisë së Shoqërisë së Huaj Tregtare në Kosovë',
            labelen: 'Zyra e Përfaqësisë së Shoqërisë së Huaj Tregtare në Kosovë'
        },
        {
            value: 'CRX3',
            labelcz: 'Kooperativa Bujqësore',
            labelen: 'Kooperativa Bujqësore'
        },
        {
            value: 'D37H',
            labelcz: 'Shoqëri me Përgjegjësi të Kufizuar',
            labelen: 'Shoqëri me Përgjegjësi të Kufizuar'
        },
        {
            value: 'OZDY',
            labelcz: 'Dega e Shoqërisë së Huaj Tregtare në Kosovë',
            labelen: 'Dega e Shoqërisë së Huaj Tregtare në Kosovë'
        },
        {
            value: 'Q22D',
            labelcz: 'Shoqëri aksionare',
            labelen: 'Shoqëri aksionare'
        },
        {
            value: 'QZEN',
            labelcz: 'Biznes Individual',
            labelen: 'Biznes Individual'
        },
        {
            value: 'T2X0',
            labelcz: 'Ortakëri e Përgjithshme',
            labelen: 'Ortakëri e Përgjithshme'
        },
        {
            value: 'W5H8',
            labelcz: 'Ndërmarrjet publike sipas ligjit në fuqi për ndërmarrjet publike',
            labelen: 'Ndërmarrjet publike sipas ligjit në fuqi për ndërmarrjet publike'
        },
        {
            value: 'W7KV',
            labelcz: 'Ortakëri e Kufizuar',
            labelen: 'Ortakëri e Kufizuar'
        }
    ],
    LV: [
        {
            value: '1IPK',
            labelcz: 'Komandītsabiedrība',
            labelen: 'Komandītsabiedrība'
        },
        { value: '5ULL', labelcz: 'Eiropas Ekonomisko interešu grupa', labelen: 'Eiropas Ekonomisko interešu grupa' },
        { value: '3LCY', labelcz: 'Pilnsabiedrība', labelen: 'Pilnsabiedrība' },
        {
            value: 'AZTM',
            labelcz: 'Eiropas komercsabiedrība',
            labelen: 'Eiropas komercsabiedrība'
        },
        {
            value: 'BS22',
            labelcz: 'Individuālais komersants',
            labelen: 'Individuālais komersants'
        },
        {
            value: 'ES2D',
            labelcz: 'Sabiedrība ar ierobežotu atbildību',
            labelen: 'Sabiedrība ar ierobežotu atbildību'
        },
        {
            value: 'VJBO',
            labelcz: 'Akciju sabiedrība',
            labelen: 'Akciju sabiedrība'
        }
    ],
    LS: [
        {
            value: 'CD8F',
            labelcz: 'Non-profit Company',
            labelen: 'Non-profit Company'
        },
        { value: 'K6G7', labelcz: 'Public Company', labelen: 'Public Company' },
        { value: 'S02Y', labelcz: 'External Company', labelen: 'External Company' },
        { value: 'S779', labelcz: 'Private Company', labelen: 'Private Company' }
    ],
    LI: [
        { value: '1DGT', labelcz: 'Treuunternehmen', labelen: 'Treuunternehmen' },
        {
            value: '1SOY',
            labelcz: 'Europäische Genossenschaft',
            labelen: 'Europäische Genossenschaft'
        },
        { value: '32HC', labelcz: 'Verein', labelen: 'Verein' },
        { value: '53QF', labelcz: 'Treuhänderschaft', labelen: 'Treuhänderschaft' },
        {
            value: '7RRP',
            labelcz: 'Aktiengesellschaft',
            labelen: 'Aktiengesellschaft'
        },
        {
            value: 'ANSR',
            labelcz: 'Kommanditgesellschaft',
            labelen: 'Kommanditgesellschaft'
        },
        { value: 'BSZ8', labelcz: 'Stiftung', labelen: 'Stiftung' },
        { value: 'IF49', labelcz: 'Genossenschaft', labelen: 'Genossenschaft' },
        {
            value: 'K98U',
            labelcz: 'Europäische Wirtschaftliche Interessenvereinigung',
            labelen: 'Europäische Wirtschaftliche Interessenvereinigung'
        },
        {
            value: 'NDID',
            labelcz: 'Kollektivgesellschaft',
            labelen: 'Kollektivgesellschaft'
        },
        { value: 'TMU1', labelcz: 'Anstalt', labelen: 'Anstalt' },
        {
            value: 'TV8Y',
            labelcz: 'Kollektivtreuhänderschaft',
            labelen: 'Kollektivtreuhänderschaft'
        },
        {
            value: 'WAK8',
            labelcz: 'Europäische Gesellschaft',
            labelen: 'Europäische Gesellschaft'
        },
        {
            value: 'Y8LH',
            labelcz: 'Gesellschaft mit beschränkter Haftung',
            labelen: 'Gesellschaft mit beschränkter Haftung'
        }
    ],
    LT: [
        {
            value: '13T9',
            labelcz: 'Europos bendrovės',
            labelen: 'Europos bendrovės'
        },
        { value: '4ZF3', labelcz: 'Valstybės įmonės', labelen: 'Valstybės įmonės' },
        {
            value: '5BY2',
            labelcz: 'Europos kooperatinės bendrovės',
            labelen: 'Europos kooperatinės bendrovės'
        },
        {
            value: '5CIE',
            labelcz: 'Advokatų profesinės bendrijos',
            labelen: 'Advokatų profesinės bendrijos'
        },
        { value: '5TA8', labelcz: 'Šeimynos', labelen: 'Šeimynos' },
        {
            value: '6JDN',
            labelcz: 'Profesinės sąjungos ir jų susivienijimai',
            labelen: 'Profesinės sąjungos ir jų susivienijimai'
        },
        {
            value: '81KA',
            labelcz: 'Akcinės bendrovės',
            labelen: 'Akcinės bendrovės'
        },
        {
            value: 'A2GC',
            labelcz: 'Religines bendruomenes, bendrijos ir centrai',
            labelen: 'Religines bendruomenes, bendrijos ir centrai'
        },
        {
            value: 'A338',
            labelcz: 'Individualios įmonės',
            labelen: 'Individualios įmonės'
        },
        {
            value: 'BGPJ',
            labelcz: 'Europos ekonominių interesų grupės',
            labelen: 'Europos ekonominių interesų grupės'
        },
        {
            value: 'BPLS',
            labelcz: 'Uždarosios akcinės bendrovės',
            labelen: 'Uždarosios akcinės bendrovės'
        },
        {
            value: 'DLCX',
            labelcz: 'Tikrosios ūkinės bendrijos',
            labelen: 'Tikrosios ūkinės bendrijos'
        },
        {
            value: 'E4HU',
            labelcz: 'Lietuvos prekybos, pramonės ir amatų rūmų asociacija',
            labelen: 'Lietuvos prekybos, pramonės ir amatų rūmų asociacija'
        },
        {
            value: 'F2TQ',
            labelcz: 'Tradicinės religinės bendruomenės ar bendrijos',
            labelen: 'Tradicinės religinės bendruomenės ar bendrijos'
        },
        { value: 'F2ZF', labelcz: 'Asociacijos', labelen: 'Asociacijos' },
        {
            value: 'HGMH',
            labelcz: 'Labdaros ir paramos fondai',
            labelen: 'Labdaros ir paramos fondai'
        },
        { value: 'HJ1Y', labelcz: 'Bendrijos', labelen: 'Bendrijos' },
        {
            value: 'K4GR',
            labelcz: 'Biudžetinės įstaigos',
            labelen: 'Biudžetinės įstaigos'
        },
        {
            value: 'KWBA',
            labelcz: 'Viešosios įstaigos',
            labelen: 'Viešosios įstaigos'
        },
        {
            value: 'LUGM',
            labelcz: 'Kooperatinės bendrovės (kooperatyvai)',
            labelen: 'Kooperatinės bendrovės (kooperatyvai)'
        },
        {
            value: 'LUOA',
            labelcz: 'Komanditinės ūkinės bendrijos',
            labelen: 'Komanditinės ūkinės bendrijos'
        },
        {
            value: 'NVPY',
            labelcz: 'Privačių detektyvų bendrijos',
            labelen: 'Privačių detektyvų bendrijos'
        },
        {
            value: 'Q4A3',
            labelcz: 'Prekybos, pramonės ir amatų rūmai',
            labelen: 'Prekybos, pramonės ir amatų rūmai'
        },
        {
            value: 'Q8UI',
            labelcz: 'Nuolatinės arbitražo institucijos',
            labelen: 'Nuolatinės arbitražo institucijos'
        },
        {
            value: 'QG9Y',
            labelcz: 'Sodininkų bendrijos',
            labelen: 'Sodininkų bendrijos'
        },
        {
            value: 'QRXD',
            labelcz: 'Europos teritorinio bendradarbiavimo grupės',
            labelen: 'Europos teritorinio bendradarbiavimo grupės'
        },
        {
            value: 'SFK9',
            labelcz: 'Bendras valdymo ir pranešimų centras',
            labelen: 'Bendras valdymo ir pranešimų centras'
        },
        {
            value: 'SFYA',
            labelcz: 'Mažosios bendrijos',
            labelen: 'Mažosios bendrijos'
        },
        {
            value: 'UHNL',
            labelcz: 'Žemės ūkio bendrovės',
            labelen: 'Žemės ūkio bendrovės'
        },
        { value: 'WQRG', labelcz: 'Centrinis bankas', labelen: 'Centrinis bankas' },
        {
            value: 'X8J8',
            labelcz: 'Politinės partijos',
            labelen: 'Politinės partijos'
        },
        {
            value: 'YRXK',
            labelcz: 'Savivaldybių įmonės',
            labelen: 'Savivaldybių įmonės'
        }
    ],
    LU: [
        { value: '7SIZ', labelcz: 'Mutuelle', labelen: 'Mutuelle' },
        { value: 'AIR5', labelcz: 'Fond commun de placement', labelen: 'Fond commun de placement' },
        {
            value: 'EUT4',
            labelcz: 'Société à responsabilité limitée simplifiée',
            labelen: 'Société à responsabilité limitée simplifiée'
        },
        {
            value: 'V7QY',
            labelcz: 'Groupement européen d’intérêt économique',
            labelen: 'Groupement européen d’intérêt économique'
        },
        {
            value: '2IGL',
            labelcz: 'Entreprise individuelle',
            labelen: 'Entreprise individuelle'
        },
        {
            value: '2JEI',
            labelcz: 'Association sans but lucratif',
            labelen: 'Association sans but lucratif'
        },
        {
            value: '2S2U',
            labelcz: "Association d'épargne pension",
            labelen: "Association d'épargne pension"
        },
        { value: '5GGB', labelcz: 'Société anonyme', labelen: 'Société anonyme' },
        {
            value: '63P9',
            labelcz: 'Société en commandite simple',
            labelen: 'Société en commandite simple'
        },
        {
            value: '68J6',
            labelcz: 'Association agricole',
            labelen: 'Association agricole'
        },
        {
            value: '81G5',
            labelcz: 'Société en commandite par actions',
            labelen: 'Société en commandite par actions'
        },
        {
            value: '9C91',
            labelcz: 'Société d’épargne-pension à capital variable',
            labelen: 'Société d’épargne-pension à capital variable'
        },
        {
            value: 'ATQY',
            labelcz: 'Société en nom collectif',
            labelen: 'Société en nom collectif'
        },
        {
            value: 'BEAN',
            labelcz: "Société d'investissement à capital fixe",
            labelen: "Société d'investissement à capital fixe"
        },
        {
            value: 'BKAB',
            labelcz: "Association d'assurances mutuelles",
            labelen: "Association d'assurances mutuelles"
        },
        {
            value: 'DVXS',
            labelcz: 'Société à responsabilité limitée',
            labelen: 'Société à responsabilité limitée'
        },
        {
            value: 'FG84',
            labelcz: 'Societas Cooperativa Europaea',
            labelen: 'Societas Cooperativa Europaea'
        },
        {
            value: 'HHR4',
            labelcz: 'Société par actions simplifiée',
            labelen: 'Société par actions simplifiée'
        },
        {
            value: 'JIWD',
            labelcz:
                "Autres personnes morales dont l'immatriculation est prévue par l'article 1 de la loi modifiée du 19 décembre 2002 concernant le registre de commerce et des sociétés ainsi que la comptabilité et les comptes annuels des entreprises",
            labelen:
                "Autres personnes morales dont l'immatriculation est prévue par l'article 1 de la loi modifiée du 19 décembre 2002 concernant le registre de commerce et des sociétés ainsi que la comptabilité et les comptes annuels des entreprises"
        },
        {
            value: 'LCR0',
            labelcz: "Groupement d'intérêt économique",
            labelen: "Groupement d'intérêt économique"
        },
        { value: 'SQ1A', labelcz: 'Société civile', labelen: 'Société civile' },
        {
            value: 'STBC',
            labelcz: 'Société coopérative organisée sous forme de société anonyme',
            labelen: 'Société coopérative organisée sous forme de société anonyme'
        },
        {
            value: 'U8KA',
            labelcz: 'Société en commandite spéciale',
            labelen: 'Société en commandite spéciale'
        },
        {
            value: 'UDY2',
            labelcz: "Société d'investissement à capital variable",
            labelen: "Société d'investissement à capital variable"
        },
        { value: 'V19Y', labelcz: 'Fondation', labelen: 'Fondation' },
        {
            value: 'V5OS',
            labelcz: 'Société coopérative',
            labelen: 'Société coopérative'
        },
        {
            value: 'WCEP',
            labelcz: 'société européenne',
            labelen: 'société européenne'
        },
        {
            value: 'ZFFA',
            labelcz: 'Etablissement public',
            labelen: 'Etablissement public'
        }
    ],
    MY: [
        { value: '7OYN', labelcz: 'Public Company', labelen: 'Public Company' },
        {
            value: 'SP51',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: 'SV3F', labelcz: 'Business', labelen: 'Business' },
        { value: 'XEOV', labelcz: 'Private Company', labelen: 'Private Company' },
        {
            value: '2SPI',
            labelcz: 'Labuan Islamic Limited Partnership',
            labelen: 'Labuan Islamic Limited Partnership'
        },
        {
            value: '6HT0',
            labelcz: 'Labuan Limited Partnership',
            labelen: 'Labuan Limited Partnership'
        },
        {
            value: '95AW',
            labelcz: 'Labuan Islamic Charitable Trust',
            labelen: 'Labuan Islamic Charitable Trust'
        },
        {
            value: 'JH78',
            labelcz: 'Labuan Company (Limited By Guarantee)',
            labelen: 'Labuan Company (Limited By Guarantee)'
        },
        {
            value: 'LA66',
            labelcz: 'Labuan Islamic Other Trust',
            labelen: 'Labuan Islamic Other Trust'
        },
        {
            value: 'MEHL',
            labelcz: 'Labuan Islamic Recognized Limited Liability Partnership',
            labelen: 'Labuan Islamic Recognized Limited Liability Partnership'
        },
        {
            value: 'NO8C',
            labelcz: 'Labuan Foreign Company',
            labelen: 'Labuan Foreign Company'
        },
        {
            value: 'NY3P',
            labelcz: 'Labuan Islamic Special Trust',
            labelen: 'Labuan Islamic Special Trust'
        },
        {
            value: 'OO14',
            labelcz: 'Labuan Islamic Limited Liability Partnership',
            labelen: 'Labuan Islamic Limited Liability Partnership'
        },
        {
            value: 'P0LR',
            labelcz: 'Labuan Company (Unlimited)',
            labelen: 'Labuan Company (Unlimited)'
        },
        {
            value: 'P0TZ',
            labelcz: 'Labuan Limited Liability Partnerships',
            labelen: 'Labuan Limited Liability Partnerships'
        },
        { value: 'PBQH', labelcz: 'Labuan Trust', labelen: 'Labuan Trust' },
        {
            value: 'PWX8',
            labelcz: 'Labuan Islamic Foundation',
            labelen: 'Labuan Islamic Foundation'
        },
        {
            value: 'QOO6',
            labelcz: 'Labuan Protected Cell Company',
            labelen: 'Labuan Protected Cell Company'
        },
        {
            value: 'S7R4',
            labelcz: 'Labuan Pre-Incorporated Company',
            labelen: 'Labuan Pre-Incorporated Company'
        },
        {
            value: 'SP0A',
            labelcz: 'Labuan Foundation',
            labelen: 'Labuan Foundation'
        },
        {
            value: 'T5HS',
            labelcz: 'Labuan Isalmic Trust',
            labelen: 'Labuan Isalmic Trust'
        },
        {
            value: 'T635',
            labelcz: 'Labuan Islamic Spendthrift/Protective Trust',
            labelen: 'Labuan Islamic Spendthrift/Protective Trust'
        },
        {
            value: 'TGWE',
            labelcz: 'Labuan Islamic Purpose Trust',
            labelen: 'Labuan Islamic Purpose Trust'
        },
        {
            value: 'TXCW',
            labelcz: 'Labuan Recognized Limited Liability Partnership',
            labelen: 'Labuan Recognized Limited Liability Partnership'
        },
        {
            value: 'ZWYK',
            labelcz: 'Labuan Company (Limited By Share)',
            labelen: 'Labuan Company (Limited By Share)'
        }
    ],
    MT: [
        { value: '3U3Y', labelcz: 'foundation', labelen: 'foundation' },
        {
            value: '9QHJ',
            labelcz: 'government entity',
            labelen: 'government entity'
        },
        {
            value: 'BVJ0',
            labelcz: 'Partnership en commendite or limited partnership',
            labelen: 'Partnership en commendite or limited partnership'
        },
        {
            value: 'C061',
            labelcz: 'Public Limited Liability Company',
            labelen: 'Public Limited Liability Company'
        },
        { value: 'CR7N', labelcz: 'European Company', labelen: 'European Company' },
        { value: 'DJ2D', labelcz: 'sole trader', labelen: 'sole trader' },
        { value: 'F5X7', labelcz: 'cooperative', labelen: 'cooperative' },
        { value: 'J4S1', labelcz: 'association', labelen: 'association' },
        {
            value: 'JOZN',
            labelcz: 'Partnership en nom collectif',
            labelen: 'Partnership en nom collectif'
        },
        {
            value: 'V89C',
            labelcz: 'Private Limited Liability Company',
            labelen: 'Private Limited Liability Company'
        },
        {
            value: 'YB0U',
            labelcz: 'European Economic Interest Grouping',
            labelen: 'European Economic Interest Grouping'
        }
    ],
    MH: [
        { value: 'DSII', labelcz: 'Corporation', labelen: 'Corporation' },
        {
            value: 'EZL8',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'S69C',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: 'UW1C', labelcz: 'Partnership', labelen: 'Partnership' }
    ],
    MU: [
        { value: '4AJY', labelcz: 'Business', labelen: 'Business' },
        {
            value: '6M6Z',
            labelcz: 'Public Companies Limited By Guarantee',
            labelen: 'Public Companies Limited By Guarantee'
        },
        {
            value: 'AOS4',
            labelcz: 'Private Companies Limited By Guarantee',
            labelen: 'Private Companies Limited By Guarantee'
        },
        {
            value: 'B0LD',
            labelcz: 'Ministries And Parastal Bodies',
            labelen: 'Ministries And Parastal Bodies'
        },
        { value: 'BVPF', labelcz: 'Cooperatives', labelen: 'Cooperatives' },
        {
            value: 'G7H0',
            labelcz: 'Private Companies',
            labelen: 'Private Companies'
        },
        {
            value: 'J76S',
            labelcz: 'Limited Partnerships',
            labelen: 'Limited Partnerships'
        },
        { value: 'JWWT', labelcz: 'Foundations', labelen: 'Foundations' },
        { value: 'O786', labelcz: 'Société', labelen: 'Société' },
        { value: 'RJYT', labelcz: 'Trade Unions', labelen: 'Trade Unions' },
        {
            value: 'RTVE',
            labelcz: 'Limited Liability Partnerships',
            labelen: 'Limited Liability Partnerships'
        },
        { value: 'S2J1', labelcz: 'Others', labelen: 'Others' },
        { value: 'XXCZ', labelcz: 'Public Companies', labelen: 'Public Companies' },
        { value: 'ZTUI', labelcz: 'Associations', labelen: 'Associations' }
    ],
    MX: [
        {
            value: '23XJ',
            labelcz: 'Sociedad anónima de capital variable, sociedad de información crediticia',
            labelen: 'Sociedad anónima de capital variable, sociedad de información crediticia'
        },
        {
            value: '2LNV',
            labelcz: 'Sociedad anónima de capital variable, institución de seguros',
            labelen: 'Sociedad anónima de capital variable, institución de seguros'
        },
        { value: '2NAI', labelcz: 'Comunidad', labelen: 'Comunidad' },
        {
            value: '2RVP',
            labelcz:
                'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
            labelen:
                'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        { value: '31N9', labelcz: 'Partido político', labelen: 'Partido político' },
        {
            value: '3WVI',
            labelcz: 'Sociedad de Responsabilidad Limitada Microindustrial',
            labelen: 'Sociedad de Responsabilidad Limitada Microindustrial'
        },
        {
            value: '449I',
            labelcz: 'Sociedad de responsabilidad limitada',
            labelen: 'Sociedad de responsabilidad limitada'
        },
        {
            value: '4HBI',
            labelcz: 'Sociedad cooperativa de ahorro y préstamo de capital variable',
            labelen: 'Sociedad cooperativa de ahorro y préstamo de capital variable'
        },
        { value: '5AWU', labelcz: 'Asociación civil', labelen: 'Asociación civil' },
        {
            value: '5K70',
            labelcz: 'Sociedad anónima bursátil de capital variable, casa de bolsa',
            labelen: 'Sociedad anónima bursátil de capital variable, casa de bolsa'
        },
        {
            value: '6EYT',
            labelcz: 'Sociedad por acciones simplificada de capital variable',
            labelen: 'Sociedad por acciones simplificada de capital variable'
        },
        {
            value: '761Z',
            labelcz: 'Sociedad de producción rural de responsabilidad limitada de capital variable',
            labelen: 'Sociedad de producción rural de responsabilidad limitada de capital variable'
        },
        {
            value: '776G',
            labelcz: 'Sociedad de producción rural de responsabilidad ilimitada',
            labelen: 'Sociedad de producción rural de responsabilidad ilimitada'
        },
        {
            value: '784B',
            labelcz: 'Sociedad anónima de capital variable, sociedad controladora',
            labelen: 'Sociedad anónima de capital variable, sociedad controladora'
        },
        {
            value: '7G15',
            labelcz: 'Sociedad Nacional de Crédito',
            labelen: 'Sociedad Nacional de Crédito'
        },
        { value: '7H63', labelcz: 'Sociedad civil', labelen: 'Sociedad civil' },
        {
            value: '7L83',
            labelcz: 'Unión ganadera regional especializada',
            labelen: 'Unión ganadera regional especializada'
        },
        {
            value: '7PKK',
            labelcz: 'Sociedad en comandita simple de capital variable',
            labelen: 'Sociedad en comandita simple de capital variable'
        },
        {
            value: '8AGD',
            labelcz: 'Unión ganadera regional general',
            labelen: 'Unión ganadera regional general'
        },
        {
            value: '8M3D',
            labelcz: 'Sociedad cooperativa de productores de bienes y/o servicios de capital variable',
            labelen: 'Sociedad cooperativa de productores de bienes y/o servicios de capital variable'
        },
        {
            value: '8MY7',
            labelcz: 'Sociedad anónima de capital variable, valuadora de acciones de fondos de inversión',
            labelen: 'Sociedad anónima de capital variable, valuadora de acciones de fondos de inversión'
        },
        {
            value: '8QZA',
            labelcz: 'Sociedad cooperativa de responsabilidad limitada de capital variable',
            labelen: 'Sociedad cooperativa de responsabilidad limitada de capital variable'
        },
        {
            value: '8RRB',
            labelcz: 'Sociedad cooperativa de ahorro y préstamo',
            labelen: 'Sociedad cooperativa de ahorro y préstamo'
        },
        {
            value: '8ZUV',
            labelcz: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad regulada',
            labelen: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: '96OC',
            labelcz: 'Sociedad cooperativa',
            labelen: 'Sociedad cooperativa'
        },
        {
            value: 'A2A8',
            labelcz: 'Sociedad en comandita por acciones',
            labelen: 'Sociedad en comandita por acciones'
        },
        {
            value: 'ANXC',
            labelcz: 'Federación de sindicatos',
            labelen: 'Federación de sindicatos'
        },
        { value: 'AOKU', labelcz: 'Unión de ejidos', labelen: 'Unión de ejidos' },
        {
            value: 'B3WQ',
            labelcz: 'Sociedad anónima de capital variable, unión de crédito',
            labelen: 'Sociedad anónima de capital variable, unión de crédito'
        },
        { value: 'B8CE', labelcz: 'Sociedad anónima', labelen: 'Sociedad anónima' },
        {
            value: 'BFIV',
            labelcz: 'Sociedad anónima, casa de cambio',
            labelen: 'Sociedad anónima, casa de cambio'
        },
        {
            value: 'BOF1',
            labelcz: 'Sociedad en nombre colectivo',
            labelen: 'Sociedad en nombre colectivo'
        },
        {
            value: 'C4Z4',
            labelcz: 'Asociación rural de interés colectivo',
            labelen: 'Asociación rural de interés colectivo'
        },
        {
            value: 'CAF9',
            labelcz: 'Sociedad anónima, centro cambiario',
            labelen: 'Sociedad anónima, centro cambiario'
        },
        {
            value: 'COVJ',
            labelcz: 'Organismo de integración financiera rural',
            labelen: 'Organismo de integración financiera rural'
        },
        {
            value: 'CU5R',
            labelcz: 'Asociación ganadera local general',
            labelen: 'Asociación ganadera local general'
        },
        {
            value: 'CU68',
            labelcz: 'Sociedad cooperativa limitada de capital variable',
            labelen: 'Sociedad cooperativa limitada de capital variable'
        },
        {
            value: 'DBU3',
            labelcz: 'Sociedad anónima  de capital variable, financiera comunitaria',
            labelen: 'Sociedad anónima  de capital variable, financiera comunitaria'
        },
        {
            value: 'DHY2',
            labelcz: 'Sociedad anónima financiera comunitaria',
            labelen: 'Sociedad anónima financiera comunitaria'
        },
        {
            value: 'DNF1',
            labelcz: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad no regulada',
            labelen: 'Sociedad anónima, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: 'DU8H',
            labelcz: 'Sociedad cooperativa de consumidores de bienes y/o servicios de capital variable',
            labelen: 'Sociedad cooperativa de consumidores de bienes y/o servicios de capital variable'
        },
        {
            value: 'E0YZ',
            labelcz: 'Sociedad de producción rural de responsabilidad suplementada',
            labelen: 'Sociedad de producción rural de responsabilidad suplementada'
        },
        {
            value: 'EHWD',
            labelcz: 'Sociedad anónima de capital variable, de inversión especializada de fondos para el retiro',
            labelen: 'Sociedad anónima de capital variable, de inversión especializada de fondos para el retiro'
        },
        {
            value: 'F3L5',
            labelcz: 'Fondos de Aseguramiento Agropecuario y Rural',
            labelen: 'Fondos de Aseguramiento Agropecuario y Rural'
        },
        {
            value: 'FVTS',
            labelcz: 'Unión de sociedades de producción rural',
            labelen: 'Unión de sociedades de producción rural'
        },
        {
            value: 'G3JV',
            labelcz: 'Sociedad anónima de capital variable, operadora de fondos de inversión',
            labelen: 'Sociedad anónima de capital variable, operadora de fondos de inversión'
        },
        {
            value: 'G522',
            labelcz: 'Sociedad cooperativa de consumidores de bienes y/o servicios',
            labelen: 'Sociedad cooperativa de consumidores de bienes y/o servicios'
        },
        {
            value: 'G73Q',
            labelcz: 'Sociedad anónima de capital variable, contraparte central de valores',
            labelen: 'Sociedad anónima de capital variable, contraparte central de valores'
        },
        {
            value: 'GNNT',
            labelcz: 'Sociedad anónima de capital variable, administradora de fondos para el retiro',
            labelen: 'Sociedad anónima de capital variable, administradora de fondos para el retiro'
        },
        {
            value: 'GW1T',
            labelcz: 'Sociedad anónima bursátil',
            labelen: 'Sociedad anónima bursátil'
        },
        {
            value: 'GXBE',
            labelcz:
                'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
            labelen:
                'Sociedad anónima promotora de inversión de capital variable, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: 'H725',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión de objeto limitado',
            labelen: 'Sociedad anónima de capital variable, fondo de inversión de objeto limitado'
        },
        {
            value: 'HKWO',
            labelcz:
                'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
            labelen: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: 'ICXT',
            labelcz: 'Sociedad anónima de capital variable, institución para el depósito de valores',
            labelen: 'Sociedad anónima de capital variable, institución para el depósito de valores'
        },
        {
            value: 'IWNQ',
            labelcz: 'Sociedad anónima de capital variable, institución de financiamiento colectivo',
            labelen: 'Sociedad anónima de capital variable, institución de financiamiento colectivo'
        },
        {
            value: 'JGV1',
            labelcz: 'Sociedad anónima de capital variable',
            labelen: 'Sociedad anónima de capital variable'
        },
        {
            value: 'JN6Y',
            labelcz: 'Sociedad cooperativa de capital variable',
            labelen: 'Sociedad cooperativa de capital variable'
        },
        {
            value: 'JRAQ',
            labelcz: 'Agrupaciones financieras',
            labelen: 'Agrupaciones financieras'
        },
        {
            value: 'JSTL',
            labelcz: 'Sociedad de solidaridad social',
            labelen: 'Sociedad de solidaridad social'
        },
        { value: 'JZ1I', labelcz: 'Sindicato', labelen: 'Sindicato' },
        {
            value: 'L2MQ',
            labelcz: 'Sociedad de responsabilidad limitada de interés público de capital variable',
            labelen: 'Sociedad de responsabilidad limitada de interés público de capital variable'
        },
        {
            value: 'L9JC',
            labelcz: 'Sociedad anónima bursátil de capital variable',
            labelen: 'Sociedad anónima bursátil de capital variable'
        },
        {
            value: 'LBPW',
            labelcz: 'Sociedad anónima  de capital variable, financiera popular',
            labelen: 'Sociedad anónima  de capital variable, financiera popular'
        },
        {
            value: 'LJTR',
            labelcz: 'Sociedad por acciones simplificada',
            labelen: 'Sociedad por acciones simplificada'
        },
        {
            value: 'LOB9',
            labelcz: 'Sociedad propietaria de tierras agrícolas, ganaderas o forestales',
            labelen: 'Sociedad propietaria de tierras agrícolas, ganaderas o forestales'
        },
        {
            value: 'LVRX',
            labelcz: 'Sociedad anónima, almacén general de depósito, organización auxiliar del crédito',
            labelen: 'Sociedad anónima, almacén general de depósito, organización auxiliar del crédito'
        },
        { value: 'M0SL', labelcz: 'Municipio', labelen: 'Municipio' },
        {
            value: 'M44Q',
            labelcz: 'Sociedad anónima de capital variable, centro cambiario',
            labelen: 'Sociedad anónima de capital variable, centro cambiario'
        },
        {
            value: 'MAM6',
            labelcz: 'Institución de asistencia privada',
            labelen: 'Institución de asistencia privada'
        },
        { value: 'MB35', labelcz: 'Ejido', labelen: 'Ejido' },
        {
            value: 'N0JF',
            labelcz: 'Sociedad anónima, bolsa de valores',
            labelen: 'Sociedad anónima, bolsa de valores'
        },
        {
            value: 'N124',
            labelcz: 'Sociedad anónima de capital variable, institución de fondos de pago electrónico',
            labelen: 'Sociedad anónima de capital variable, institución de fondos de pago electrónico'
        },
        {
            value: 'NA09',
            labelcz: 'Asociación religiosa',
            labelen: 'Asociación religiosa'
        },
        {
            value: 'NHBK',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión de capitales',
            labelen: 'Sociedad anónima de capital variable, fondo de inversión de capitales'
        },
        {
            value: 'NSZI',
            labelcz: 'Unidad agrícola industrial de la mujer',
            labelen: 'Unidad agrícola industrial de la mujer'
        },
        {
            value: 'O15R',
            labelcz: 'Sociedad anónima de capital variable, casa de cambio',
            labelen: 'Sociedad anónima de capital variable, casa de cambio'
        },
        {
            value: 'OZ3O',
            labelcz: 'Sociedad anónima promotora de inversión bursátil',
            labelen: 'Sociedad anónima promotora de inversión bursátil'
        },
        {
            value: 'P28E',
            labelcz: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad regulada',
            labelen: 'Sociedad anónima de capital variable, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: 'P7VS',
            labelcz: 'Sociedad anónima institución de fianzas',
            labelen: 'Sociedad anónima institución de fianzas'
        },
        {
            value: 'P8D7',
            labelcz: 'Sociedad anónima institución de banca múltiple',
            labelen: 'Sociedad anónima institución de banca múltiple'
        },
        {
            value: 'PG49',
            labelcz: 'Confederación de sindicatos',
            labelen: 'Confederación de sindicatos'
        },
        {
            value: 'Q7WY',
            labelcz:
                'Sociedad anónima de capital variable, almacén general de depósito, organización auxiliar del crédito',
            labelen:
                'Sociedad anónima de capital variable, almacén general de depósito, organización auxiliar del crédito'
        },
        {
            value: 'QAUY',
            labelcz: 'Sociedad de producción rural de responsabilidad limitada',
            labelen: 'Sociedad de producción rural de responsabilidad limitada'
        },
        {
            value: 'QM7Z',
            labelcz: 'Sociedad anónima de capital variable, casa de bolsa',
            labelen: 'Sociedad anónima de capital variable, casa de bolsa'
        },
        {
            value: 'QZB4',
            labelcz: 'Sociedad anónima bursátil de capital variable, bolsa de valores',
            labelen: 'Sociedad anónima bursátil de capital variable, bolsa de valores'
        },
        {
            value: 'R8PY',
            labelcz: 'Sociedad anónima de capital variable, bolsa de valores',
            labelen: 'Sociedad anónima de capital variable, bolsa de valores'
        },
        {
            value: 'RCE0',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión de renta variable',
            labelen: 'Sociedad anónima de capital variable, fondo de inversión de renta variable'
        },
        {
            value: 'RCJS',
            labelcz: 'Corporaciones de carácter público reconocidos por la legislación mexicana',
            labelen: 'Corporaciones de carácter público reconocidos por la legislación mexicana'
        },
        {
            value: 'RKLI',
            labelcz: 'Sociedad anónima, sociedad de información crediticia',
            labelen: 'Sociedad anónima, sociedad de información crediticia'
        },
        {
            value: 'RQDD',
            labelcz: 'Sociedad anónima bursátil, sociedad financiera de objeto múltiple, entidad regulada',
            labelen: 'Sociedad anónima bursátil, sociedad financiera de objeto múltiple, entidad regulada'
        },
        {
            value: 'RR3L',
            labelcz: 'Sociedad anónima promotora de inversión bursátil de capital variable',
            labelen: 'Sociedad anónima promotora de inversión bursátil de capital variable'
        },
        {
            value: 'S6M8',
            labelcz: 'Sociedad nacional de crédito institución de banca de desarrollo',
            labelen: 'Sociedad nacional de crédito institución de banca de desarrollo'
        },
        {
            value: 'S8DM',
            labelcz: 'Sociedad anónima institución de seguros',
            labelen: 'Sociedad anónima institución de seguros'
        },
        {
            value: 'SKO4',
            labelcz: 'Sociedad mutualista',
            labelen: 'Sociedad mutualista'
        },
        {
            value: 'TPJZ',
            labelcz: 'Sociedad anónima promotora de inversión',
            labelen: 'Sociedad anónima promotora de inversión'
        },
        {
            value: 'TTIF',
            labelcz:
                'Sociedad anónima bursátil de capital variable, sociedad financiera de objeto múltiple, entidad no regulada',
            labelen:
                'Sociedad anónima bursátil de capital variable, sociedad financiera de objeto múltiple, entidad no regulada'
        },
        {
            value: 'TYW0',
            labelcz: 'Sociedad anónima bursátil de capital variable, sociedad controladora',
            labelen: 'Sociedad anónima bursátil de capital variable, sociedad controladora'
        },
        {
            value: 'U77P',
            labelcz: 'Sociedad anónima de capital variable, institución de fianzas',
            labelen: 'Sociedad anónima de capital variable, institución de fianzas'
        },
        {
            value: 'U901',
            labelcz: 'Instituciones de Seguros',
            labelen: 'Instituciones de Seguros'
        },
        {
            value: 'UBV0',
            labelcz: 'Sociedad anónima de capital variable, fondo de inversión en instrumentos de deuda',
            labelen: 'Sociedad anónima de capital variable, fondo de inversión en instrumentos de deuda'
        },
        {
            value: 'VATV',
            labelcz: 'Sociedad anónima promotora de inversión de capital variable',
            labelen: 'Sociedad anónima promotora de inversión de capital variable'
        },
        { value: 'VIOQ', labelcz: 'Estado', labelen: 'Estado' },
        {
            value: 'VN3F',
            labelcz: 'Sociedad cooperativa de productores de bienes y/o servicios',
            labelen: 'Sociedad cooperativa de productores de bienes y/o servicios'
        },
        {
            value: 'W9WS',
            labelcz: 'Empresa productiva del estado',
            labelen: 'Empresa productiva del estado'
        },
        {
            value: 'X9J8',
            labelcz: 'Asociación ganadera local especializada',
            labelen: 'Asociación ganadera local especializada'
        },
        {
            value: 'XDGC',
            labelcz: 'Sociedad cooperativa limitada',
            labelen: 'Sociedad cooperativa limitada'
        },
        {
            value: 'XEN5',
            labelcz: 'Sociedad en comandita simple',
            labelen: 'Sociedad en comandita simple'
        },
        {
            value: 'XLVZ',
            labelcz: 'Sociedad de responsabilidad limitada de capital variable',
            labelen: 'Sociedad de responsabilidad limitada de capital variable'
        },
        {
            value: 'XSZY',
            labelcz: 'Sociedad anónima financiera popular',
            labelen: 'Sociedad anónima financiera popular'
        },
        {
            value: 'YRI0',
            labelcz: 'Fideicomiso público de fomento económico',
            labelen: 'Fideicomiso público de fomento económico'
        },
        {
            value: 'ZAIS',
            labelcz: 'Sociedad en nombre colectivo de capital variable',
            labelen: 'Sociedad en nombre colectivo de capital variable'
        },
        {
            value: 'ZXVG',
            labelcz: 'Sociedad en comandita por acciones de capital variable',
            labelen: 'Sociedad en comandita por acciones de capital variable'
        }
    ],
    NL: [
        { value: '33MN', labelcz: 'vereniging', labelen: 'vereniging' },
        { value: '4QXM', labelcz: 'eenmanszaak', labelen: 'eenmanszaak' },
        {
            value: '54M6',
            labelcz: 'besloten vennootschap met beperkte aansprakelijkheid',
            labelen: 'besloten vennootschap met beperkte aansprakelijkheid'
        },
        {
            value: '5WU6',
            labelcz: 'Europees Economisch Samenwerkingsverband',
            labelen: 'Europees Economisch Samenwerkingsverband'
        },
        {
            value: '62Y3',
            labelcz: 'vennootschap onder firma',
            labelen: 'vennootschap onder firma'
        },
        { value: '9AAK', labelcz: 'maatschap', labelen: 'maatschap' },
        {
            value: 'A0W7',
            labelcz: 'publiekrechtelijke rechtspersoon',
            labelen: 'publiekrechtelijke rechtspersoon'
        },
        {
            value: 'B5PM',
            labelcz: 'naamloze vennootschap',
            labelen: 'naamloze vennootschap'
        },
        {
            value: 'BBEB',
            labelcz: 'Europese naamloze vennootschap (Societas Europaea)',
            labelen: 'Europese naamloze vennootschap (Societas Europaea)'
        },
        {
            value: 'CODH',
            labelcz: 'commanditaire vennootschap',
            labelen: 'commanditaire vennootschap'
        },
        {
            value: 'DEO1',
            labelcz: 'onderlinge waarborgmaatschappij',
            labelen: 'onderlinge waarborgmaatschappij'
        },
        {
            value: 'EZQW',
            labelcz: 'rechtspersoon in oprichting',
            labelen: 'rechtspersoon in oprichting'
        },
        {
            value: 'GNXT',
            labelcz: 'vereniging van eigenaars',
            labelen: 'vereniging van eigenaars'
        },
        {
            value: 'JHK5',
            labelcz: 'fonds voor gemene rekening',
            labelen: 'fonds voor gemene rekening'
        },
        { value: 'L7HX', labelcz: 'kerkgenootschap', labelen: 'kerkgenootschap' },
        {
            value: 'M1IZ',
            labelcz: 'Overige Privaatrechtelijke Rechtspersoon',
            labelen: 'Overige Privaatrechtelijke Rechtspersoon'
        },
        { value: 'NFFH', labelcz: 'coöperatie', labelen: 'coöperatie' },
        { value: 'UNJ2', labelcz: 'rederij', labelen: 'rederij' },
        { value: 'V44D', labelcz: 'stichting', labelen: 'stichting' },
        {
            value: 'Y3ZB',
            labelcz: 'Societas Cooperativa Europaea',
            labelen: 'Societas Cooperativa Europaea'
        }
    ],
    NZ: [
        {
            value: '4LEA',
            labelcz: 'Unlimited Liability Company',
            labelen: 'Unlimited Liability Company'
        },
        {
            value: 'F7KI',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'P2R9',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'Z6ZU',
            labelcz: 'Cooperative Company',
            labelen: 'Cooperative Company'
        }
    ],
    MK: [
        {
            value: '149O',
            labelcz: 'Komanditno drustvo so akcii',
            labelen: 'Komanditno drustvo so akcii'
        },
        {
            value: 'DTIU',
            labelcz: 'Akcionersko drustvo',
            labelen: 'Akcionersko drustvo'
        },
        {
            value: 'HEXO',
            labelcz: 'Javno trgovsko pretprijatie',
            labelen: 'Javno trgovsko pretprijatie'
        },
        {
            value: 'JCK1',
            labelcz: 'Stopanska interesna zaednica',
            labelen: 'Stopanska interesna zaednica'
        },
        {
            value: 'KHAB',
            labelcz: 'Drustvo so ogranicena odgvornost',
            labelen: 'Drustvo so ogranicena odgvornost'
        },
        {
            value: 'KXDY',
            labelcz: 'Podruznica na stransko trgovsko drustvo, odnosno na stranski trgovec poedinec',
            labelen: 'Podruznica na stransko trgovsko drustvo, odnosno na stranski trgovec poedinec'
        },
        { value: 'VPFY', labelcz: 'Trgovec poedinec', labelen: 'Trgovec poedinec' },
        {
            value: 'XH7Z',
            labelcz: 'Komanditno drustvo',
            labelen: 'Komanditno drustvo'
        }
    ],
    NO: [
        {
            value: '326Y',
            labelcz: 'Ansvarlig selskap',
            labelen: 'Ansvarlig selskap'
        },
        { value: '3C7U', labelcz: 'Stiftelse', labelen: 'Stiftelse' },
        {
            value: '3L58',
            labelcz: 'Kommunalt foretak',
            labelen: 'Kommunalt foretak'
        },
        {
            value: '4ZRR',
            labelcz: 'Norskregistrert utenlandsk foretak',
            labelen: 'Norskregistrert utenlandsk foretak'
        },
        { value: '50TD', labelcz: 'Statsforetak', labelen: 'Statsforetak' },
        {
            value: '5ZTZ',
            labelcz: 'Fylkeskommunalt foretak',
            labelen: 'Fylkeskommunalt foretak'
        },
        {
            value: '8S9H',
            labelcz: 'Gjensidig forsikringsselskap',
            labelen: 'Gjensidig forsikringsselskap'
        },
        { value: '9DI1', labelcz: 'Boligbyggelag', labelen: 'Boligbyggelag' },
        { value: 'AEV1', labelcz: 'Partrederi', labelen: 'Partrederi' },
        { value: 'BJ65', labelcz: 'Pensjonskasse', labelen: 'Pensjonskasse' },
        {
            value: 'CF5L',
            labelcz: 'Ansvarlig selskap, delt ansvar',
            labelen: 'Ansvarlig selskap, delt ansvar'
        },
        {
            value: 'DRPL',
            labelcz: 'Europeisk økonomisk foretaksgruppe',
            labelen: 'Europeisk økonomisk foretaksgruppe'
        },
        {
            value: 'EXD7',
            labelcz: 'Enkeltpersonforetak',
            labelen: 'Enkeltpersonforetak'
        },
        {
            value: 'FSBD',
            labelcz: 'Forening/lag/innretning (eller bare forening?)',
            labelen: 'Forening/lag/innretning (eller bare forening?)'
        },
        {
            value: 'GYY6',
            labelcz: 'Annen juridisk person',
            labelen: 'Annen juridisk person'
        },
        {
            value: 'IQGE',
            labelcz: 'Allmennaksjeselskap',
            labelen: 'Allmennaksjeselskap'
        },
        { value: 'K5P8', labelcz: 'Samvirkeforetak', labelen: 'Samvirkeforetak' },
        { value: 'LJJW', labelcz: 'Verdipapirfond', labelen: 'Verdipapirfond' },
        {
            value: 'M9IQ',
            labelcz: 'Kommandittselskap',
            labelen: 'Kommandittselskap'
        },
        { value: 'O0EU', labelcz: 'Borettslag', labelen: 'Borettslag' },
        {
            value: 'O7LB',
            labelcz: 'Europeisk samvirkeforetak',
            labelen: 'Europeisk samvirkeforetak'
        },
        { value: 'PB3V', labelcz: 'Konkursbo', labelen: 'Konkursbo' },
        {
            value: 'Q0Q1',
            labelcz: 'Selskap med begrenset ansvar',
            labelen: 'Selskap med begrenset ansvar'
        },
        { value: 'R71C', labelcz: 'Sparebank', labelen: 'Sparebank' },
        {
            value: 'V06W',
            labelcz: 'Europeisk selskap',
            labelen: 'Europeisk selskap'
        },
        { value: 'YI42', labelcz: 'Aksjeselskap', labelen: 'Aksjeselskap' },
        {
            value: 'YTMC',
            labelcz: 'Interkommunalt selskap',
            labelen: 'Interkommunalt selskap'
        },
        {
            value: 'ZQ0Q',
            labelcz: 'Eierseksjonssameie',
            labelen: 'Eierseksjonssameie'
        }
    ],
    PK: [
        {
            value: '4XMS',
            labelcz: 'Private Limited Company(multi member)',
            labelen: 'Private Limited Company(multi member)'
        },
        {
            value: '7IYW',
            labelcz: 'Company Limited by Guarantee( having share capital)',
            labelen: 'Company Limited by Guarantee( having share capital)'
        },
        {
            value: '88OX',
            labelcz: 'Private Limited Company(Single member)',
            labelen: 'Private Limited Company(Single member)'
        },
        {
            value: 'LH0Q',
            labelcz: 'Unlimited Company',
            labelen: 'Unlimited Company'
        },
        {
            value: 'MOI8',
            labelcz: 'Public Limited Company(not-for profit association)',
            labelen: 'Public Limited Company(not-for profit association)'
        },
        {
            value: 'QR25',
            labelcz: 'Company Limited by Guarantee( without share capital)',
            labelen: 'Company Limited by Guarantee( without share capital)'
        },
        {
            value: 'RKYF',
            labelcz: 'Public Limited Company(unlisted)',
            labelen: 'Public Limited Company(unlisted)'
        },
        {
            value: 'VQV6',
            labelcz: 'Public Limited Company (listed)',
            labelen: 'Public Limited Company (listed)'
        },
        {
            value: 'XBK3',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        }
    ],
    PA: [
        { value: '6TPA', labelcz: 'Sociedad Anónima', labelen: 'Sociedad Anónima' },
        { value: 'BSN7', labelcz: 'Asociación', labelen: 'Asociación' },
        { value: 'GDT9', labelcz: 'Sociedad Civil', labelen: 'Sociedad Civil' },
        {
            value: 'JS13',
            labelcz: 'Sociedad de Responsabilidad Limitada',
            labelen: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: 'PY5Y',
            labelcz: 'Sociedad en Comandita por acciones',
            labelen: 'Sociedad en Comandita por acciones'
        },
        {
            value: 'UNCO',
            labelcz: 'Fundación de Interés Privado',
            labelen: 'Fundación de Interés Privado'
        },
        {
            value: 'V5VG',
            labelcz: 'Sociedad en Comandita simple',
            labelen: 'Sociedad en Comandita simple'
        },
        {
            value: 'VIMA',
            labelcz: 'Micro-empresa de Responsabilidad Limitada',
            labelen: 'Micro-empresa de Responsabilidad Limitada'
        }
    ],
    PG: [
        { value: '6UED', labelcz: 'Local Company', labelen: 'Local Company' },
        {
            value: 'WHCV',
            labelcz: 'Foreign Enterprise',
            labelen: 'Foreign Enterprise'
        },
        { value: 'ZE1G', labelcz: 'Overseas Company', labelen: 'Overseas Company' }
    ],
    PY: [
        {
            value: '48X2',
            labelcz: 'Empresa Unipersonal De Responsabilidad Limitada',
            labelen: 'Empresa Unipersonal De Responsabilidad Limitada'
        },
        {
            value: '4QBB',
            labelcz: 'Sociedad En Comandita Simple',
            labelen: 'Sociedad En Comandita Simple'
        },
        {
            value: '78SG',
            labelcz: 'Empresa Unipersonal',
            labelen: 'Empresa Unipersonal'
        },
        { value: 'IJAO', labelcz: 'Sociedad Anonima', labelen: 'Sociedad Anonima' },
        {
            value: 'K08V',
            labelcz: 'Sociedad De Responsabilidad Limitada',
            labelen: 'Sociedad De Responsabilidad Limitada'
        },
        {
            value: 'LNG8',
            labelcz: 'Sociedad En Comandita Por Acciones',
            labelen: 'Sociedad En Comandita Por Acciones'
        }
    ],
    PE: [
        {
            value: '1MQ6',
            labelcz: 'Sociedad en Comandita por Acciones',
            labelen: 'Sociedad en Comandita por Acciones'
        },
        {
            value: '37G2',
            labelcz: 'Sociedad por Acciones Cerrada Simplificada',
            labelen: 'Sociedad por Acciones Cerrada Simplificada'
        },
        {
            value: '3LHF',
            labelcz: 'Sociedad Colectiva',
            labelen: 'Sociedad Colectiva'
        },
        {
            value: '4LCX',
            labelcz: 'Empresas de Derecho Público',
            labelen: 'Empresas de Derecho Público'
        },
        {
            value: '649C',
            labelcz: 'Sociedad Civil de Responsabilidad Limitada',
            labelen: 'Sociedad Civil de Responsabilidad Limitada'
        },
        {
            value: '73C0',
            labelcz: 'Sociedad Comercial de Responsabilidad Limitada',
            labelen: 'Sociedad Comercial de Responsabilidad Limitada'
        },
        {
            value: 'AABQ',
            labelcz: 'Empresas Multicomunales',
            labelen: 'Empresas Multicomunales'
        },
        {
            value: 'CHX6',
            labelcz: 'Sociedad Anónima Cerrada',
            labelen: 'Sociedad Anónima Cerrada'
        },
        {
            value: 'H8G2',
            labelcz: 'Empresa Individual de Responsabilidad Limitada',
            labelen: 'Empresa Individual de Responsabilidad Limitada'
        },
        { value: 'I695', labelcz: 'Socieda Anónima', labelen: 'Socieda Anónima' },
        { value: 'P53M', labelcz: 'Cooperativas', labelen: 'Cooperativas' },
        {
            value: 'PKRY',
            labelcz: 'Socieda Anónima Abierta',
            labelen: 'Socieda Anónima Abierta'
        },
        { value: 'QQWG', labelcz: 'Sociedad Civil', labelen: 'Sociedad Civil' },
        {
            value: 'RFJT',
            labelcz: 'Sociedad en Comandita Simple',
            labelen: 'Sociedad en Comandita Simple'
        },
        { value: 'YMBC', labelcz: 'Sociedad legal', labelen: 'Sociedad legal' }
    ],
    PL: [
        {
            value: '85PM',
            labelcz: 'Europejskie Zgrupowanie Interesów Gospodarczych',
            labelen: 'Europejskie Zgrupowanie Interesów Gospodarczych'
        },
        { value: 'B21W', labelcz: 'prosta spółka akcyjna', labelen: 'prosta spółka akcyjna' },
        {
            value: '13ZV',
            labelcz: 'samodzielny publiczny zakład opieki zdrowotnej',
            labelen: 'samodzielny publiczny zakład opieki zdrowotnej'
        },
        {
            value: '3BJG',
            labelcz: 'spółka partnerska',
            labelen: 'spółka partnerska'
        },
        {
            value: '5F76',
            labelcz: 'cechy i izby rzemieślnicze, izby gospodarcze',
            labelen: 'cechy i izby rzemieślnicze, izby gospodarcze'
        },
        {
            value: '60BG',
            labelcz: 'organy władzy, administracji rządowej, kontroli państwowej i ochrony prawa oraz sądy i trybunały',
            labelen: 'organy władzy, administracji rządowej, kontroli państwowej i ochrony prawa oraz sądy i trybunały'
        },
        { value: '629I', labelcz: 'spółka jawna', labelen: 'spółka jawna' },
        {
            value: '6LUM',
            labelcz: 'główny oddział zagranicznego zakładu reasekuracji',
            labelen: 'główny oddział zagranicznego zakładu reasekuracji'
        },
        { value: '6OYI', labelcz: 'zrzeszenie', labelen: 'zrzeszenie' },
        { value: '8TOF', labelcz: 'spółdzielnia', labelen: 'spółdzielnia' },
        { value: '96XK', labelcz: 'fundacja', labelen: 'fundacja' },
        {
            value: 'AL9T',
            labelcz: 'samorządowe jednostki organizacyjne',
            labelen: 'samorządowe jednostki organizacyjne'
        },
        {
            value: 'BSJT',
            labelcz: 'spółka komandytowa',
            labelen: 'spółka komandytowa'
        },
        {
            value: 'CY1M',
            labelcz: 'instytucje gospodarki budżetowej',
            labelen: 'instytucje gospodarki budżetowej'
        },
        {
            value: 'EU0T',
            labelcz: 'towarzystwo reasekuracji wzajemnej',
            labelen: 'towarzystwo reasekuracji wzajemnej'
        },
        { value: 'F21U', labelcz: 'Skarb Państwa', labelen: 'Skarb Państwa' },
        { value: 'FANM', labelcz: 'kółka rolnicze', labelen: 'kółka rolnicze' },
        { value: 'FJ0E', labelcz: 'spółka akcyjna', labelen: 'spółka akcyjna' },
        {
            value: 'FQ5Y',
            labelcz: 'organizacje społeczne i zawodowe',
            labelen: 'organizacje społeczne i zawodowe'
        },
        {
            value: 'GZE5',
            labelcz: 'wspólnota mieszkaniowa',
            labelen: 'wspólnota mieszkaniowa'
        },
        {
            value: 'H7OD',
            labelcz: 'spółdzielcza kasa oszczędnościowo-kredytowa',
            labelen: 'spółdzielcza kasa oszczędnościowo-kredytowa'
        },
        {
            value: 'HOT8',
            labelcz: 'partie polityczne',
            labelen: 'partie polityczne'
        },
        {
            value: 'J3A3',
            labelcz: 'spółka europejska',
            labelen: 'spółka europejska'
        },
        {
            value: 'JCKO',
            labelcz: 'państwowe jednostki organizacyjne',
            labelen: 'państwowe jednostki organizacyjne'
        },
        {
            value: 'KM66',
            labelcz: 'instytuty badawcze',
            labelen: 'instytuty badawcze'
        },
        { value: 'LT9U', labelcz: 'związek zawodowy', labelen: 'związek zawodowy' },
        {
            value: 'O7XB',
            labelcz: 'spółka z ograniczoną odpowiedzialnością',
            labelen: 'spółka z ograniczoną odpowiedzialnością'
        },
        {
            value: 'OMX0',
            labelcz: 'spółka komandytowo-akcyjna',
            labelen: 'spółka komandytowo-akcyjna'
        },
        {
            value: 'P1L1',
            labelcz: 'główny oddział zagranicznego zakładu ubezpieczeń',
            labelen: 'główny oddział zagranicznego zakładu ubezpieczeń'
        },
        {
            value: 'QUX1',
            labelcz: 'otwarty fundusz emerytalny',
            labelen: 'otwarty fundusz emerytalny'
        },
        {
            value: 'QYL4',
            labelcz: 'placówki systemu oświaty',
            labelen: 'placówki systemu oświaty'
        },
        {
            value: 'RBHP',
            labelcz: 'fundusz inwestycyjny',
            labelen: 'fundusz inwestycyjny'
        },
        {
            value: 'RUCO',
            labelcz: 'oddział przedsiębiorcy zagranicznego',
            labelen: 'oddział przedsiębiorcy zagranicznego'
        },
        {
            value: 'SMIS',
            labelcz: 'przedsiębiorstwo państwowe',
            labelen: 'przedsiębiorstwo państwowe'
        },
        {
            value: 'SP4S',
            labelcz: 'kościoł i związki wyznaniowe',
            labelen: 'kościoł i związki wyznaniowe'
        },
        {
            value: 'SVA3',
            labelcz: 'fundusze inne niż inwestycyjne i inne niż otwarte fundusze emerytalne',
            labelen: 'fundusze inne niż inwestycyjne i inne niż otwarte fundusze emerytalne'
        },
        {
            value: 'T7PB',
            labelcz: 'wspólnoty samorządowe',
            labelen: 'wspólnoty samorządowe'
        },
        {
            value: 'WNX1',
            labelcz: 'towarzystwo ubezpieczeń wzajemnych',
            labelen: 'towarzystwo ubezpieczeń wzajemnych'
        },
        {
            value: 'WOK7',
            labelcz: 'związki inne niż zawodowe',
            labelen: 'związki inne niż zawodowe'
        },
        { value: 'WUJ2', labelcz: 'uczelnia', labelen: 'uczelnia' },
        { value: 'YLZL', labelcz: 'spółka cywilna', labelen: 'spółka cywilna' },
        {
            value: 'ZVVM',
            labelcz: 'osoby fizyczne prowadzące działalność gospodarczą',
            labelen: 'osoby fizyczne prowadzące działalność gospodarczą'
        },
        {
            value: 'ZZKE',
            labelcz: 'stowarzyszenie i związki stowarzyszeń',
            labelen: 'stowarzyszenie i związki stowarzyszeń'
        }
    ],
    PT: [
        { value: '1HGD', labelcz: 'Cooperativa', labelen: 'Cooperativa' },
        {
            value: '5KVH',
            labelcz: 'Cooperativa de 2º Grau',
            labelen: 'Cooperativa de 2º Grau'
        },
        {
            value: '68PD',
            labelcz: 'Representação Permanente',
            labelen: 'Representação Permanente'
        },
        {
            value: '6IK8',
            labelcz: 'Entidade Empresarial Intermunicipal',
            labelen: 'Entidade Empresarial Intermunicipal'
        },
        { value: '6L6P', labelcz: 'Fundo', labelen: 'Fundo' },
        {
            value: '99JD',
            labelcz: 'Agrupamento Europeu de Interesse Económico',
            labelen: 'Agrupamento Europeu de Interesse Económico'
        },
        {
            value: 'A8CT',
            labelcz: 'Entidade Pública Empresarial',
            labelen: 'Entidade Pública Empresarial'
        },
        { value: 'ALPT', labelcz: 'Associação', labelen: 'Associação' },
        {
            value: 'D7OA',
            labelcz: 'Entidade Empresarial Municipal',
            labelen: 'Entidade Empresarial Municipal'
        },
        {
            value: 'DFE5',
            labelcz: 'Sociedade Anónima',
            labelen: 'Sociedade Anónima'
        },
        {
            value: 'IX01',
            labelcz: 'Empresa Intermunicipal',
            labelen: 'Empresa Intermunicipal'
        },
        {
            value: 'KUUV',
            labelcz: 'Organismo da Administração Pública',
            labelen: 'Organismo da Administração Pública'
        },
        {
            value: 'MFHR',
            labelcz: 'Sociedade Anónima Europeia',
            labelen: 'Sociedade Anónima Europeia'
        },
        {
            value: 'N66B',
            labelcz: 'Sociedade em Nome Coletivo',
            labelen: 'Sociedade em Nome Coletivo'
        },
        {
            value: 'NIQY',
            labelcz: 'Entidade Empresarial Metropolitana',
            labelen: 'Entidade Empresarial Metropolitana'
        },
        {
            value: 'OXUC',
            labelcz: 'Sociedade em Comandita',
            labelen: 'Sociedade em Comandita'
        },
        {
            value: 'P5S3',
            labelcz: 'Pessoa Coletiva de Direito Público',
            labelen: 'Pessoa Coletiva de Direito Público'
        },
        {
            value: 'PIDC',
            labelcz: 'Empresa Municipal',
            labelen: 'Empresa Municipal'
        },
        {
            value: 'QFXD',
            labelcz: 'Pessoa Coletiva Internacional',
            labelen: 'Pessoa Coletiva Internacional'
        },
        {
            value: 'USOG',
            labelcz: 'Sociedade por Quotas',
            labelen: 'Sociedade por Quotas'
        },
        {
            value: 'VF4C',
            labelcz: 'Sociedade Unipessoal por Quotas',
            labelen: 'Sociedade Unipessoal por Quotas'
        },
        {
            value: 'W9W3',
            labelcz: 'Sociedade Anónima Desportiva',
            labelen: 'Sociedade Anónima Desportiva'
        },
        {
            value: 'XD16',
            labelcz: 'Empresa Metropolitana',
            labelen: 'Empresa Metropolitana'
        },
        { value: 'XMXM', labelcz: 'Fundo', labelen: 'Fundo' },
        {
            value: 'YMLD',
            labelcz: 'Agrupamento Complementar de Empresas',
            labelen: 'Agrupamento Complementar de Empresas'
        },
        { value: 'Z0NE', labelcz: 'Fundação', labelen: 'Fundação' },
        {
            value: 'ZILA',
            labelcz: 'Estabelecimento Individual de Responsabilidade Limitada',
            labelen: 'Estabelecimento Individual de Responsabilidade Limitada'
        },
        { value: 'ZSWE', labelcz: 'Empresa Regional', labelen: 'Empresa Regional' },
        { value: 'IKBN', labelcz: 'Trust', labelen: 'Trust' },
        {
            value: 'Z7ZX',
            labelcz: 'Sucursal Financeira Exterior',
            labelen: 'Sucursal Financeira Exterior'
        }
    ],
    PR: [
        {
            value: '194I',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        { value: '1TG4', labelcz: 'Low Profit LLC', labelen: 'Low Profit LLC' },
        {
            value: '35RF',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: '3QX8',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        { value: '4XY9', labelcz: 'Trust', labelen: 'Trust' },
        {
            value: '6DE6',
            labelcz: 'Close Corporation',
            labelen: 'Close Corporation'
        },
        {
            value: '7JAI',
            labelcz: 'Special Employee Owned Corporation',
            labelen: 'Special Employee Owned Corporation'
        },
        {
            value: '81YI',
            labelcz: 'International Financial Entity (LLC)',
            labelen: 'International Financial Entity (LLC)'
        },
        {
            value: '87N3',
            labelcz: 'Cooperativa de Consumo',
            labelen: 'Cooperativa de Consumo'
        },
        { value: '9EGO', labelcz: 'Bank (LLC)', labelen: 'Bank (LLC)' },
        {
            value: 'A4MM',
            labelcz: 'International Banking Center (Corporation)',
            labelen: 'International Banking Center (Corporation)'
        },
        {
            value: 'BQ6L',
            labelcz: 'Sponsored By Municipal Corporation',
            labelen: 'Sponsored By Municipal Corporation'
        },
        {
            value: 'C907',
            labelcz: 'Youth Cooperative',
            labelen: 'Youth Cooperative'
        },
        {
            value: 'D5L6',
            labelcz: 'Consumer Cooperative',
            labelen: 'Consumer Cooperative'
        },
        {
            value: 'D8XQ',
            labelcz: 'Municipal Enterprise',
            labelen: 'Municipal Enterprise'
        },
        {
            value: 'DE7H',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'E85L',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'EQQP',
            labelcz: 'Special Employee Owned Corporation',
            labelen: 'Special Employee Owned Corporation'
        },
        {
            value: 'ERUM',
            labelcz: 'Public Benefit Corporation',
            labelen: 'Public Benefit Corporation'
        },
        {
            value: 'GCP3',
            labelcz: 'International Financial Entity (LLC)',
            labelen: 'International Financial Entity (LLC)'
        },
        {
            value: 'GL33',
            labelcz: 'International Banking Center (Corporation)',
            labelen: 'International Banking Center (Corporation)'
        },
        {
            value: 'GRH5',
            labelcz: 'Workers Cooperative',
            labelen: 'Workers Cooperative'
        },
        {
            value: 'I1WG',
            labelcz: 'Municipal Enterprise',
            labelen: 'Municipal Enterprise'
        },
        {
            value: 'I6FV',
            labelcz: 'Savings & Credit Cooperative',
            labelen: 'Savings & Credit Cooperative'
        },
        { value: 'INDH', labelcz: 'Corporation', labelen: 'Corporation' },
        { value: 'JJ1V', labelcz: 'Trust', labelen: 'Trust' },
        {
            value: 'ME4Y',
            labelcz: 'Public Benefit Corporation',
            labelen: 'Public Benefit Corporation'
        },
        {
            value: 'O2JM',
            labelcz: 'Youth Cooperative',
            labelen: 'Youth Cooperative'
        },
        {
            value: 'O4QG',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'RA5B',
            labelcz: 'International Banking Center (LLC)',
            labelen: 'International Banking Center (LLC)'
        },
        {
            value: 'SOQ1',
            labelcz: 'Workers Cooperative',
            labelen: 'Workers Cooperative'
        },
        {
            value: 'SQXC',
            labelcz: 'Insurance Company',
            labelen: 'Insurance Company'
        },
        {
            value: 'T2JS',
            labelcz: 'Close Corporation',
            labelen: 'Close Corporation'
        },
        {
            value: 'TEGV',
            labelcz: 'Special Corporation for Municipal Development',
            labelen: 'Special Corporation for Municipal Development'
        },
        {
            value: 'TPFL',
            labelcz: 'Bank (Corporation)',
            labelen: 'Bank (Corporation)'
        },
        {
            value: 'UL6C',
            labelcz: 'Savings & Credit Cooperative',
            labelen: 'Savings & Credit Cooperative'
        },
        {
            value: 'VKSV',
            labelcz: 'Insurance Company',
            labelen: 'Insurance Company'
        },
        {
            value: 'W6NI',
            labelcz: 'International Financial Entity (Corporation)',
            labelen: 'International Financial Entity (Corporation)'
        },
        {
            value: 'XK6L',
            labelcz: 'International Financial Entity (Corporation)',
            labelen: 'International Financial Entity (Corporation)'
        },
        {
            value: 'XUYT',
            labelcz: 'International Banking Center (LLC)',
            labelen: 'International Banking Center (LLC)'
        },
        {
            value: 'Y21X',
            labelcz: 'Sponsored By Municipal Corporation',
            labelen: 'Sponsored By Municipal Corporation'
        },
        {
            value: 'Y3T2',
            labelcz: 'Special Corporation for Municipal Development',
            labelen: 'Special Corporation for Municipal Development'
        },
        { value: 'Y7LW', labelcz: 'Low Profit LLC', labelen: 'Low Profit LLC' },
        { value: 'YS16', labelcz: 'Corporation', labelen: 'Corporation' }
    ],
    RO: [
        {
            value: '1CDX',
            labelcz: 'Societate europeană',
            labelen: 'Societate europeană'
        },
        {
            value: '37II',
            labelcz: 'Cooperativă meșteșugărească',
            labelen: 'Cooperativă meșteșugărească'
        },
        {
            value: '4V0A',
            labelcz: 'Grupul european de interes economic',
            labelen: 'Grupul european de interes economic'
        },
        {
            value: '5NCK',
            labelcz: 'Organizație non-guvernamentală',
            labelen: 'Organizație non-guvernamentală'
        },
        {
            value: '7B9H',
            labelcz: 'Societate cooperativă',
            labelen: 'Societate cooperativă'
        },
        {
            value: '7W9B',
            labelcz: 'Organizații cooperatiste de credit și casele centrale ale acestora',
            labelen: 'Organizații cooperatiste de credit și casele centrale ale acestora'
        },
        { value: '85K5', labelcz: 'Reprezentanta', labelen: 'Reprezentanta' },
        {
            value: '8FD2',
            labelcz: 'Cooperativă de consum',
            labelen: 'Cooperativă de consum'
        },
        {
            value: 'AI01',
            labelcz: 'Persoana fizica independentă',
            labelen: 'Persoana fizica independentă'
        },
        {
            value: 'ANDT',
            labelcz: 'Societate pe acţiuni',
            labelen: 'Societate pe acţiuni'
        },
        {
            value: 'CTBD',
            labelcz: 'Alte forme de proprietate',
            labelen: 'Alte forme de proprietate'
        },
        { value: 'CUGP', labelcz: 'Regie autonomă', labelen: 'Regie autonomă' },
        {
            value: 'DUGD',
            labelcz: 'Intreprindere individuala',
            labelen: 'Intreprindere individuala'
        },
        {
            value: 'EFBR',
            labelcz: 'Grupul de interes economic',
            labelen: 'Grupul de interes economic'
        },
        {
            value: 'F0BK',
            labelcz: 'Societate agricolă',
            labelen: 'Societate agricolă'
        },
        {
            value: 'F68H',
            labelcz: 'Societate în nume colectiv',
            labelen: 'Societate în nume colectiv'
        },
        {
            value: 'FJQ8',
            labelcz: 'Persoana fizica autorizata',
            labelen: 'Persoana fizica autorizata'
        },
        {
            value: 'GT4V',
            labelcz: 'Cooperativă de credit',
            labelen: 'Cooperativă de credit'
        },
        {
            value: 'I15K',
            labelcz: 'Cooperativă agricolă',
            labelen: 'Cooperativă agricolă'
        },
        { value: 'I9BB', labelcz: 'Sucursala', labelen: 'Sucursala' },
        {
            value: 'NFRJ',
            labelcz: 'Reprezentant fiscal',
            labelen: 'Reprezentant fiscal'
        },
        {
            value: 'SWMK',
            labelcz: 'Societate în comandită pe acţiuni',
            labelen: 'Societate în comandită pe acţiuni'
        },
        {
            value: 'TH8A',
            labelcz: 'Asociatie familiala',
            labelen: 'Asociatie familiala'
        },
        {
            value: 'UWEE',
            labelcz: 'Societate Cooperativă Europeană',
            labelen: 'Societate Cooperativă Europeană'
        },
        {
            value: 'V0FL',
            labelcz: 'Societate în comandită simplă',
            labelen: 'Societate în comandită simplă'
        },
        {
            value: 'XHN1',
            labelcz: 'Societate cu răspundere limitată',
            labelen: 'Societate cu răspundere limitată'
        }
    ],
    RU: [
        {
            value: '15A2',
            labelcz: `Ob"yedineniya (assotsiatsii i soyuzy) blagotvoritel'nykh organizatsiy`,
            labelen: `Ob"yedineniya (assotsiatsii i soyuzy) blagotvoritel'nykh organizatsiy`
        },
        {
            value: '17R7',
            labelcz: "Obshchestva s ogranichennoy otvetstvennost'yu",
            labelen: "Obshchestva s ogranichennoy otvetstvennost'yu"
        },
        {
            value: '1MJ0',
            labelcz: "Krest'yanskiye (fermerskiye) khozyaystva",
            labelen: "Krest'yanskiye (fermerskiye) khozyaystva"
        },
        {
            value: '1RJ2',
            labelcz: 'Avtonomnyye nekommercheskiye organizatsii',
            labelen: 'Avtonomnyye nekommercheskiye organizatsii'
        },
        {
            value: '1U7Y',
            labelcz: "Blagotvoritel'nyye uchrezhdeniya",
            labelen: "Blagotvoritel'nyye uchrezhdeniya"
        },
        {
            value: '24TU',
            labelcz: `Soyuzy (assotsiatsii) obshchestvennykh ob"yedineniy`,
            labelen: `Soyuzy (assotsiatsii) obshchestvennykh ob"yedineniy`
        },
        {
            value: '2H36',
            labelcz: 'Soyuzy (assotsiatsii) kooperativov',
            labelen: 'Soyuzy (assotsiatsii) kooperativov'
        },
        {
            value: '2OTW',
            labelcz: "Munitsipal'nyye avtonomnyye uchrezhdeniya",
            labelen: "Munitsipal'nyye avtonomnyye uchrezhdeniya"
        },
        {
            value: '2R46',
            labelcz: "Tovarishchestva sobstvennikov zhil'ya",
            labelen: "Tovarishchestva sobstvennikov zhil'ya"
        },
        {
            value: '37YG',
            labelcz: "Federal'nyye kazennyye predpriyatiya",
            labelen: "Federal'nyye kazennyye predpriyatiya"
        },
        {
            value: '3AMJ',
            labelcz: "Sel'skokhozyaystvennyye proizvodstvennyye kooperativy",
            labelen: "Sel'skokhozyaystvennyye proizvodstvennyye kooperativy"
        },
        {
            value: '3EAX',
            labelcz: "Proizvodstvennyye kooperativy (krome sel'skokhozyaystvennykh proizvodstvennykh kooperativov)",
            labelen: "Proizvodstvennyye kooperativy (krome sel'skokhozyaystvennykh proizvodstvennykh kooperativov)"
        },
        { value: '3F98', labelcz: 'Uchrezhdeniya', labelen: 'Uchrezhdeniya' },
        {
            value: '3TOV',
            labelcz: 'Profsoyuznyye organizatsii',
            labelen: 'Profsoyuznyye organizatsii'
        },
        {
            value: '3U8X',
            labelcz: 'Prochiye yuridicheskiye litsa, yavlyayushchiyesya kommercheskimi organizatsiyami',
            labelen: 'Prochiye yuridicheskiye litsa, yavlyayushchiyesya kommercheskimi organizatsiyami'
        },
        {
            value: '4PZX',
            labelcz: `Uchrezhdeniya, sozdannyye sub"yektom Rossiyskoy Federatsii`,
            labelen: `Uchrezhdeniya, sozdannyye sub"yektom Rossiyskoy Federatsii`
        },
        {
            value: '4TYO',
            labelcz: 'Publichnyye aktsionernyye obshchestva',
            labelen: 'Publichnyye aktsionernyye obshchestva'
        },
        {
            value: '4VTZ',
            labelcz: 'Assotsiatsii (soyuzy)',
            labelen: 'Assotsiatsii (soyuzy)'
        },
        {
            value: '5VMR',
            labelcz: 'Advokaty, uchredivshiye advokatskiy kabinet',
            labelen: 'Advokaty, uchredivshiye advokatskiy kabinet'
        },
        {
            value: '6H83',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye zhivotnovodcheskiye kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye zhivotnovodcheskiye kooperativy"
        },
        {
            value: '8B9A',
            labelcz: "Zhilishchnyye ili zhilishchno-stroitel'nyye kooperativy",
            labelen: "Zhilishchnyye ili zhilishchno-stroitel'nyye kooperativy"
        },
        {
            value: '8JWV',
            labelcz: 'Gosudarstvennyye akademii nauk',
            labelen: 'Gosudarstvennyye akademii nauk'
        },
        {
            value: '8MQM',
            labelcz: `Gosudarstvennyye byudzhetnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii`,
            labelen: `Gosudarstvennyye byudzhetnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii`
        },
        {
            value: '8NF7',
            labelcz: "Federal'nyye gosudarstvennyye byudzhetnyye uchrezhdeniya",
            labelen: "Federal'nyye gosudarstvennyye byudzhetnyye uchrezhdeniya"
        },
        {
            value: '8NZE',
            labelcz: "Sadovodcheskiye, ogorodnicheskiye ili dachnyye potrebitel'skiye kooperativy",
            labelen: "Sadovodcheskiye, ogorodnicheskiye ili dachnyye potrebitel'skiye kooperativy"
        },
        {
            value: '8RIH',
            labelcz: 'Publichno-pravovyye kompanii',
            labelen: 'Publichno-pravovyye kompanii'
        },
        {
            value: '8XDD',
            labelcz: `Sovety munitsipal'nykh obrazovaniy sub"yektov Rossiyskoy Federatsii`,
            labelen: `Sovety munitsipal'nykh obrazovaniy sub"yektov Rossiyskoy Federatsii`
        },
        { value: '9M15', labelcz: "Central'nyj bank", labelen: "Central'nyj bank" },
        {
            value: '9RQZ',
            labelcz: `Gosudarstvennyye unitarnyye predpriyatiya sub"yektov Rossiyskoy Federatsii`,
            labelen: `Gosudarstvennyye unitarnyye predpriyatiya sub"yektov Rossiyskoy Federatsii`
        },
        {
            value: 'AS78',
            labelcz: 'Advokatskiye byuro',
            labelen: 'Advokatskiye byuro'
        },
        {
            value: 'B5GH',
            labelcz:
                "Kazach'i obshchestva, vnesennyye v gosudarstvennyy reyestr kazach'ikh obshchestv v Rossiyskoy Federatsii",
            labelen:
                "Kazach'i obshchestva, vnesennyye v gosudarstvennyy reyestr kazach'ikh obshchestv v Rossiyskoy Federatsii"
        },
        {
            value: 'BLVV',
            labelcz: "Kreditnyye potrebitel'skiye kooperativy",
            labelen: "Kreditnyye potrebitel'skiye kooperativy"
        },
        {
            value: 'BQ3A',
            labelcz: "Garazhnyye i garazhno-stroitel'nyye kooperativy",
            labelen: "Garazhnyye i garazhno-stroitel'nyye kooperativy"
        },
        {
            value: 'BZQL',
            labelcz: "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan (fizicheskikh lits)",
            labelen: "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan (fizicheskikh lits)"
        },
        {
            value: 'C3RQ',
            labelcz:
                'Organizatsionno-pravovyyу formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi korporativnymi organizatsiyami',
            labelen:
                'Organizatsionno-pravovyyу formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi korporativnymi organizatsiyami'
        },
        {
            value: 'C7TI',
            labelcz: `Assotsiatsii (soyuzy) sadovodcheskikh, ogorodnicheskikh i dachnykh nekommercheskikh ob"yedineniy`,
            labelen: `Assotsiatsii (soyuzy) sadovodcheskikh, ogorodnicheskikh i dachnykh nekommercheskikh ob"yedineniy`
        },
        {
            value: 'CKTA',
            labelcz: 'Nekommercheskiye partnerstva',
            labelen: 'Nekommercheskiye partnerstva'
        },
        { value: 'CN7I', labelcz: 'Fondy prokata', labelen: 'Fondy prokata' },
        {
            value: 'D094',
            labelcz: 'Ekologicheskiye fondy',
            labelen: 'Ekologicheskiye fondy'
        },
        {
            value: 'D84J',
            labelcz: 'Obshchestvennyye organizatsii',
            labelen: 'Obshchestvennyye organizatsii'
        },
        {
            value: 'DO25',
            labelcz: 'Gosudarstvennyye kompanii',
            labelen: 'Gosudarstvennyye kompanii'
        },
        {
            value: 'DZSY',
            labelcz: `Kazennyye predpriyatiya sub"yektov Rossiyskoy Federatsii`,
            labelen: `Kazennyye predpriyatiya sub"yektov Rossiyskoy Federatsii`
        },
        {
            value: 'E0VI',
            labelcz: 'Gosudarstvennyye korporatsii',
            labelen: 'Gosudarstvennyye korporatsii'
        },
        {
            value: 'EH3M',
            labelcz: 'Obshchestvennyye fondy',
            labelen: 'Obshchestvennyye fondy'
        },
        {
            value: 'EWQF',
            labelcz: "Organizatsionno-pravovyye formy dlya kommercheskoy deyatel'nosti grazhdan",
            labelen: "Organizatsionno-pravovyye formy dlya kommercheskoy deyatel'nosti grazhdan"
        },
        {
            value: 'FWGK',
            labelcz: "Munitsipal'nyye byudzhetnyye uchrezhdeniya",
            labelen: "Munitsipal'nyye byudzhetnyye uchrezhdeniya"
        },
        {
            value: 'FZKX',
            labelcz: 'Proizvodstvennyye kooperativy (arteli)',
            labelen: 'Proizvodstvennyye kooperativy (arteli)'
        },
        {
            value: 'G2CW',
            labelcz: "Territorial'nyye obshchestvennyye samoupravleniya",
            labelen: "Territorial'nyye obshchestvennyye samoupravleniya"
        },
        {
            value: 'GHC5',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye ogorodnicheskiye kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye ogorodnicheskiye kooperativy"
        },
        {
            value: 'GQRJ',
            labelcz: 'Uchrezhdeniya, sozdannyye Rossiyskoy Federatsiyey',
            labelen: 'Uchrezhdeniya, sozdannyye Rossiyskoy Federatsiyey'
        },
        {
            value: 'GWHK',
            labelcz: 'Obshchiny korennykh malochislennykh narodov Rossiyskoy Federatsii',
            labelen: 'Obshchiny korennykh malochislennykh narodov Rossiyskoy Federatsii'
        },
        {
            value: 'GZF9',
            labelcz: 'Strukturnyye podrazdeleniya obosoblennykh podrazdeleniy yuridicheskikh lits',
            labelen: 'Strukturnyye podrazdeleniya obosoblennykh podrazdeleniy yuridicheskikh lits'
        },
        {
            value: 'H2AF',
            labelcz: 'Tovarishchestva sobstvennikov nedvizhimosti',
            labelen: 'Tovarishchestva sobstvennikov nedvizhimosti'
        },
        {
            value: 'H2P4',
            labelcz: 'Kreditnyye kooperativy vtorogo urovnya',
            labelen: 'Kreditnyye kooperativy vtorogo urovnya'
        },
        {
            value: 'H4NY',
            labelcz: 'Advokatskiye palaty',
            labelen: 'Advokatskiye palaty'
        },
        {
            value: 'HKKL',
            labelcz: "Federal'nyye gosudarstvennyye avtonomnyye uchrezhdeniya",
            labelen: "Federal'nyye gosudarstvennyye avtonomnyye uchrezhdeniya"
        },
        {
            value: 'HUET',
            labelcz: 'Religioznyye organizatsii',
            labelen: 'Religioznyye organizatsii'
        },
        {
            value: 'HUR1',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye obsluzhivayushchiye kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye obsluzhivayushchiye kooperativy"
        },
        {
            value: 'I9O1',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye pererabatyvayushchiye kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye pererabatyvayushchiye kooperativy"
        },
        {
            value: 'I9V2',
            labelcz:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi unitarnymi organizatsiyami',
            labelen:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi unitarnymi organizatsiyami'
        },
        {
            value: 'IBSS',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye snabzhencheskiye kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye snabzhencheskiye kooperativy"
        },
        {
            value: 'IC46',
            labelcz: "Sel'skokhozyaystvennyye arteli (kolkhozy)",
            labelen: "Sel'skokhozyaystvennyye arteli (kolkhozy)"
        },
        {
            value: 'ILY0',
            labelcz: 'Samoreguliruyemyye organizatsii',
            labelen: 'Samoreguliruyemyye organizatsii'
        },
        {
            value: 'J18N',
            labelcz: 'Tovarishchestva na vere (kommanditnyye tovarishchestva)',
            labelen: 'Tovarishchestva na vere (kommanditnyye tovarishchestva)'
        },
        {
            value: 'J7NW',
            labelcz: 'Prostyye tovarishchestva',
            labelen: 'Prostyye tovarishchestva'
        },
        {
            value: 'JPMQ',
            labelcz: 'Organizatsionno-pravovyye formy organizatsiy, sozdannykh bez prav yuridicheskogo litsa',
            labelen: 'Organizatsionno-pravovyye formy organizatsiy, sozdannykh bez prav yuridicheskogo litsa'
        },
        {
            value: 'JZBN',
            labelcz: 'Nepublichnyye aktsionernyye obshchestva',
            labelen: 'Nepublichnyye aktsionernyye obshchestva'
        },
        {
            value: 'KLA2',
            labelcz: 'Khozyaystvennyye tovarishchestva',
            labelen: 'Khozyaystvennyye tovarishchestva'
        },
        {
            value: 'KOYR',
            labelcz: "Glavy krest'yanskikh (fermerskikh) khozyaystv",
            labelen: "Glavy krest'yanskikh (fermerskikh) khozyaystv"
        },
        {
            value: 'KVSH',
            labelcz: "Organy obshchestvennoy samodeyatel'nosti",
            labelen: "Organy obshchestvennoy samodeyatel'nosti"
        },
        { value: 'KZC6', labelcz: 'Fondy', labelen: 'Fondy' },
        {
            value: 'LLL8',
            labelcz: "Otdeleniya inostrannykh nekommercheskikh nepravitel'stvennykh organizatsiy",
            labelen: "Otdeleniya inostrannykh nekommercheskikh nepravitel'stvennykh organizatsiy"
        },
        {
            value: 'LYTH',
            labelcz: "Blagotvoritel'nyye fondy",
            labelen: "Blagotvoritel'nyye fondy"
        },
        {
            value: 'MG22',
            labelcz: `Gosudarstvennyye avtonomnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii`,
            labelen: `Gosudarstvennyye avtonomnyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii`
        },
        {
            value: 'MT3A',
            labelcz: 'Otkrytoye aktsionernoye obshchestvo',
            labelen: 'Otkrytoye aktsionernoye obshchestvo'
        },
        {
            value: 'MV1C',
            labelcz: "Potrebitel'skiye obshchestva",
            labelen: "Potrebitel'skiye obshchestva"
        },
        {
            value: 'MVSF',
            labelcz: `Ob"yedineniya fermerskikh khozyaystv`,
            labelen: `Ob"yedineniya fermerskikh khozyaystv`
        },
        {
            value: 'NRK9',
            labelcz: 'Obshchestvennyye uchrezhdeniya',
            labelen: 'Obshchestvennyye uchrezhdeniya'
        },
        {
            value: 'NZ85',
            labelcz: 'Politicheskiye partii',
            labelen: 'Politicheskiye partii'
        },
        {
            value: 'O1KO',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye sbytovyye (torgovyye) kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye sbytovyye (torgovyye) kooperativy"
        },
        {
            value: 'OCIS',
            labelcz: "Federal'nyye gosudarstvennyye unitarnyye predpriyatiya",
            labelen: "Federal'nyye gosudarstvennyye unitarnyye predpriyatiya"
        },
        {
            value: 'OPLQ',
            labelcz: "Predstavitel'stva yuridicheskikh lits",
            labelen: "Predstavitel'stva yuridicheskikh lits"
        },
        {
            value: 'OVLN',
            labelcz:
                'Unitarnyye predpriyatiya, osnovannyye na prave operativnogo upravleniya (kazennyye predpriyatiya)',
            labelen: 'Unitarnyye predpriyatiya, osnovannyye na prave operativnogo upravleniya (kazennyye predpriyatiya)'
        },
        {
            value: 'P9CF',
            labelcz: "Individual'nyye predprinimateli",
            labelen: "Individual'nyye predprinimateli"
        },
        {
            value: 'PA5X',
            labelcz: `Assotsiatsii (soyuzy) ekonomicheskogo vzaimodeystviya sub"yektov Rossiyskoy Federatsii`,
            labelen: `Assotsiatsii (soyuzy) ekonomicheskogo vzaimodeystviya sub"yektov Rossiyskoy Federatsii`
        },
        {
            value: 'PDYW',
            labelcz: "Sel'skokhozyaystvennyye potrebitel'skiye sadovodcheskiye kooperativy",
            labelen: "Sel'skokhozyaystvennyye potrebitel'skiye sadovodcheskiye kooperativy"
        },
        {
            value: 'PJRZ',
            labelcz: "Notarial'nyye palaty",
            labelen: "Notarial'nyye palaty"
        },
        {
            value: 'Q9FA',
            labelcz: "Mezhpravitel'stvennyye mezhdunarodnyye organizatsii",
            labelen: "Mezhpravitel'stvennyye mezhdunarodnyye organizatsii"
        },
        {
            value: 'QCRH',
            labelcz: 'Khozyaystvennyye obshchestva',
            labelen: 'Khozyaystvennyye obshchestva'
        },
        {
            value: 'QFGM',
            labelcz: "Potrebitel'skiye kooperativy",
            labelen: "Potrebitel'skiye kooperativy"
        },
        {
            value: 'QKFU',
            labelcz: "Uchrezhdeniya, sozdannyye munitsipal'nym obrazovaniyem (munitsipal'nyye uchrezhdeniya)",
            labelen: "Uchrezhdeniya, sozdannyye munitsipal'nym obrazovaniyem (munitsipal'nyye uchrezhdeniya)"
        },
        {
            value: 'QMEH',
            labelcz: 'Obshchestva vzaimnogo strakhovaniya',
            labelen: 'Obshchestva vzaimnogo strakhovaniya'
        },
        {
            value: 'QQS1',
            labelcz:
                "Organizatsionno-pravovyye formy mezhdunarodnykh organizatsiy, osushchestvlyayushchikh deyatel'nost' na territorii rossiyskoy federatsii",
            labelen:
                "Organizatsionno-pravovyye formy mezhdunarodnykh organizatsiy, osushchestvlyayushchikh deyatel'nost' na territorii rossiyskoy federatsii"
        },
        {
            value: 'QSXT',
            labelcz: 'Notariusy, zanimayushchiyesya chastnoy praktikoy',
            labelen: 'Notariusy, zanimayushchiyesya chastnoy praktikoy'
        },
        {
            value: 'QUMQ',
            labelcz: 'Unitarnyye predpriyatiya, osnovannyye na prave khozyaystvennogo vedeniya',
            labelen: 'Unitarnyye predpriyatiya, osnovannyye na prave khozyaystvennogo vedeniya'
        },
        {
            value: 'R71T',
            labelcz: 'Aktsionernyye obshchestva',
            labelen: 'Aktsionernyye obshchestva'
        },
        {
            value: 'RJUK',
            labelcz: 'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye tovarishchestva',
            labelen: 'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye tovarishchestva'
        },
        {
            value: 'SDVV',
            labelcz: `Ob"yedineniya rabotodateley`,
            labelen: `Ob"yedineniya rabotodateley`
        },
        {
            value: 'SIPP',
            labelcz: "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan, ne otnesennoy k predprinimatel'stvu",
            labelen: "Organizatsionno-pravovyye formy dlya deyatel'nosti grazhdan, ne otnesennoy k predprinimatel'stvu"
        },
        {
            value: 'TLDB',
            labelcz: "Soyuzy potrebitel'skikh obshchestv",
            labelen: "Soyuzy potrebitel'skikh obshchestv"
        },
        {
            value: 'TMIG',
            labelcz: "Federal'nyye gosudarstvennyye kazennyye uchrezhdeniya",
            labelen: "Federal'nyye gosudarstvennyye kazennyye uchrezhdeniya"
        },
        {
            value: 'UTBN',
            labelcz: 'Kollegii advokatov',
            labelen: 'Kollegii advokatov'
        },
        {
            value: 'UY49',
            labelcz: 'Rayonnyye sudy, gorodskiye sudy, mezhrayonnyye sudy (rayonnyye sudy)',
            labelen: 'Rayonnyye sudy, gorodskiye sudy, mezhrayonnyye sudy (rayonnyye sudy)'
        },
        {
            value: 'VA0A',
            labelcz: 'Rybolovetskiye arteli (kolkhozy)',
            labelen: 'Rybolovetskiye arteli (kolkhozy)'
        },
        {
            value: 'VAB6',
            labelcz: 'Obosoblennyye podrazdeleniya yuridicheskikh lits',
            labelen: 'Obosoblennyye podrazdeleniya yuridicheskikh lits'
        },
        {
            value: 'VE1P',
            labelcz:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi korporativnymi organizatsiyami',
            labelen:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya nekommercheskimi korporativnymi organizatsiyami'
        },
        {
            value: 'VEOU',
            labelcz: 'Unitarnyye predpriyatiya',
            labelen: 'Unitarnyye predpriyatiya'
        },
        {
            value: 'VEX5',
            labelcz: "Munitsipal'nyye kazennyye uchrezhdeniya",
            labelen: "Munitsipal'nyye kazennyye uchrezhdeniya"
        },
        {
            value: 'VIGZ',
            labelcz: 'Filialy yuridicheskikh lits',
            labelen: 'Filialy yuridicheskikh lits'
        },
        {
            value: 'VOUU',
            labelcz:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi unitarnymi organizatsiyami',
            labelen:
                'Organizatsionno-pravovyye formy yuridicheskikh lits, yavlyayushchikhsya kommercheskimi unitarnymi organizatsiyami'
        },
        {
            value: 'WJXS',
            labelcz: "Zhilishchnyye nakopitel'nyye kooperativy",
            labelen: "Zhilishchnyye nakopitel'nyye kooperativy"
        },
        {
            value: 'WYNO',
            labelcz: 'Soyuzy (assotsiatsii) kreditnykh kooperativov',
            labelen: 'Soyuzy (assotsiatsii) kreditnykh kooperativov'
        },
        {
            value: 'XBRI',
            labelcz: "Nepravitel'stvennyye mezhdunarodnyye organizatsii",
            labelen: "Nepravitel'stvennyye mezhdunarodnyye organizatsii"
        },
        {
            value: 'XIGI',
            labelcz: "Munitsipal'nyye kazennyye predpriyatiya",
            labelen: "Munitsipal'nyye kazennyye predpriyatiya"
        },
        {
            value: 'XINV',
            labelcz: 'Kooperativnyye khozyaystva (koopkhozy)',
            labelen: 'Kooperativnyye khozyaystva (koopkhozy)'
        },
        {
            value: 'XJJR',
            labelcz: 'Soyuzy (assotsiatsii) obshchin malochislennykh narodov',
            labelen: 'Soyuzy (assotsiatsii) obshchin malochislennykh narodov'
        },
        {
            value: 'XNKN',
            labelcz: "Kreditnyye potrebitel'skiye kooperativy grazhdan",
            labelen: "Kreditnyye potrebitel'skiye kooperativy grazhdan"
        },
        {
            value: 'YA7H',
            labelcz: 'Chastnyye uchrezhdeniya',
            labelen: 'Chastnyye uchrezhdeniya'
        },
        {
            value: 'YGHZ',
            labelcz: 'Payevyye investitsionnyye fondy',
            labelen: 'Payevyye investitsionnyye fondy'
        },
        {
            value: 'YJ6A',
            labelcz: 'Obshchestvennyye dvizheniya',
            labelen: 'Obshchestvennyye dvizheniya'
        },
        {
            value: 'Z2AQ',
            labelcz: 'Negosudarstvennyye pensionnyye fondy',
            labelen: 'Negosudarstvennyye pensionnyye fondy'
        },
        {
            value: 'Z3SH',
            labelcz: "Munitsipal'nyye unitarnyye predpriyatiya",
            labelen: "Munitsipal'nyye unitarnyye predpriyatiya"
        },
        {
            value: 'Z3Y0',
            labelcz: 'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye partnerstva',
            labelen: 'Sadovodcheskiye, ogorodnicheskiye ili dachnyye nekommercheskiye partnerstva'
        },
        {
            value: 'ZGYA',
            labelcz: 'Torgovo-promyshlennyye palaty',
            labelen: 'Torgovo-promyshlennyye palaty'
        },
        {
            value: 'ZH3O',
            labelcz: 'Khozyaystvennyye partnerstva',
            labelen: 'Khozyaystvennyye partnerstva'
        },
        {
            value: 'ZKAF',
            labelcz: 'Polnyye tovarishchestva',
            labelen: 'Polnyye tovarishchestva'
        },
        {
            value: 'ZNHF',
            labelcz: `Gosudarstvennyye kazennyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii`,
            labelen: `Gosudarstvennyye kazennyye uchrezhdeniya sub"yektov Rossiyskoy Federatsii`
        }
    ],
    WS: [
        { value: '1RPE', labelcz: 'Charitable trust', labelen: 'Charitable trust' },
        {
            value: '7WL9',
            labelcz: 'Public limited company',
            labelen: 'Public limited company'
        },
        { value: 'BCM3', labelcz: 'Credit Union', labelen: 'Credit Union' },
        {
            value: 'M6YY',
            labelcz: 'Private limited company',
            labelen: 'Private limited company'
        },
        { value: 'QWFD', labelcz: 'Overseas company', labelen: 'Overseas company' },
        {
            value: 'SXY3',
            labelcz: 'Incorporated society',
            labelen: 'Incorporated society'
        },
        {
            value: 'TOMA',
            labelcz: 'Co-operative society',
            labelen: 'Co-operative society'
        }
    ],
    SA: [
        {
            value: '78VH',
            labelcz: 'sharikat musahama',
            labelen: 'sharikat musahama'
        },
        {
            value: 'B3JS',
            labelcz: "sharikat 'ashkhas",
            labelen: "sharikat 'ashkhas"
        },
        {
            value: 'DW9N',
            labelcz: "sharikat tawsiat bial'ashum",
            labelen: "sharikat tawsiat bial'ashum"
        },
        {
            value: 'N10C',
            labelcz: 'sharikat dhat ras mal qabil liltaghyir',
            labelen: 'sharikat dhat ras mal qabil liltaghyir'
        },
        { value: 'PT6M', labelcz: "sharikat 'amwal", labelen: "sharikat 'amwal" },
        {
            value: 'T2NA',
            labelcz: 'sharikat altadamun',
            labelen: 'sharikat altadamun'
        },
        {
            value: 'TTE8',
            labelcz: 'sharakah dhat maswuwliat mahduda',
            labelen: 'sharakah dhat maswuwliat mahduda'
        },
        {
            value: 'WHCI',
            labelcz: 'sharakah tawsiat basita',
            labelen: 'sharakah tawsiat basita'
        },
        { value: 'YVGA', labelcz: 'sharikat muhasa', labelen: 'sharikat muhasa' },
        {
            value: 'Z9IE',
            labelcz: "sharikat 'ajnabia",
            labelen: "sharikat 'ajnabia"
        }
    ],
    RS: [
        { value: '6UPM', labelcz: 'Zadružni savez', labelen: 'Zadružni savez' },
        {
            value: '73PZ',
            labelcz: 'Komanditno društvo',
            labelen: 'Komanditno društvo'
        },
        {
            value: '88TX',
            labelcz: 'Društveno preduzeće',
            labelen: 'Društveno preduzeće'
        },
        { value: '9O67', labelcz: 'Preduzetnik', labelen: 'Preduzetnik' },
        { value: 'DEF6', labelcz: 'Javno preduzeće', labelen: 'Javno preduzeće' },
        { value: 'E7W8', labelcz: 'Zadruga', labelen: 'Zadruga' },
        {
            value: 'KIU5',
            labelcz: 'Društvo sa ograničenom odgovornošću',
            labelen: 'Društvo sa ograničenom odgovornošću'
        },
        {
            value: 'YVPW',
            labelcz: 'Akcionarsko društvo',
            labelen: 'Akcionarsko društvo'
        },
        { value: 'ZPOY', labelcz: 'Ortačko društvo', labelen: 'Ortačko društvo' }
    ],
    SC: [
        { value: '3YUS', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: '6MS4',
            labelcz: 'Company Limited by Shares',
            labelen: 'Company Limited by Shares'
        },
        {
            value: '7QEH',
            labelcz: 'International Business Company - Company Limited by Shares',
            labelen: 'International Business Company - Company Limited by Shares'
        },
        {
            value: '7XUS',
            labelcz: 'Special License Company',
            labelen: 'Special License Company'
        },
        {
            value: 'BB5Y',
            labelcz: 'International Trust',
            labelen: 'International Trust'
        },
        {
            value: 'CDYY',
            labelcz: 'Company Limited by Guarantee',
            labelen: 'Company Limited by Guarantee'
        },
        {
            value: 'E3YL',
            labelcz: 'Company Limited by Shares and Guarantee',
            labelen: 'Company Limited by Shares and Guarantee'
        },
        {
            value: 'G6M8',
            labelcz: 'International Business Company - Protected Cell Company',
            labelen: 'International Business Company - Protected Cell Company'
        },
        { value: 'H35I', labelcz: 'Public Company', labelen: 'Public Company' },
        {
            value: 'H987',
            labelcz: 'Proprietary Company',
            labelen: 'Proprietary Company'
        },
        {
            value: 'KGUS',
            labelcz: 'International Business Company - Company Limited by Shares and Guarantee',
            labelen: 'International Business Company - Company Limited by Shares and Guarantee'
        },
        {
            value: 'KOFC',
            labelcz: 'International Business Company - Company Limited by Guarantee',
            labelen: 'International Business Company - Company Limited by Guarantee'
        },
        {
            value: 'P3YJ',
            labelcz: 'Unlimited Company',
            labelen: 'Unlimited Company'
        },
        {
            value: 'Q9VK',
            labelcz: 'Protected Cell Company',
            labelen: 'Protected Cell Company'
        },
        {
            value: 'VA1X',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'WKFR',
            labelcz: 'International Business Company - Limited Life Company',
            labelen: 'International Business Company - Limited Life Company'
        }
    ],
    SG: [
        {
            value: '17FJ',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: '2PHU', labelcz: 'Business', labelen: 'Business' },
        {
            value: '5SGV',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'KEMH',
            labelcz: 'Company (Foreign Branch)',
            labelen: 'Company (Foreign Branch)'
        },
        { value: 'LWXI', labelcz: 'Company (Local)', labelen: 'Company (Local)' }
    ],
    SX: [
        { value: '1CSZ', labelcz: 'vereniging', labelen: 'vereniging' },
        {
            value: '2CC3',
            labelcz: 'besloten vennootschap',
            labelen: 'besloten vennootschap'
        },
        {
            value: '2UBX',
            labelcz: 'commanditaire vennootschap op aandelen',
            labelen: 'commanditaire vennootschap op aandelen'
        },
        {
            value: '52AV',
            labelcz: 'stichting particulier fonds',
            labelen: 'stichting particulier fonds'
        },
        { value: '66T3', labelcz: 'eenmanszaak', labelen: 'eenmanszaak' },
        {
            value: '8W32',
            labelcz: 'openbare vennootschap',
            labelen: 'openbare vennootschap'
        },
        {
            value: 'B4OI',
            labelcz: 'onderlinge waarborgmaatschappij',
            labelen: 'onderlinge waarborgmaatschappij'
        },
        {
            value: 'FBX9',
            labelcz: 'aandeelhouder-bestuurde vennootschap',
            labelen: 'aandeelhouder-bestuurde vennootschap'
        },
        { value: 'FI9R', labelcz: 'stichting', labelen: 'stichting' },
        { value: 'NWT1', labelcz: 'coöperatie', labelen: 'coöperatie' },
        {
            value: 'SXX9',
            labelcz: 'naamloze vennootschap',
            labelen: 'naamloze vennootschap'
        },
        {
            value: 'YXX0',
            labelcz: 'commanditaire vennootschap',
            labelen: 'commanditaire vennootschap'
        }
    ],
    SK: [
        {
            value: '14NU',
            labelcz: 'Rozpočtové a príspevkové organizácie',
            labelen: 'Rozpočtové a príspevkové organizácie'
        },
        {
            value: '189Q',
            labelcz: 'Špecializovaná organizačná jednotka ČSD',
            labelen: 'Špecializovaná organizačná jednotka ČSD'
        },
        { value: '1CSW', labelcz: 'Obecný podnik', labelen: 'Obecný podnik' },
        {
            value: '1GLU',
            labelcz: 'Jednotka železničného správneho úradu',
            labelen: 'Jednotka železničného správneho úradu'
        },
        {
            value: '1HEP',
            labelcz: 'Rozpočtová organizácia',
            labelen: 'Rozpočtová organizácia'
        },
        {
            value: '1K73',
            labelcz: 'Zahraničná osoba, právnická osoba so sídlom mimo územia SR',
            labelen: 'Zahraničná osoba, právnická osoba so sídlom mimo územia SR'
        },
        { value: '1W8B', labelcz: 'Zahraničná osoba', labelen: 'Zahraničná osoba' },
        {
            value: '2EEG',
            labelcz: 'Akciová spoločnosť',
            labelen: 'Akciová spoločnosť'
        },
        {
            value: '2KMA',
            labelcz: 'Štátny podnik v oddieli Pšn',
            labelen: 'Štátny podnik v oddieli Pšn'
        },
        { value: '2XNE', labelcz: 'Komoditná burza', labelen: 'Komoditná burza' },
        {
            value: '3P3W',
            labelcz: 'Družstevný podnik (s jedným zakladateľom)',
            labelen: 'Družstevný podnik (s jedným zakladateľom)'
        },
        {
            value: '43MZ',
            labelcz: 'Príspevková organizácia',
            labelen: 'Príspevková organizácia'
        },
        {
            value: '46CD',
            labelcz: 'Pobočka sporiteľne',
            labelen: 'Pobočka sporiteľne'
        },
        { value: '4CKX', labelcz: 'Krajský úrad', labelen: 'Krajský úrad' },
        { value: '4GX1', labelcz: 'Národný výbor', labelen: 'Národný výbor' },
        {
            value: '5AM3',
            labelcz: 'Zastupiteľské orgány iných štátov',
            labelen: 'Zastupiteľské orgány iných štátov'
        },
        {
            value: '5J5Y',
            labelcz: 'Verejná obchodná spoločnosť',
            labelen: 'Verejná obchodná spoločnosť'
        },
        {
            value: '5YBL',
            labelcz: 'Stavovská organizácia - profesná komora',
            labelen: 'Stavovská organizácia - profesná komora'
        },
        {
            value: '5Z8W',
            labelcz: 'Samostatne hospodáriaci roľník zapísaný v obchodnom registri',
            labelen: 'Samostatne hospodáriaci roľník zapísaný v obchodnom registri'
        },
        {
            value: '6R72',
            labelcz: 'Samostatne hospodáriaci roľník nezapísaný v obchodnom registri',
            labelen: 'Samostatne hospodáriaci roľník nezapísaný v obchodnom registri'
        },
        { value: '72R7', labelcz: 'Stredná škola', labelen: 'Stredná škola' },
        {
            value: '73MQ',
            labelcz: 'Samosprávny kraj (úrad samosprávneho kraja)',
            labelen: 'Samosprávny kraj (úrad samosprávneho kraja)'
        },
        { value: '7EG2', labelcz: 'Fondy', labelen: 'Fondy' },
        {
            value: '7O89',
            labelcz: 'Európske družstvo',
            labelen: 'Európske družstvo'
        },
        {
            value: '7QSE',
            labelcz: 'Zastúpenie zahraničnej právnickej osoby',
            labelen: 'Zastúpenie zahraničnej právnickej osoby'
        },
        {
            value: '8KHD',
            labelcz: 'Jednotka zboru ozbrojenej ochrany železníc',
            labelen: 'Jednotka zboru ozbrojenej ochrany železníc'
        },
        {
            value: '8RE3',
            labelcz: 'Družstevný podnik poľnohospodársky',
            labelen: 'Družstevný podnik poľnohospodársky'
        },
        {
            value: '8UE6',
            labelcz: 'Organizačná jednotka politickej strany, politického hnutia',
            labelen: 'Organizačná jednotka politickej strany, politického hnutia'
        },
        {
            value: '90YN',
            labelcz: 'Sociálna a zdravotné poisťovne',
            labelen: 'Sociálna a zdravotné poisťovne'
        },
        {
            value: '93WZ',
            labelcz: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
            labelen: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako sam.hosp.roľník'
        },
        {
            value: '95MS',
            labelcz: 'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona',
            labelen: 'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona'
        },
        {
            value: '9L9V',
            labelcz: 'Poľnohospodárske družstvo',
            labelen: 'Poľnohospodárske družstvo'
        },
        {
            value: '9NSV',
            labelcz: 'Neinvestičný fond',
            labelen: 'Neinvestičný fond'
        },
        {
            value: 'AGSR',
            labelcz: 'Jednotka štátnej železnično - technickej inšpekcie',
            labelen: 'Jednotka štátnej železnično - technickej inšpekcie'
        },
        {
            value: 'BKEB',
            labelcz: 'Oblastný závod poisťovne',
            labelen: 'Oblastný závod poisťovne'
        },
        {
            value: 'BUMI',
            labelcz: 'Európska spoločnosť',
            labelen: 'Európska spoločnosť'
        },
        {
            value: 'C4PZ',
            labelcz: 'Podnikateľ-fyzická osoba-nezapísaný v obchodnom registri',
            labelen: 'Podnikateľ-fyzická osoba-nezapísaný v obchodnom registri'
        },
        {
            value: 'CS8B',
            labelcz: 'Štátna hospodárska organizácia riadená okresným úradom',
            labelen: 'Štátna hospodárska organizácia riadená okresným úradom'
        },
        {
            value: 'D18J',
            labelcz: 'Jednoduchá spoločnosť na akcie',
            labelen: 'Jednoduchá spoločnosť na akcie'
        },
        { value: 'DAQC', labelcz: 'Základná škola', labelen: 'Základná škola' },
        {
            value: 'E1VK',
            labelcz: 'Medzinárodné organizácie a združenia',
            labelen: 'Medzinárodné organizácie a združenia'
        },
        { value: 'E4CI', labelcz: 'Bytové družstvo', labelen: 'Bytové družstvo' },
        {
            value: 'E9SH',
            labelcz: 'Zahraničná osoba, fyzická osoba s bydliskom mimo územia SR',
            labelen: 'Zahraničná osoba, fyzická osoba s bydliskom mimo územia SR'
        },
        {
            value: 'ED84',
            labelcz: 'Poisťovací spolok',
            labelen: 'Poisťovací spolok'
        },
        {
            value: 'ER02',
            labelcz: 'Organizačná jednotka združenia',
            labelen: 'Organizačná jednotka združenia'
        },
        {
            value: 'F560',
            labelcz: 'Spoločná záujmová organizácia družstiev',
            labelen: 'Spoločná záujmová organizácia družstiev'
        },
        {
            value: 'FDVU',
            labelcz: 'Fyzická osoba-príležitostne činná-zapísaná v registri daňového informačného systému',
            labelen: 'Fyzická osoba-príležitostne činná-zapísaná v registri daňového informačného systému'
        },
        {
            value: 'FMUC',
            labelcz: 'Iné pracovisko vysokej školy/fakulty',
            labelen: 'Iné pracovisko vysokej školy/fakulty'
        },
        {
            value: 'FQRE',
            labelcz: 'Účelová zahranično - obchodná organizácia',
            labelen: 'Účelová zahranično - obchodná organizácia'
        },
        {
            value: 'GL07',
            labelcz: 'Poisťovňa - akciová spoločnosť',
            labelen: 'Poisťovňa - akciová spoločnosť'
        },
        {
            value: 'GY5R',
            labelcz: 'Cirkevná organizácia',
            labelen: 'Cirkevná organizácia'
        },
        { value: 'HZG7', labelcz: 'Vysoká škola', labelen: 'Vysoká škola' },
        {
            value: 'HZI2',
            labelcz: 'Banka-štátny peňažný ústav',
            labelen: 'Banka-štátny peňažný ústav'
        },
        { value: 'I7AS', labelcz: 'Družstvo', labelen: 'Družstvo' },
        {
            value: 'ISCZ',
            labelcz: 'Doplnková dôchodková poisťovňa',
            labelen: 'Doplnková dôchodková poisťovňa'
        },
        { value: 'IW8Z', labelcz: 'Výrobné družstvo', labelen: 'Výrobné družstvo' },
        {
            value: 'J8DW',
            labelcz: 'Podnik zahraničnej osoby (organizačná zložka podniku zahraničnej osoby)',
            labelen: 'Podnik zahraničnej osoby (organizačná zložka podniku zahraničnej osoby)'
        },
        {
            value: 'JKC5',
            labelcz: 'Podnik alebo hospodárske zariadenie združenia',
            labelen: 'Podnik alebo hospodárske zariadenie združenia'
        },
        {
            value: 'KB52',
            labelcz: 'Komanditná spoločnosť',
            labelen: 'Komanditná spoločnosť'
        },
        {
            value: 'KVQU',
            labelcz: 'Združenie medzinárodného obchodu',
            labelen: 'Združenie medzinárodného obchodu'
        },
        {
            value: 'KWFE',
            labelcz: 'Komora (s výnimkou profesných komôr)',
            labelen: 'Komora (s výnimkou profesných komôr)'
        },
        {
            value: 'KZ3R',
            labelcz: 'Poisťovňa - štátny podnik',
            labelen: 'Poisťovňa - štátny podnik'
        },
        {
            value: 'L1M7',
            labelcz: 'Fakulta vysokej školy',
            labelen: 'Fakulta vysokej školy'
        },
        {
            value: 'L9WT',
            labelcz: 'Obec (obecný úrad), mesto (mestský úrad)',
            labelen: 'Obec (obecný úrad), mesto (mestský úrad)'
        },
        {
            value: 'MSGT',
            labelcz:
                'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona zapísaná v obchodnom registri',
            labelen:
                'Slobodné povolanie-fyzická osoba podnikajúca na základe iného ako živnostenského zákona zapísaná v obchodnom registri'
        },
        {
            value: 'MY1S',
            labelcz: 'Odštepný závod alebo iná organizačná zložka podniku zapisujúca sa do obchodného registra',
            labelen: 'Odštepný závod alebo iná organizačná zložka podniku zapisujúca sa do obchodného registra'
        },
        {
            value: 'N5MX',
            labelcz: 'Samostatne podnikajúca fyzická osoba',
            labelen: 'Samostatne podnikajúca fyzická osoba'
        },
        {
            value: 'N7I1',
            labelcz: 'Organizačná zložka príspevkovej organizácie s odvodenou právnou subjektivitou',
            labelen: 'Organizačná zložka príspevkovej organizácie s odvodenou právnou subjektivitou'
        },
        {
            value: 'N9QW',
            labelcz: 'Pobočka štátneho peňažného ústavu',
            labelen: 'Pobočka štátneho peňažného ústavu'
        },
        {
            value: 'NC88',
            labelcz: 'Účelová organizačná jednotka ČSD',
            labelen: 'Účelová organizačná jednotka ČSD'
        },
        {
            value: 'NL31',
            labelcz: 'Spoločný podnik (s viacerými zakladateľmi)',
            labelen: 'Spoločný podnik (s viacerými zakladateľmi)'
        },
        { value: 'NLI7', labelcz: 'Sporiteľna', labelen: 'Sporiteľna' },
        { value: 'NO20', labelcz: 'Zatiaľ neurčené', labelen: 'Zatiaľ neurčené' },
        {
            value: 'O0Y2',
            labelcz: 'Nešpecifikovaná právna forma',
            labelen: 'Nešpecifikovaná právna forma'
        },
        { value: 'O7TC', labelcz: 'Spoločný podnik', labelen: 'Spoločný podnik' },
        { value: 'OKAZ', labelcz: 'Obecný úrad', labelen: 'Obecný úrad' },
        {
            value: 'P6XJ',
            labelcz: 'Podnik alebo hospodárske zariadenie politickej strany',
            labelen: 'Podnik alebo hospodárske zariadenie politickej strany'
        },
        {
            value: 'PX29',
            labelcz: 'Iná právnicka osoba',
            labelen: 'Iná právnicka osoba'
        },
        {
            value: 'QACV',
            labelcz: 'Spotrebné družstvo',
            labelen: 'Spotrebné družstvo'
        },
        {
            value: 'QCJ9',
            labelcz: 'Spoločnosť komanditná na akcie',
            labelen: 'Spoločnosť komanditná na akcie'
        },
        {
            value: 'R9GT',
            labelcz: 'Samostatná drobná prevádzkareň obecného úradu',
            labelen: 'Samostatná drobná prevádzkareň obecného úradu'
        },
        {
            value: 'RF3D',
            labelcz: 'Združenie (zväz, spolok, spoločnosť, klub ai.)',
            labelen: 'Združenie (zväz, spolok, spoločnosť, klub ai.)'
        },
        {
            value: 'S5E1',
            labelcz: 'Miestna jednotka bez právnej spôsobilosti',
            labelen: 'Miestna jednotka bez právnej spôsobilosti'
        },
        {
            value: 'SIRY',
            labelcz: 'Záujmové združenie právnických osôb',
            labelen: 'Záujmové združenie právnických osôb'
        },
        {
            value: 'SMUS',
            labelcz: 'Záujmové združenie',
            labelen: 'Záujmové združenie'
        },
        {
            value: 'SPIE',
            labelcz: 'Podnikateľ-fyzická osoba-zapísaný v obchodnom registri',
            labelen: 'Podnikateľ-fyzická osoba-zapísaný v obchodnom registri'
        },
        {
            value: 'SQ4I',
            labelcz: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
            labelen: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním'
        },
        { value: 'SQFW', labelcz: 'Iné družstvo', labelen: 'Iné družstvo' },
        {
            value: 'STUP',
            labelcz: 'Národná banka Slovenska',
            labelen: 'Národná banka Slovenska'
        },
        {
            value: 'SUH3',
            labelcz: 'Záujmová organizácia družstiev',
            labelen: 'Záujmová organizácia družstiev'
        },
        {
            value: 'T0KQ',
            labelcz: 'Svojpomocné poľnohospodárske družstvo',
            labelen: 'Svojpomocné poľnohospodárske družstvo'
        },
        {
            value: 'TAV3',
            labelcz: 'Iná organizácia verejnej správy',
            labelen: 'Iná organizácia verejnej správy'
        },
        {
            value: 'TG3X',
            labelcz: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako sam.hosp.roľník',
            labelen: 'Podnikateľ-fyzická osoba-nezapís.v OR-podnikajúca súčasne ako sam.hosp.roľník'
        },
        {
            value: 'U3QQ',
            labelcz: 'Banka - akciová spoločnosť',
            labelen: 'Banka - akciová spoločnosť'
        },
        { value: 'U5IM', labelcz: 'Železnice SR', labelen: 'Železnice SR' },
        { value: 'U7QK', labelcz: 'Nadácia', labelen: 'Nadácia' },
        {
            value: 'UCTO',
            labelcz: 'Oblastná organizačná jednotka ČSD',
            labelen: 'Oblastná organizačná jednotka ČSD'
        },
        {
            value: 'VATN',
            labelcz: 'Európske zoskupenie územnej spolupráce',
            labelen: 'Európske zoskupenie územnej spolupráce'
        },
        {
            value: 'VRJP',
            labelcz: 'Nezisková organizácia poskytujúca všeobecne prospešné služby',
            labelen: 'Nezisková organizácia poskytujúca všeobecne prospešné služby'
        },
        {
            value: 'VSC1',
            labelcz: 'Zahraničné kultúrne, informačné stredisko, rozhlasová, tlačová a televízna agentúra',
            labelen: 'Zahraničné kultúrne, informačné stredisko, rozhlasová, tlačová a televízna agentúra'
        },
        {
            value: 'VSZS',
            labelcz: 'Spoločnosť s ručením obmedzeným',
            labelen: 'Spoločnosť s ručením obmedzeným'
        },
        {
            value: 'WQCR',
            labelcz: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním',
            labelen: 'Podnikateľ-fyzická osoba-zapís.v OR-podnikajúca súčasne ako osoba so slobodným povolaním'
        },
        {
            value: 'XLXU',
            labelcz: 'Politická strana, politické hnutie',
            labelen: 'Politická strana, politické hnutie'
        },
        { value: 'Y1X5', labelcz: 'Štátny podnik', labelen: 'Štátny podnik' },
        {
            value: 'Y45Q',
            labelcz: 'Podnik zahraničného obchodu',
            labelen: 'Podnik zahraničného obchodu'
        },
        {
            value: 'YB59',
            labelcz: 'Podnik so zahraničnou majetkovou účasťou',
            labelen: 'Podnik so zahraničnou majetkovou účasťou'
        },
        {
            value: 'YF99',
            labelcz: 'Verejnoprávna inštitúcia',
            labelen: 'Verejnoprávna inštitúcia'
        },
        {
            value: 'YGN4',
            labelcz: 'Organizačná zložka podniku',
            labelen: 'Organizačná zložka podniku'
        },
        {
            value: 'YRIU',
            labelcz: 'Nezisková organizácia',
            labelen: 'Nezisková organizácia'
        },
        {
            value: 'YVE8',
            labelcz: 'Európske zoskupenie hospodárskych záujmov',
            labelen: 'Európske zoskupenie hospodárskych záujmov'
        },
        {
            value: 'YVWB',
            labelcz: 'Záujmové združenie fyzických osôb bez právnej spôsobilosti',
            labelen: 'Záujmové združenie fyzických osôb bez právnej spôsobilosti'
        },
        {
            value: 'ZG2I',
            labelcz: 'Spoločenstvá vlastníkov pozemkov, bytov a pod.',
            labelen: 'Spoločenstvá vlastníkov pozemkov, bytov a pod.'
        }
    ],
    SI: [
        { value: '14AT', labelcz: 'Javna agencija', labelen: 'Javna agencija' },
        { value: '1OR3', labelcz: 'delniška družba', labelen: 'delniška družba' },
        { value: '2CTG', labelcz: 'zadruga', labelen: 'zadruga' },
        { value: '34PA', labelcz: 'Centralna banka', labelen: 'Centralna banka' },
        { value: 'RG9Z', labelcz: 'Societas Cooperativa Europaea', labelen: 'Societas Cooperativa Europaea' },
        {
            value: '4A8T',
            labelcz: 'evropska delniška družba',
            labelen: 'evropska delniška družba'
        },
        {
            value: '5LXY',
            labelcz: 'Verska skupnost in podobne verske organizacije',
            labelen: 'Verska skupnost in podobne verske organizacije'
        },
        { value: '6MPY', labelcz: 'Ustanova', labelen: 'Ustanova' },
        {
            value: '8ER6',
            labelcz: 'Stanovanjska zadruga',
            labelen: 'Stanovanjska zadruga'
        },
        {
            value: 'D64E',
            labelcz: 'Gospodarska zbornica',
            labelen: 'Gospodarska zbornica'
        },
        {
            value: 'E01X',
            labelcz: 'zadruga v zasebni lasti',
            labelen: 'zadruga v zasebni lasti'
        },
        {
            value: 'HJCS',
            labelcz: 'Društvo, zveza društev',
            labelen: 'Društvo, zveza društev'
        },
        { value: 'I7MN', labelcz: 'Javno podjetje', labelen: 'Javno podjetje' },
        {
            value: 'ICQT',
            labelcz: 'Družba za vzajemno zavarovanje',
            labelen: 'Družba za vzajemno zavarovanje'
        },
        {
            value: 'JQA2',
            labelcz: 'Kmetijska zadruga',
            labelen: 'Kmetijska zadruga'
        },
        {
            value: 'KBKD',
            labelcz: 'družba z omejeno odgovornostjo',
            labelen: 'družba z omejeno odgovornostjo'
        },
        {
            value: 'KH4O',
            labelcz: 'Skupnost lastnikov stanovanj',
            labelen: 'Skupnost lastnikov stanovanj'
        },
        { value: 'LNYR', labelcz: 'Obrtna zadruga', labelen: 'Obrtna zadruga' },
        { value: 'M84A', labelcz: 'Sklad', labelen: 'Sklad' },
        {
            value: 'OPDJ',
            labelcz: 'komanditna družba',
            labelen: 'komanditna družba'
        },
        {
            value: 'Q2EV',
            labelcz: 'Evropsko gospodarsko interesno združenje',
            labelen: 'Evropsko gospodarsko interesno združenje'
        },
        {
            value: 'QUEA',
            labelcz: 'Tuja pravna oseba po ZZK-1',
            labelen: 'Tuja pravna oseba po ZZK-1'
        },
        {
            value: 'QW8S',
            labelcz: 'Samostojni podjetnik posameznik',
            labelen: 'Samostojni podjetnik posameznik'
        },
        {
            value: 'QYQ5',
            labelcz: 'Družbeno podjetje',
            labelen: 'Družbeno podjetje'
        },
        {
            value: 'RAX7',
            labelcz: 'Zadruga z omejeno odgovornostjo',
            labelen: 'Zadruga z omejeno odgovornostjo'
        },
        {
            value: 'S1UI',
            labelcz: 'Civilna odvetniška družba',
            labelen: 'Civilna odvetniška družba'
        },
        {
            value: 'SD81',
            labelcz: 'družba z neomejeno odgovornostjo',
            labelen: 'družba z neomejeno odgovornostjo'
        },
        {
            value: 'TMVE',
            labelcz: 'Zadruga brez odgovornosti',
            labelen: 'Zadruga brez odgovornosti'
        },
        {
            value: 'UDQJ',
            labelcz: 'Gospodarsko interesno združenje',
            labelen: 'Gospodarsko interesno združenje'
        },
        { value: 'UESF', labelcz: 'Javni sklad', labelen: 'Javni sklad' },
        {
            value: 'UG0E',
            labelcz: 'Dobrodelna organizacija',
            labelen: 'Dobrodelna organizacija'
        },
        {
            value: 'WZ78',
            labelcz: 'komanditna delniška družba',
            labelen: 'komanditna delniška družba'
        },
        {
            value: 'X94Z',
            labelcz: 'Republika Slovenija',
            labelen: 'Republika Slovenija'
        }
    ],
    SB: [
        { value: '8PIA', labelcz: 'Private Company', labelen: 'Private Company' },
        {
            value: 'A7VA',
            labelcz: 'Community Company',
            labelen: 'Community Company'
        },
        { value: 'YSBJ', labelcz: 'Overseas Company', labelen: 'Overseas Company' },
        { value: 'Z4ZP', labelcz: 'Public Company', labelen: 'Public Company' }
    ],
    ZA: [
        {
            value: '4YUU',
            labelcz: 'Close Corporation',
            labelen: 'Close Corporation'
        },
        {
            value: 'CXWJ',
            labelcz: 'Co-operatives (Secondary)',
            labelen: 'Co-operatives (Secondary)'
        },
        { value: 'GQVQ', labelcz: 'Private Company', labelen: 'Private Company' },
        {
            value: 'J7L0',
            labelcz: 'Non-Profit Company',
            labelen: 'Non-Profit Company'
        },
        {
            value: 'MZT6',
            labelcz: 'Co-operatives (Primary)',
            labelen: 'Co-operatives (Primary)'
        },
        {
            value: 'R155',
            labelcz: 'State Owned Company',
            labelen: 'State Owned Company'
        },
        { value: 'R59V', labelcz: 'External Company', labelen: 'External Company' },
        {
            value: 'U89P',
            labelcz: 'Personal Liability Company',
            labelen: 'Personal Liability Company'
        },
        { value: 'XE4Z', labelcz: 'Public Company', labelen: 'Public Company' },
        {
            value: 'ZE81',
            labelcz: 'Co-operatives (Tertiary)',
            labelen: 'Co-operatives (Tertiary)'
        }
    ],
    ES: [
        {
            value: '1G29',
            labelcz: 'Sociedad Limitada Laboral (o Sociedad de Responsabilidad Limitada laboral)',
            labelen: 'Sociedad Limitada Laboral (o Sociedad de Responsabilidad Limitada laboral)'
        },
        {
            value: '1QU8',
            labelcz: 'Sociedad Cooperativa',
            labelen: 'Sociedad Cooperativa'
        },
        {
            value: '1SL4',
            labelcz: 'Empresario Individual',
            labelen: 'Empresario Individual'
        },
        {
            value: '1ZHJ',
            labelcz: 'Sociedad Colectiva Profesional (o Sociedad regular colectiva profesional)',
            labelen: 'Sociedad Colectiva Profesional (o Sociedad regular colectiva profesional)'
        },
        { value: '4S57', labelcz: 'Caja de Ahorros', labelen: 'Caja de Ahorros' },
        {
            value: '4SJR',
            labelcz: 'Sociedad Agraría de Trasformación',
            labelen: 'Sociedad Agraría de Trasformación'
        },
        { value: '5RDO', labelcz: 'Sociedad Anonima', labelen: 'Sociedad Anonima' },
        {
            value: '7U8O',
            labelcz: 'Sociedades de Inversion Inmobiliaria',
            labelen: 'Sociedades de Inversion Inmobiliaria'
        },
        {
            value: '8EHB',
            labelcz: 'Sociedad de Inversión de Capital Variable',
            labelen: 'Sociedad de Inversión de Capital Variable'
        },
        {
            value: '956I',
            labelcz: 'Sociedad Limitada de nueva empresa',
            labelen: 'Sociedad Limitada de nueva empresa'
        },
        {
            value: '9FPZ',
            labelcz: 'Sociedad Anonima Europea',
            labelen: 'Sociedad Anonima Europea'
        },
        { value: 'A0J6', labelcz: 'Asociación', labelen: 'Asociación' },
        {
            value: 'A97B',
            labelcz: 'Mutualidad de Prevision Social',
            labelen: 'Mutualidad de Prevision Social'
        },
        {
            value: 'AJ9U',
            labelcz: 'Sociedad Anonima Profesional',
            labelen: 'Sociedad Anonima Profesional'
        },
        {
            value: 'ARDP',
            labelcz: 'Sociedad Civil Profesional',
            labelen: 'Sociedad Civil Profesional'
        },
        {
            value: 'AXS5',
            labelcz: 'Sociedad de Capital-Riesgo',
            labelen: 'Sociedad de Capital-Riesgo'
        },
        {
            value: 'B0V5',
            labelcz: 'Sociedad Cooperativa Profesional',
            labelen: 'Sociedad Cooperativa Profesional'
        },
        {
            value: 'BI3B',
            labelcz: 'Agrupacion Europea de Interes Economico',
            labelen: 'Agrupacion Europea de Interes Economico'
        },
        { value: 'CUIH', labelcz: 'Mutua', labelen: 'Mutua' },
        {
            value: 'DDES',
            labelcz: 'Sociedad de Capital-Riesgo-Pyme',
            labelen: 'Sociedad de Capital-Riesgo-Pyme'
        },
        {
            value: 'DP3Q',
            labelcz: 'Sociedad de Responsabilidad Limitada',
            labelen: 'Sociedad de Responsabilidad Limitada'
        },
        {
            value: 'FCJF',
            labelcz: 'Fondo de Inversion en activos del Mercado Monetario',
            labelen: 'Fondo de Inversion en activos del Mercado Monetario'
        },
        {
            value: 'FH4R',
            labelcz: 'Fondo de Pensiones',
            labelen: 'Fondo de Pensiones'
        },
        {
            value: 'GJL1',
            labelcz: 'Sociedad Comanditaria por Acciones',
            labelen: 'Sociedad Comanditaria por Acciones'
        },
        {
            value: 'GJTL',
            labelcz: 'Sociedad Comanditaria por Acciones Profesional',
            labelen: 'Sociedad Comanditaria por Acciones Profesional'
        },
        {
            value: 'HRQA',
            labelcz: 'Sociedad Cooperativa Europea',
            labelen: 'Sociedad Cooperativa Europea'
        },
        {
            value: 'I2WU',
            labelcz: 'Agrupacion de Interes Economico',
            labelen: 'Agrupacion de Interes Economico'
        },
        {
            value: 'IAS6',
            labelcz: 'Sociedad de Garantia Reciproca',
            labelen: 'Sociedad de Garantia Reciproca'
        },
        {
            value: 'IT6N',
            labelcz: 'Emprendedor de Responsabilidad Limitada',
            labelen: 'Emprendedor de Responsabilidad Limitada'
        },
        {
            value: 'JB2M',
            labelcz: 'Sociedad Limitada Profesional',
            labelen: 'Sociedad Limitada Profesional'
        },
        {
            value: 'JTV5',
            labelcz: 'Fondo de Capital-Riesgo',
            labelen: 'Fondo de Capital-Riesgo'
        },
        {
            value: 'K0RI',
            labelcz: 'Institucion de Inversion Colectiva',
            labelen: 'Institucion de Inversion Colectiva'
        },
        {
            value: 'K6L9',
            labelcz: 'Sociedad Civil Profesional',
            labelen: 'Sociedad Civil Profesional'
        },
        { value: 'MDOL', labelcz: 'Fundación', labelen: 'Fundación' },
        {
            value: 'QMUM',
            labelcz: 'Fondos de Inversion Inmobiliaria',
            labelen: 'Fondos de Inversion Inmobiliaria'
        },
        {
            value: 'R2L8',
            labelcz: 'Sociedad Anonima Laboral',
            labelen: 'Sociedad Anonima Laboral'
        },
        {
            value: 'R6UT',
            labelcz: 'Sociedad Limitada Unipersonal',
            labelen: 'Sociedad Limitada Unipersonal'
        },
        {
            value: 'S0Z5',
            labelcz: 'Fondo de Inversion',
            labelen: 'Fondo de Inversion'
        },
        { value: 'S6MS', labelcz: 'Congregación', labelen: 'Congregación' },
        {
            value: 'S6X7',
            labelcz: 'Sociedad Colectiva',
            labelen: 'Sociedad Colectiva'
        },
        {
            value: 'SS0L',
            labelcz: 'Cooperativa de Credito',
            labelen: 'Cooperativa de Credito'
        },
        {
            value: 'TDD5',
            labelcz: 'Sociedad Comanditaria Simple',
            labelen: 'Sociedad Comanditaria Simple'
        },
        {
            value: 'TUHS',
            labelcz: 'Corporación de Derecho Público',
            labelen: 'Corporación de Derecho Público'
        },
        {
            value: 'UJ35',
            labelcz: 'Fondo de Inversion Mobiliaria',
            labelen: 'Fondo de Inversion Mobiliaria'
        },
        {
            value: 'VFIU',
            labelcz: 'Sociedad Comanditaria Simple Profesional',
            labelen: 'Sociedad Comanditaria Simple Profesional'
        },
        {
            value: 'XYGP',
            labelcz: 'Fondo de Capital-Riesgo-Pyme',
            labelen: 'Fondo de Capital-Riesgo-Pyme'
        }
    ],
    SR: [
        { value: '8MS6', labelcz: 'Stichting', labelen: 'Stichting' },
        {
            value: 'K4ZA',
            labelcz: 'Cooperatieve Vereniging',
            labelen: 'Cooperatieve Vereniging'
        },
        {
            value: 'KJZ3',
            labelcz: 'Filiaal of Bijkantoor',
            labelen: 'Filiaal of Bijkantoor'
        },
        {
            value: 'OBTO',
            labelcz: 'Commanditaire vennootschap (op aandelen) met een beherende vennoot',
            labelen: 'Commanditaire vennootschap (op aandelen) met een beherende vennoot'
        },
        { value: 'QPC9', labelcz: 'Vereniging', labelen: 'Vereniging' },
        {
            value: 'QWWY',
            labelcz: 'Commanditaire vennootschap (op aandelen) met meer dan een beherende vennoot',
            labelen: 'Commanditaire vennootschap (op aandelen) met meer dan een beherende vennoot'
        },
        { value: 'R6BI', labelcz: 'Eenmanszaak', labelen: 'Eenmanszaak' },
        {
            value: 'TCVB',
            labelcz: 'Naamloze Vennootschap / Limited Company by Shares',
            labelen: 'Naamloze Vennootschap / Limited Company by Shares'
        },
        {
            value: 'WBWC',
            labelcz: 'Vennootschap onder een firma',
            labelen: 'Vennootschap onder een firma'
        }
    ],
    SE: [
        {
            value: '1TN0',
            labelcz: 'Ideell förening (som bedriver näringsverksamhet)',
            labelen: 'Ideell förening (som bedriver näringsverksamhet)'
        },
        {
            value: '2UAX',
            labelcz: 'Trossamfund (som bedriver näringsverksamhet)',
            labelen: 'Trossamfund (som bedriver näringsverksamhet)'
        },
        { value: '381R', labelcz: 'Medlemsbank', labelen: 'Medlemsbank' },
        { value: '54P7', labelcz: 'Europabolag', labelen: 'Europabolag' },
        { value: '9YIP', labelcz: 'Europakooperativ', labelen: 'Europakooperativ' },
        { value: 'AZTO', labelcz: 'Sambruksförening', labelen: 'Sambruksförening' },
        { value: 'BEAY', labelcz: 'Handelsbolag', labelen: 'Handelsbolag' },
        { value: 'BYQJ', labelcz: 'Bankaktiebolag', labelen: 'Bankaktiebolag' },
        {
            value: 'C61P',
            labelcz: 'Ekonomisk förening',
            labelen: 'Ekonomisk förening'
        },
        { value: 'CX05', labelcz: 'Kommanditbolag', labelen: 'Kommanditbolag' },
        { value: 'G04R', labelcz: 'Sparbank', labelen: 'Sparbank' },
        {
            value: 'M0Y0',
            labelcz: 'Försäkringsförening',
            labelen: 'Försäkringsförening'
        },
        {
            value: 'O1QI',
            labelcz: 'Ömsesidigt försäkringsbolag',
            labelen: 'Ömsesidigt försäkringsbolag'
        },
        {
            value: 'OJ9I',
            labelcz: 'Försäkringsaktiebolag',
            labelen: 'Försäkringsaktiebolag'
        },
        {
            value: 'PDQ0',
            labelcz: 'Kooperativ hyresrättsförening',
            labelen: 'Kooperativ hyresrättsförening'
        },
        {
            value: 'RLJO',
            labelcz: 'Europeisk ekonomisk intressegruppering',
            labelen: 'Europeisk ekonomisk intressegruppering'
        },
        {
            value: 'RYFP',
            labelcz: 'Europeisk gruppering för territoriellt samarbete',
            labelen: 'Europeisk gruppering för territoriellt samarbete'
        },
        {
            value: 'SSOM',
            labelcz: 'Bostadsrättsförening',
            labelen: 'Bostadsrättsförening'
        },
        { value: 'WZDB', labelcz: 'Bostadsförening', labelen: 'Bostadsförening' },
        { value: 'XJHM', labelcz: 'Aktiebolag', labelen: 'Aktiebolag' }
    ],
    CH: [
        {
            value: '1BL5',
            labelcz: 'Swiss branch of an enterprise domiciled abroad not registered in the commercial register',
            labelen: 'Swiss branch of an enterprise domiciled abroad not registered in the commercial register'
        },
        {
            value: '1RKS',
            labelcz: 'Foreign public administration (e.g. embassy)',
            labelen: 'Foreign public administration (e.g. embassy)'
        },
        {
            value: '2B81',
            labelcz: 'Simple partnership',
            labelen: 'Simple partnership'
        },
        { value: '2JZ4', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: '2WFG',
            labelcz: 'Foreign public company',
            labelen: 'Foreign public company'
        },
        {
            value: '2XJA',
            labelcz: 'Federal administration',
            labelen: 'Federal administration'
        },
        {
            value: '3EKS',
            labelcz: 'Limited liability company',
            labelen: 'Limited liability company'
        },
        {
            value: '54WI',
            labelcz: 'Investment company with fixed capital',
            labelen: 'Investment company with fixed capital'
        },
        {
            value: '5BEZ',
            labelcz: 'Special legal form',
            labelen: 'Special legal form'
        },
        {
            value: '7MNN',
            labelcz: 'Public sector institution',
            labelen: 'Public sector institution'
        },
        {
            value: 'AZA0',
            labelcz: 'Sole proprietorship',
            labelen: 'Sole proprietorship'
        },
        {
            value: 'BF9N',
            labelcz: 'Federal public company',
            labelen: 'Federal public company'
        },
        {
            value: 'CQMY',
            labelcz: 'Limited partnership',
            labelen: 'Limited partnership'
        },
        {
            value: 'DP2E',
            labelcz: 'International organisation',
            labelen: 'International organisation'
        },
        {
            value: 'E0NE',
            labelcz: 'Public corporation',
            labelen: 'Public corporation'
        },
        {
            value: 'FFTN',
            labelcz: 'Cantonal administration',
            labelen: 'Cantonal administration'
        },
        { value: 'FJG4', labelcz: 'Trust', labelen: 'Trust' },
        { value: 'FLNB', labelcz: 'Fonds', labelen: 'Fonds' },
        {
            value: 'GP8M',
            labelcz: 'Local administration',
            labelen: 'Local administration'
        },
        { value: 'H781', labelcz: 'Association', labelen: 'Association' },
        {
            value: 'HX77',
            labelcz: 'Cantonal public company',
            labelen: 'Cantonal public company'
        },
        {
            value: 'JB25',
            labelcz: 'Swiss branch of an enterprise domiciled abroad registered in the commercial registrer',
            labelen: 'Swiss branch of an enterprise domiciled abroad registered in the commercial registrer'
        },
        {
            value: 'KJ9Q',
            labelcz: 'Non-commercial power of attorney',
            labelen: 'Non-commercial power of attorney'
        },
        {
            value: 'L5DU',
            labelcz: 'Local public company',
            labelen: 'Local public company'
        },
        {
            value: 'M848',
            labelcz: 'Corpororate public company',
            labelen: 'Corpororate public company'
        },
        {
            value: 'MRSY',
            labelcz: 'General partnership',
            labelen: 'General partnership'
        },
        {
            value: 'MVII',
            labelcz: 'Company limited by shares',
            labelen: 'Company limited by shares'
        },
        {
            value: 'OBFU',
            labelcz: 'Representative of an ownership in undivided shares',
            labelen: 'Representative of an ownership in undivided shares'
        },
        { value: 'QSI2', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: 'R9TC',
            labelcz: 'Foreign enterprise',
            labelen: 'Foreign enterprise'
        },
        {
            value: 'TL87',
            labelcz: 'Limited partnership for collective investments',
            labelen: 'Limited partnership for collective investments'
        },
        {
            value: 'UNA9',
            labelcz: 'Swiss branch registered at the registry of commerce',
            labelen: 'Swiss branch registered at the registry of commerce'
        },
        {
            value: 'VPRH',
            labelcz: 'District public company',
            labelen: 'District public company'
        },
        {
            value: 'W6A7',
            labelcz: 'Patnership limited by shares',
            labelen: 'Patnership limited by shares'
        },
        {
            value: 'XJOT',
            labelcz: 'Investment company with variable capital',
            labelen: 'Investment company with variable capital'
        },
        {
            value: 'YRGM',
            labelcz: 'District administration',
            labelen: 'District administration'
        }
    ],
    TO: [
        { value: 'UZUP', labelcz: 'Local Company', labelen: 'Local Company' },
        { value: 'ZQEN', labelcz: 'Overseas Company', labelen: 'Overseas Company' }
    ],
    TR: [
        { value: '5T3H', labelcz: 'Fonlar', labelen: 'Fonlar' },
        { value: 'JMQU', labelcz: 'kollektif şirket', labelen: 'kollektif şirket' },
        { value: 'ONVA', labelcz: 'komandit şirket', labelen: 'komandit şirket' },
        { value: 'R5UT', labelcz: 'limited şirket', labelen: 'limited şirket' },
        { value: 'W2SQ', labelcz: 'anonim şirket', labelen: 'anonim şirket' }
    ],
    AE: [
        {
            value: 'F8VX',
            labelcz: 'Joint Liability Company',
            labelen: 'Joint Liability Company'
        },
        {
            value: 'JGNU',
            labelcz: 'Public Joint Stock Company',
            labelen: 'Public Joint Stock Company'
        },
        {
            value: 'LOL8',
            labelcz: 'Simple Commandite Company',
            labelen: 'Simple Commandite Company'
        },
        { value: 'MV4S', labelcz: 'Sole Proprietor', labelen: 'Sole Proprietor' },
        {
            value: 'RWVW',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'WR09',
            labelcz: 'Private Joint Stock Company',
            labelen: 'Private Joint Stock Company'
        },
        {
            value: '4VPM',
            labelcz: 'Incorporated Cell',
            labelen: 'Incorporated Cell'
        },
        {
            value: '6H9F',
            labelcz: 'Open Ended Investment Company',
            labelen: 'Open Ended Investment Company'
        },
        {
            value: '9I58',
            labelcz: 'Private Company Unlimited without Shares',
            labelen: 'Private Company Unlimited without Shares'
        },
        {
            value: '9U6F',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'B13W',
            labelcz: 'Restricted Scope Company',
            labelen: 'Restricted Scope Company'
        },
        {
            value: 'FE4G',
            labelcz: 'Protected Cell Company',
            labelen: 'Protected Cell Company'
        },
        {
            value: 'GU5E',
            labelcz: 'Public Company Limited by Shares',
            labelen: 'Public Company Limited by Shares'
        },
        {
            value: 'H8MU',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'HECG',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'KAEM',
            labelcz: 'Private Company Unlimited with Shares',
            labelen: 'Private Company Unlimited with Shares'
        },
        {
            value: 'LZ3H',
            labelcz: 'Close Ended Investment Company',
            labelen: 'Close Ended Investment Company'
        },
        {
            value: 'OSE2',
            labelcz: 'Private Company Limited by Shares',
            labelen: 'Private Company Limited by Shares'
        },
        {
            value: 'PNX6',
            labelcz: 'Incorporated Cell Company',
            labelen: 'Incorporated Cell Company'
        },
        {
            value: 'R2YL',
            labelcz: 'Private Company Limited by Guarantee',
            labelen: 'Private Company Limited by Guarantee'
        },
        { value: 'VKZD', labelcz: 'Foundation', labelen: 'Foundation' },
        { value: '375P', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: '3P03',
            labelcz: 'Open Ended Investment Company',
            labelen: 'Open Ended Investment Company'
        },
        {
            value: '46QC',
            labelcz: 'Public Company Limited by Shares',
            labelen: 'Public Company Limited by Shares'
        },
        {
            value: '70EO',
            labelcz: 'Private Company Limited by Shares',
            labelen: 'Private Company Limited by Shares'
        },
        {
            value: 'AIR0',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'F3UE',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'RWX4',
            labelcz: 'Protected Cell Company',
            labelen: 'Protected Cell Company'
        },
        {
            value: 'V2PA',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'VTIP',
            labelcz: 'Close Ended Investment Company',
            labelen: 'Close Ended Investment Company'
        },
        {
            value: '35BX',
            labelcz: 'Intellectual Property Holding Company ',
            labelen: 'Intellectual Property Holding Company '
        },
        {
            value: 'FHRL',
            labelcz: 'Segregated Portfolio Company',
            labelen: 'Segregated Portfolio Company'
        },
        {
            value: 'GQ8F',
            labelcz: 'Company Limited By Guarantee',
            labelen: 'Company Limited By Guarantee'
        },
        {
            value: 'HNPH',
            labelcz: 'Restricted Purposes Company',
            labelen: 'Restricted Purposes Company'
        },
        {
            value: 'QJVN',
            labelcz: 'Company Limited By Shares',
            labelen: 'Company Limited By Shares'
        },
        {
            value: 'Z3P8',
            labelcz: 'Unlimited Company',
            labelen: 'Unlimited Company'
        }
    ],
    GB: [
        { value: '468Q', labelcz: 'United Kingdom Societas', labelen: 'United Kingdom Societas' },
        {
            value: 'VYF8',
            labelcz: 'United Kingdom Economic Interest Grouping',
            labelen: 'United Kingdom Economic Interest Grouping'
        },
        {
            value: '17R0',
            labelcz: 'Community Interest Company',
            labelen: 'Community Interest Company'
        },
        { value: '1W62', labelcz: 'Oversea Company', labelen: 'Oversea Company' },
        {
            value: '4A3J',
            labelcz: 'Northern Ireland Company',
            labelen: 'Northern Ireland Company'
        },
        {
            value: '4GJI',
            labelcz: 'Private Limited by Guarantee',
            labelen: 'Private Limited by Guarantee'
        },
        {
            value: '55MA',
            labelcz: 'Cwmni Cyfyngedig Cyhoeddus',
            labelen: 'Cwmni Cyfyngedig Cyhoeddus'
        },
        {
            value: '57V7',
            labelcz: 'Private Unlimited',
            labelen: 'Private Unlimited'
        },
        {
            value: '5FRT',
            labelcz: 'Other Type of Company (in Northern Ireland)',
            labelen: 'Other Type of Company (in Northern Ireland)'
        },
        {
            value: '60IF',
            labelcz: 'Private Unlimited/No Share Capital',
            labelen: 'Private Unlimited/No Share Capital'
        },
        {
            value: '7T8N',
            labelcz: 'Charitable Incorporated Organisation',
            labelen: 'Charitable Incorporated Organisation'
        },
        {
            value: '7VVZ',
            labelcz: 'Co-operative Society (Northern Ireland)',
            labelen: 'Co-operative Society (Northern Ireland)'
        },
        {
            value: '8CF0',
            labelcz: 'Assurance Company',
            labelen: 'Assurance Company'
        },
        {
            value: '9B78',
            labelcz: 'Royal Charter Company',
            labelen: 'Royal Charter Company'
        },
        {
            value: 'A2X8',
            labelcz: 'Unregistered Company',
            labelen: 'Unregistered Company'
        },
        {
            value: 'AVYY',
            labelcz: 'Government Entity',
            labelen: 'Government Entity'
        },
        {
            value: 'B6ES',
            labelcz: 'Public Limited Company',
            labelen: 'Public Limited Company'
        },
        { value: 'BX6Y', labelcz: 'Friendly Society', labelen: 'Friendly Society' },
        {
            value: 'C605',
            labelcz: 'Private Limited by Shares (Section 30 Exemption)',
            labelen: 'Private Limited by Shares (Section 30 Exemption)'
        },
        { value: 'CDOT', labelcz: 'UK Establishment', labelen: 'UK Establishment' },
        { value: 'E12O', labelcz: 'Building Society', labelen: 'Building Society' },
        {
            value: 'FVGZ',
            labelcz: 'Industrial and Provident Society',
            labelen: 'Industrial and Provident Society'
        },
        {
            value: 'G12F',
            labelcz: 'Private Limited by Guarantee/No Share Capital',
            labelen: 'Private Limited by Guarantee/No Share Capital'
        },
        {
            value: 'H0PO',
            labelcz: 'Private Limited Company',
            labelen: 'Private Limited Company'
        },

        { value: 'HX6D', labelcz: 'Private Limited', labelen: 'Private Limited' },
        {
            value: 'ID30',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'IYXU',
            labelcz: 'Community Benefit Society',
            labelen: 'Community Benefit Society'
        },
        {
            value: 'JTCO',
            labelcz: 'Credit Union (Northern Ireland)',
            labelen: 'Credit Union (Northern Ireland)'
        },

        {
            value: 'NBTW',
            labelcz: 'Scottish Partnership',
            labelen: 'Scottish Partnership'
        },
        {
            value: 'Q0M5',
            labelcz: 'Unregistered Company',
            labelen: 'Unregistered Company'
        },
        {
            value: 'STX7',
            labelcz: 'Scottish Charitable Incorporated Organisation',
            labelen: 'Scottish Charitable Incorporated Organisation'
        },
        { value: 'T61R', labelcz: 'cyfyngedig', labelen: 'cyfyngedig' },
        {
            value: 'TT2H',
            labelcz: 'Protected Cell Company',
            labelen: 'Protected Cell Company'
        },
        {
            value: 'TYJK',
            labelcz: 'Private Limited by Guarantee/No Share Capital (Use of Limited Exemption)',
            labelen: 'Private Limited by Guarantee/No Share Capital (Use of Limited Exemption)'
        },
        {
            value: 'UTY8',
            labelcz: 'Community Benefit Society (Northern Ireland)',
            labelen: 'Community Benefit Society (Northern Ireland)'
        },
        {
            value: 'VV0W',
            labelcz: 'Investment Company with Variable Capital',
            labelen: 'Investment Company with Variable Capital'
        },
        { value: 'WBQU', labelcz: 'Credit Union', labelen: 'Credit Union' },
        {
            value: 'WJ0A',
            labelcz: 'Partneriaeth Atebolrwydd Cyfyngedig',
            labelen: 'Partneriaeth Atebolrwydd Cyfyngedig'
        },
        {
            value: 'XLZV',
            labelcz: 'Registered Society',
            labelen: 'Registered Society'
        },
        {
            value: 'Z0EY',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'ZQ6S',
            labelcz: 'Old Public Company',
            labelen: 'Old Public Company'
        },
        {
            value: 'ZZGG',
            labelcz: 'Co-operative Society',
            labelen: 'Co-operative Society'
        }
    ],
    US: [
        {
            value: 'CR3H',
            labelcz: 'Registered Limited Liability Partnership',
            labelen: 'Registered Limited Liability Partnership'
        },
        {
            value: 'CWRI',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'HFGV',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'HN8W',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'V65U',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: 'WDT2',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: '9A4Q',
            labelcz: 'Religious Corporation',
            labelen: 'Religious Corporation'
        },
        {
            value: 'BRO8',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'D4YS',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'K2BJ',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: 'M886',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'OVBT',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'TRS2',
            labelcz: 'Cooperative Corporation',
            labelen: 'Cooperative Corporation'
        },
        {
            value: 'VXDE',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '5MNR',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: '78H5',
            labelcz: 'Corporation (Nonprofit)',
            labelen: 'Corporation (Nonprofit)'
        },
        {
            value: 'A9AW',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'D8PB',
            labelcz: 'Business Development Corporation',
            labelen: 'Business Development Corporation'
        },
        {
            value: 'FGVH',
            labelcz: 'Corporation (Business or for-profit)',
            labelen: 'Corporation (Business or for-profit)'
        },
        {
            value: 'IMDT',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        { value: 'IVQQ', labelcz: 'Corporation Sole', labelen: 'Corporation Sole' },
        {
            value: 'N69M',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'O85W',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        { value: 'P24O', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'QEEJ',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        {
            value: 'QUJ5',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        {
            value: 'RSWJ',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'S68T',
            labelcz: 'Electric Cooperative Nonprofit Membership Corporation',
            labelen: 'Electric Cooperative Nonprofit Membership Corporation'
        },
        {
            value: 'ST2Q',
            labelcz: 'Cooperative Marketing Association',
            labelen: 'Cooperative Marketing Association'
        },
        {
            value: 'UGE3',
            labelcz: 'Nonprofit Electric Generation and Transmission Cooperative Corporation',
            labelen: 'Nonprofit Electric Generation and Transmission Cooperative Corporation'
        },
        {
            value: 'VKPN',
            labelcz: 'Close Corporation',
            labelen: 'Close Corporation'
        },
        {
            value: '1K9U',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: 'EJX1',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'KGZ8',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'L2DM',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: 'M4FO',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'MJJZ',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '5HQ4',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '7CDL',
            labelcz: 'For-Profit Corporation Close',
            labelen: 'For-Profit Corporation Close'
        },
        {
            value: 'BADE',
            labelcz: 'Nonprofit Common Interest Development Association',
            labelen: 'Nonprofit Common Interest Development Association'
        },
        {
            value: 'CVXK',
            labelcz: 'Nonprofit Corporation Religious',
            labelen: 'Nonprofit Corporation Religious'
        },
        {
            value: 'EI4J',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'G1P6',
            labelcz: 'Nonprofit Corporation Mutual Benefit',
            labelen: 'Nonprofit Corporation Mutual Benefit'
        },
        {
            value: 'H1UM',
            labelcz: 'For-Profit Corporation General Stock',
            labelen: 'For-Profit Corporation General Stock'
        },
        {
            value: 'K7YU',
            labelcz: 'Nonprofit Corporation Public Benefit',
            labelen: 'Nonprofit Corporation Public Benefit'
        },
        {
            value: 'PZR6',
            labelcz: 'For-Profit Corporation Professional',
            labelen: 'For-Profit Corporation Professional'
        },
        {
            value: 'SQ7B',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: '81WV',
            labelcz: 'Limited Cooperative Association',
            labelen: 'Limited Cooperative Association'
        },
        {
            value: 'BC32',
            labelcz: 'Limited Partnership Association',
            labelen: 'Limited Partnership Association'
        },
        {
            value: 'HLCG',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'I3Z9',
            labelcz: 'For-Profit Public Benefit Corporation',
            labelen: 'For-Profit Public Benefit Corporation'
        },
        {
            value: 'L10T',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'M64D',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'OWR6',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'PDLV',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: 'WE9D',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: 'ZCHO',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: '7W53',
            labelcz: 'Nonstock Corporation',
            labelen: 'Nonstock Corporation'
        },
        {
            value: 'JKOT',
            labelcz: 'Stock Corporation',
            labelen: 'Stock Corporation'
        },
        {
            value: 'L7HH',
            labelcz: 'Religious Society or Religious Corporation',
            labelen: 'Religious Society or Religious Corporation'
        },
        {
            value: 'LKQ2',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: 'SHCN', labelcz: 'Statutory Trust', labelen: 'Statutory Trust' },
        {
            value: 'T80N',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'Y182',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: '12N6',
            labelcz: 'Unincorporated Nonprofit Association',
            labelen: 'Unincorporated Nonprofit Association'
        },
        {
            value: '1HXP',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: '4FSX', labelcz: 'Statutory Trust', labelen: 'Statutory Trust' },
        {
            value: 'HZEH',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        { value: 'QF4W', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: 'T91T',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'TGMR',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        { value: 'XTIQ', labelcz: 'Corporation', labelen: 'Corporation' },
        {
            value: '3N55',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: '5DS0',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '8N21',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'D155',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: 'TRI2',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: '6IIM',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'AD0H',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'ASC7',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'MFYJ',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'S7VR',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: '6MB6',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        { value: '982Z', labelcz: 'Service Mark', labelen: 'Service Mark' },
        {
            value: 'AQBO',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'B38Q',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'DX2N',
            labelcz: 'Corporation (Nonprofit)',
            labelen: 'Corporation (Nonprofit)'
        },
        { value: 'FTNW', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: 'L2QV',
            labelcz: 'Corporation (Profit)',
            labelen: 'Corporation (Profit)'
        },
        { value: 'L5BO', labelcz: 'Trade Name', labelen: 'Trade Name' },
        {
            value: 'M2KR',
            labelcz: 'Limited Liablity Partnership',
            labelen: 'Limited Liablity Partnership'
        },
        {
            value: 'S0BB',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'SBF3',
            labelcz: 'Sustainable Business Corporation',
            labelen: 'Sustainable Business Corporation'
        },
        { value: 'TTTV', labelcz: 'Corporation Sole', labelen: 'Corporation Sole' },
        {
            value: 'VPBH',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'WMTY',
            labelcz: 'Publicity Rights Name Registration',
            labelen: 'Publicity Rights Name Registration'
        },
        {
            value: 'YOUG',
            labelcz: 'Commercial Registered Agent',
            labelen: 'Commercial Registered Agent'
        },
        { value: 'ZLIW', labelcz: 'Trademark', labelen: 'Trademark' },
        {
            value: '530K',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'EVE6',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'QLWR',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'RU6X',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'U9HL',
            labelcz: 'General Business Corporation',
            labelen: 'General Business Corporation'
        },
        {
            value: 'UK9P',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: '1WZP',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '8RLE',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'AZUK',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'F5VL',
            labelcz: 'Professional Services Corporation',
            labelen: 'Professional Services Corporation'
        },
        {
            value: 'HSPI',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'VUXH',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '78PB',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: '95W7',
            labelcz: 'Financial Institution',
            labelen: 'Financial Institution'
        },
        {
            value: '9FD9',
            labelcz: 'Master Limited Liability Company',
            labelen: 'Master Limited Liability Company'
        },
        {
            value: 'D92T',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'DQBZ',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        { value: 'EW9A', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'EZ08',
            labelcz: 'Agricultural Cooperative',
            labelen: 'Agricultural Cooperative'
        },
        {
            value: 'G4YY',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'N0YQ',
            labelcz: 'Insurance Corporation',
            labelen: 'Insurance Corporation'
        },
        {
            value: 'R0BI',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'V5G5',
            labelcz: 'Professional Benefit Corporation',
            labelen: 'Professional Benefit Corporation'
        },
        {
            value: 'V89I',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        { value: 'VCQZ', labelcz: 'Series', labelen: 'Series' },
        {
            value: 'X4EB',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        {
            value: '32AX',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: '7XPF',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'DU35',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'HPKC',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'HUSW',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'L22N',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'VVPD',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        {
            value: '3MMY',
            labelcz: 'Limited Liability Limited Partership',
            labelen: 'Limited Liability Limited Partership'
        },
        {
            value: '5RRE',
            labelcz: 'Corporation (professional)',
            labelen: 'Corporation (professional)'
        },
        {
            value: '6GEC',
            labelcz: 'Limited Liability Company (professional)',
            labelen: 'Limited Liability Company (professional)'
        },
        { value: '85YQ', labelcz: 'Statutory Trust', labelen: 'Statutory Trust' },
        {
            value: 'A9VQ',
            labelcz: 'Limited Cooperative Assocation',
            labelen: 'Limited Cooperative Assocation'
        },
        {
            value: 'DAVB',
            labelcz: 'Corporation ( non-profit)',
            labelen: 'Corporation ( non-profit)'
        },
        {
            value: 'EBP8',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'F2QV',
            labelcz: 'Limited Liability Company (profit)',
            labelen: 'Limited Liability Company (profit)'
        },
        {
            value: 'LU9O',
            labelcz: 'Unincorporated Non-Profit Assocation',
            labelen: 'Unincorporated Non-Profit Assocation'
        },
        {
            value: 'MY61',
            labelcz: 'Limited Liability Company (non-profit)',
            labelen: 'Limited Liability Company (non-profit)'
        },
        {
            value: 'O5PH',
            labelcz: 'Public Benefit Corporation (profit)',
            labelen: 'Public Benefit Corporation (profit)'
        },
        { value: 'OFGO', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'QWPR',
            labelcz: 'Corporation (profit)',
            labelen: 'Corporation (profit)'
        },
        {
            value: 'T362',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'VE28',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '1V0I',
            labelcz: 'Domestic Benefit Corporation',
            labelen: 'Domestic Benefit Corporation'
        },
        {
            value: '6DVA',
            labelcz: 'Foreign Non-Profit Limited Liability Company',
            labelen: 'Foreign Non-Profit Limited Liability Company'
        },
        {
            value: '6EDK',
            labelcz: 'Domestic Non-Profit Corporation',
            labelen: 'Domestic Non-Profit Corporation'
        },
        {
            value: '8PUO',
            labelcz: 'Foreign Partnership',
            labelen: 'Foreign Partnership'
        },
        {
            value: '9L6B',
            labelcz: 'Foreign Limited Liability Company',
            labelen: 'Foreign Limited Liability Company'
        },
        {
            value: 'C1F4',
            labelcz: 'Domestic Public Benefit Corporation',
            labelen: 'Domestic Public Benefit Corporation'
        },
        {
            value: 'CD9O',
            labelcz: 'Domestic Limited Liability Company',
            labelen: 'Domestic Limited Liability Company'
        },
        {
            value: 'EO9A',
            labelcz: 'Foreign Real Estate Investment Trust',
            labelen: 'Foreign Real Estate Investment Trust'
        },
        {
            value: 'HQYG',
            labelcz: 'Foreign Corporation',
            labelen: 'Foreign Corporation'
        },
        {
            value: 'LTKC',
            labelcz: 'Home Service Contract Provider',
            labelen: 'Home Service Contract Provider'
        },
        {
            value: 'MQU4',
            labelcz: 'Domestic Unincorporated Association',
            labelen: 'Domestic Unincorporated Association'
        },
        {
            value: 'N71W',
            labelcz: 'Cable & Video Franchise',
            labelen: 'Cable & Video Franchise'
        },
        {
            value: 'NI44',
            labelcz: 'Domestic Corporation',
            labelen: 'Domestic Corporation'
        },
        {
            value: 'NV9X',
            labelcz: 'Domestic Real Estate Investment Trust',
            labelen: 'Domestic Real Estate Investment Trust'
        },
        {
            value: 'O6QP',
            labelcz: 'Domestic Partnership',
            labelen: 'Domestic Partnership'
        },
        {
            value: 'ONJ1',
            labelcz: 'Domestic Low-Profit Limited Liability Company',
            labelen: 'Domestic Low-Profit Limited Liability Company'
        },
        {
            value: 'Q8RV',
            labelcz: 'Foreign Benefit Corporation',
            labelen: 'Foreign Benefit Corporation'
        },
        {
            value: 'SJKV',
            labelcz: 'Foreign Non-Profit Corporation',
            labelen: 'Foreign Non-Profit Corporation'
        },
        {
            value: 'TDBW',
            labelcz: 'Domestic Registered Limited Liability Partnership',
            labelen: 'Domestic Registered Limited Liability Partnership'
        },
        { value: 'WP6R', labelcz: 'Co-op', labelen: 'Co-op' },
        {
            value: 'Z016',
            labelcz: 'Collection Agency',
            labelen: 'Collection Agency'
        },
        {
            value: 'ZQZW',
            labelcz: 'Foreign Public Benefit',
            labelen: 'Foreign Public Benefit'
        },
        {
            value: '2XXG',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: '53DC',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'IIZ4',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: 'JR3Z', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: 'M9A1',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'TTB3',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: '1XME',
            labelcz: 'Housing Cooperative Corporation',
            labelen: 'Housing Cooperative Corporation'
        },
        {
            value: '672E',
            labelcz: 'Cooperative Corporation',
            labelen: 'Cooperative Corporation'
        },
        {
            value: '6I75',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'BYFU',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'CAGH',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'GOGQ',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'NETO',
            labelcz: 'Employee Cooperative Corporation',
            labelen: 'Employee Cooperative Corporation'
        },
        {
            value: 'QX9N',
            labelcz: 'Domestic Benefit Corporation (including professional corporations)',
            labelen: 'Domestic Benefit Corporation (including professional corporations)'
        },
        {
            value: 'R7QO',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: 'Z73Z',
            labelcz: 'Voluntary Association and Business Trusts',
            labelen: 'Voluntary Association and Business Trusts'
        },
        {
            value: 'ZJTK',
            labelcz: 'Domestic Business  Corporation',
            labelen: 'Domestic Business  Corporation'
        },
        {
            value: '47LQ',
            labelcz: 'Corporation (Nonprofit)',
            labelen: 'Corporation (Nonprofit)'
        },
        {
            value: '58N0',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '6E4G',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '88XU',
            labelcz: 'Sole proprietorship',
            labelen: 'Sole proprietorship'
        },
        {
            value: 'HQJV',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'IN4H',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        {
            value: 'LJH5',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'MI0H',
            labelcz: 'for profit and not-for profit co-operatives',
            labelen: 'for profit and not-for profit co-operatives'
        },
        {
            value: 'NK3V',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        { value: 'NR96', labelcz: 'L3C', labelen: 'L3C' },
        {
            value: 'U7HC',
            labelcz: 'Corporation (For-Profit)',
            labelen: 'Corporation (For-Profit)'
        },
        {
            value: 'UJZB',
            labelcz: 'Ecclesiastical Corporation',
            labelen: 'Ecclesiastical Corporation'
        },
        { value: 'XTOF', labelcz: 'Railroad', labelen: 'Railroad' },
        {
            value: '1ASH',
            labelcz: 'Religious corporations',
            labelen: 'Religious corporations'
        },
        {
            value: '1ONH',
            labelcz: 'Public Benefit Corporations',
            labelen: 'Public Benefit Corporations'
        },
        {
            value: '37F5',
            labelcz: 'Professional Firms',
            labelen: 'Professional Firms'
        },
        {
            value: '43LY',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '6ZAR',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: '8OK2', labelcz: 'Business Trusts', labelen: 'Business Trusts' },
        {
            value: '9HKD',
            labelcz: 'Financial Corporations',
            labelen: 'Financial Corporations'
        },
        {
            value: '9I4Y',
            labelcz: 'Non-Profit Corporation',
            labelen: 'Non-Profit Corporation'
        },
        {
            value: 'BQRL',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'DEMP',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'IYZI',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: 'LDBS',
            labelcz: 'Cooperative (Producer)',
            labelen: 'Cooperative (Producer)'
        },
        {
            value: 'OXAZ',
            labelcz: 'Insurance Corporations',
            labelen: 'Insurance Corporations'
        },
        {
            value: 'S2K8',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'T4OL',
            labelcz: 'Cemetery associations',
            labelen: 'Cemetery associations'
        },
        {
            value: 'TBN1',
            labelcz: 'Non-Profit Limited Liability Company',
            labelen: 'Non-Profit Limited Liability Company'
        },
        {
            value: 'UJ49',
            labelcz: 'Cooperative (Investor)',
            labelen: 'Cooperative (Investor)'
        },
        {
            value: '8YBQ',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'NDBR',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'O4NK',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'U7GR',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'WPCN',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'XST3',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: '1ADA',
            labelcz: 'Family Trust Company',
            labelen: 'Family Trust Company'
        },
        {
            value: '21OE',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '7F5B',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'EMLK',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'KC7Z',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'R8SH',
            labelcz: 'Not For Profit Corporation',
            labelen: 'Not For Profit Corporation'
        },
        {
            value: 'SU5T',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: '1S9L',
            labelcz: 'Professional Series Limited Liability Company',
            labelen: 'Professional Series Limited Liability Company'
        },
        {
            value: '1XOG',
            labelcz: 'Agricultural Marketing Association',
            labelen: 'Agricultural Marketing Association'
        },
        {
            value: '30PQ',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        { value: '30TX', labelcz: 'Trust Company', labelen: 'Trust Company' },
        {
            value: '40SO',
            labelcz: 'Mutual Benefit Corporation',
            labelen: 'Mutual Benefit Corporation'
        },
        {
            value: '5AE9',
            labelcz: 'Builidng and Loan Association',
            labelen: 'Builidng and Loan Association'
        },
        {
            value: '5MRP',
            labelcz: 'Close Corporation',
            labelen: 'Close Corporation'
        },
        {
            value: '7OS8',
            labelcz: 'Congressional Chartered Corporation',
            labelen: 'Congressional Chartered Corporation'
        },
        {
            value: '93CA',
            labelcz: 'Agricultural Association',
            labelen: 'Agricultural Association'
        },
        {
            value: '9OSW',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: '9STD', labelcz: 'Corporation', labelen: 'Corporation' },
        {
            value: 'A770',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'AEK0',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'B2F4',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        { value: 'HEMZ', labelcz: 'Credit Union', labelen: 'Credit Union' },
        {
            value: 'JGPP',
            labelcz: 'Rural Cooperative Association',
            labelen: 'Rural Cooperative Association'
        },
        {
            value: 'KPH8',
            labelcz: 'Investment Company',
            labelen: 'Investment Company'
        },
        {
            value: 'L1PM',
            labelcz: 'Professional Limited Liability Limited Partnership',
            labelen: 'Professional Limited Liability Limited Partnership'
        },
        {
            value: 'LPLY',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'MY93',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        {
            value: 'OOX5',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        {
            value: 'PNF3',
            labelcz: 'Corporate Credit Union',
            labelen: 'Corporate Credit Union'
        },
        { value: 'QB0A', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'SCX8',
            labelcz: 'Public Benefit Corporation',
            labelen: 'Public Benefit Corporation'
        },
        {
            value: 'T91C',
            labelcz: 'Professional Close Corporation',
            labelen: 'Professional Close Corporation'
        },
        {
            value: 'WRF9',
            labelcz: 'Religious Corporation',
            labelen: 'Religious Corporation'
        },
        {
            value: 'XVC6',
            labelcz: 'Series Limited Liability Company',
            labelen: 'Series Limited Liability Company'
        },
        {
            value: '3GTV',
            labelcz: 'Sanitary & Improvement District',
            labelen: 'Sanitary & Improvement District'
        },
        {
            value: '4TMV',
            labelcz: 'Domestic Limited Cooperative Association',
            labelen: 'Domestic Limited Cooperative Association'
        },
        {
            value: '5OET',
            labelcz: 'Foreign Limited Liability Company',
            labelen: 'Foreign Limited Liability Company'
        },
        {
            value: '639V',
            labelcz: 'Non Profit Domesticated Foreign Corporation',
            labelen: 'Non Profit Domesticated Foreign Corporation'
        },
        {
            value: '6ICB',
            labelcz: 'Foreign Corp Professional Corporation',
            labelen: 'Foreign Corp Professional Corporation'
        },
        {
            value: '7BQ5',
            labelcz: 'Non Stock Corporation',
            labelen: 'Non Stock Corporation'
        },
        {
            value: '8APW',
            labelcz: 'Domestic Limited Liability Company',
            labelen: 'Domestic Limited Liability Company'
        },
        {
            value: '8HNT',
            labelcz: 'Foreign Corporation',
            labelen: 'Foreign Corporation'
        },
        {
            value: 'B843',
            labelcz: 'Domestic Professional Limited Liability Company',
            labelen: 'Domestic Professional Limited Liability Company'
        },
        {
            value: 'BJ2V',
            labelcz: 'Foreign Professional Limited Liability Company',
            labelen: 'Foreign Professional Limited Liability Company'
        },
        {
            value: 'CXIO',
            labelcz: 'Domesticated Foreign Corporation Professional Corporation',
            labelen: 'Domesticated Foreign Corporation Professional Corporation'
        },
        {
            value: 'D2MO',
            labelcz: 'Joint Public Agency',
            labelen: 'Joint Public Agency'
        },
        {
            value: 'DFPP',
            labelcz: 'Domestic Limited Partnership',
            labelen: 'Domestic Limited Partnership'
        },
        {
            value: 'ECLT',
            labelcz: 'Domestic Corporation Professional Corporation',
            labelen: 'Domestic Corporation Professional Corporation'
        },
        {
            value: 'HV3B',
            labelcz: 'Non Taxable Corporation',
            labelen: 'Non Taxable Corporation'
        },
        {
            value: 'IOWN',
            labelcz: 'Non Profit Foreign Limited Cooperative Association',
            labelen: 'Non Profit Foreign Limited Cooperative Association'
        },
        {
            value: 'KFPS',
            labelcz: 'Domestic General Partnership',
            labelen: 'Domestic General Partnership'
        },
        {
            value: 'LQZC',
            labelcz: 'Nebraska Benefit Corporation',
            labelen: 'Nebraska Benefit Corporation'
        },
        {
            value: 'MPFG',
            labelcz: 'Foreign Limited Liability Partnership',
            labelen: 'Foreign Limited Liability Partnership'
        },
        {
            value: 'NGZJ',
            labelcz: 'Domesticated Foreign Corporation',
            labelen: 'Domesticated Foreign Corporation'
        },
        {
            value: 'O256',
            labelcz: 'Non Profit Foreign Corporation',
            labelen: 'Non Profit Foreign Corporation'
        },
        {
            value: 'R22H',
            labelcz: 'Registered Agent Designation',
            labelen: 'Registered Agent Designation'
        },
        {
            value: 'R3J6',
            labelcz: 'Foreign General Apartnership',
            labelen: 'Foreign General Apartnership'
        },
        {
            value: 'R7JP',
            labelcz: 'Non Profit (Dom) Corporation',
            labelen: 'Non Profit (Dom) Corporation'
        },
        {
            value: 'RH6N',
            labelcz: 'Domestic Corporation',
            labelen: 'Domestic Corporation'
        },
        {
            value: 'T172',
            labelcz: 'Insurance Company',
            labelen: 'Insurance Company'
        },
        {
            value: 'V4RX',
            labelcz: 'Non Profit Dom Limited Cooperative Association',
            labelen: 'Non Profit Dom Limited Cooperative Association'
        },
        {
            value: 'VYEO',
            labelcz: 'Fraternal Society',
            labelen: 'Fraternal Society'
        },
        {
            value: 'XBKP',
            labelcz: 'Agricultural Association',
            labelen: 'Agricultural Association'
        },
        { value: 'XUVE', labelcz: 'Bank', labelen: 'Bank' },
        {
            value: 'Y7BG',
            labelcz: 'Hospital Authority',
            labelen: 'Hospital Authority'
        },
        {
            value: 'YQDQ',
            labelcz: 'Domestic Limited Liability Partnership',
            labelen: 'Domestic Limited Liability Partnership'
        },
        {
            value: 'YWK0',
            labelcz: 'Foreign Limited Partnership',
            labelen: 'Foreign Limited Partnership'
        },
        {
            value: 'ZEZ2',
            labelcz: 'Foreign Limited Cooperative Association',
            labelen: 'Foreign Limited Cooperative Association'
        },
        {
            value: '62L3',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '7K6U',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '8WM4',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'IY8C',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'MM8M',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        { value: 'SUEQ', labelcz: 'Business Trust', labelen: 'Business Trust' },
        { value: '520I', labelcz: 'Foundation', labelen: 'Foundation' },
        {
            value: '6M6O',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: '9M2Q',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        {
            value: 'G66U',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'OJ9K',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'P3LZ',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'RCNI',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: 'S97G', labelcz: 'Investment Trust', labelen: 'Investment Trust' },
        {
            value: '7HY7',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'FFBM',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'P7RH',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'T4M6',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'XSNP',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: '4YOA',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: '7GMS',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: 'VG3S',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'W0U4',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: '51RC',
            labelcz: 'Not-for-profit Corporation',
            labelen: 'Not-for-profit Corporation'
        },
        {
            value: 'BO6L',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'PJ10',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'SDX0',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'XIZI',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '1QMT',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: '358I',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: '3DXJ',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        {
            value: '4LKE',
            labelcz: 'County Agricultural Fair',
            labelen: 'County Agricultural Fair'
        },
        {
            value: '5JAL',
            labelcz: 'Insurance Company',
            labelen: 'Insurance Company'
        },
        { value: '6NI8', labelcz: 'Railroad', labelen: 'Railroad' },
        {
            value: '8QMN',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'ARON',
            labelcz: 'limited partnership',
            labelen: 'limited partnership'
        },
        {
            value: 'CJ58',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: 'F99D',
            labelcz: 'Electric Membership Cooperative',
            labelen: 'Electric Membership Cooperative'
        },
        {
            value: 'IHLF',
            labelcz: 'Savings & Loan Association',
            labelen: 'Savings & Loan Association'
        },
        {
            value: 'JF6D',
            labelcz: 'Nonprofit Community Trust',
            labelen: 'Nonprofit Community Trust'
        },
        {
            value: 'Q4F9',
            labelcz: 'Mutual Association',
            labelen: 'Mutual Association'
        },
        { value: 'Q6EM', labelcz: 'L3C', labelen: 'L3C' },
        {
            value: 'SIST',
            labelcz: 'Public Transportation Authority',
            labelen: 'Public Transportation Authority'
        },
        {
            value: 'U94O',
            labelcz: 'Captive Insurance Company',
            labelen: 'Captive Insurance Company'
        },
        { value: 'UFIY', labelcz: 'Bank', labelen: 'Bank' },
        {
            value: 'UKX4',
            labelcz: 'State Savings Bank',
            labelen: 'State Savings Bank'
        },
        { value: 'WY1B', labelcz: 'Municipal', labelen: 'Municipal' },
        {
            value: 'X0MP',
            labelcz: 'limited liability partnership',
            labelen: 'limited liability partnership'
        },
        {
            value: 'X1EL',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'Y5L0',
            labelcz: 'Mutual Burial Association',
            labelen: 'Mutual Burial Association'
        },
        {
            value: 'YJZ3',
            labelcz: 'Registered Limited Liability Limited Partnership',
            labelen: 'Registered Limited Liability Limited Partnership'
        },
        {
            value: '2WJZ',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: '4U9V',
            labelcz: 'Professional Limited Liabity Partnership',
            labelen: 'Professional Limited Liabity Partnership'
        },
        {
            value: '64HG',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        {
            value: '6JCE',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'CPK1',
            labelcz: 'Mutual Aid Cooperative',
            labelen: 'Mutual Aid Cooperative'
        },
        {
            value: 'DLEW',
            labelcz: 'Nonprofit Limited Liability Company',
            labelen: 'Nonprofit Limited Liability Company'
        },
        {
            value: 'EO24',
            labelcz: 'Cooperative Grazing Associations',
            labelen: 'Cooperative Grazing Associations'
        },
        {
            value: 'ER7C',
            labelcz: 'Publicly Traded Corporation',
            labelen: 'Publicly Traded Corporation'
        },
        {
            value: 'FK53',
            labelcz: 'Farm/Ranch Limited Laibility Company',
            labelen: 'Farm/Ranch Limited Laibility Company'
        },
        {
            value: 'GHB2',
            labelcz: '(Business) Limited Liability Company',
            labelen: '(Business) Limited Liability Company'
        },
        {
            value: 'J1V0',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'LF4E',
            labelcz: 'Farm/Ranch Corporation',
            labelen: 'Farm/Ranch Corporation'
        },
        {
            value: 'MTDW',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: 'NHGN',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'NJA5',
            labelcz: 'Real Estate Investment Trusts',
            labelen: 'Real Estate Investment Trusts'
        },
        {
            value: 'OGHV',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'S745',
            labelcz: '(Business) Corporation',
            labelen: '(Business) Corporation'
        },
        {
            value: 'U87X',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'WIU6',
            labelcz: 'Community Development Corporation',
            labelen: 'Community Development Corporation'
        },
        {
            value: 'YOB3',
            labelcz: 'Electric Cooperative Corporations',
            labelen: 'Electric Cooperative Corporations'
        },
        {
            value: 'ZULC',
            labelcz: 'Development Corporation',
            labelen: 'Development Corporation'
        },
        {
            value: '52U0',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '7VK5',
            labelcz: 'Corporation (Nonprofit)',
            labelen: 'Corporation (Nonprofit)'
        },
        {
            value: '95OK',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: 'AEJF',
            labelcz: 'Professional Association',
            labelen: 'Professional Association'
        },
        {
            value: 'BTQ1',
            labelcz: 'Corporation (For-Profit)',
            labelen: 'Corporation (For-Profit)'
        },
        {
            value: 'EZNQ',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        { value: 'FZMT', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: 'ZD39',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'B8XC',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'BGH4',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'OJDX',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'PQXK',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'VJXH',
            labelcz: 'Not-for-profit Corporation',
            labelen: 'Not-for-profit Corporation'
        },
        {
            value: '4BEM',
            labelcz: 'Assumed Business Name',
            labelen: 'Assumed Business Name'
        },
        {
            value: 'GEE0',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'QK2J',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'R18M',
            labelcz: 'District Improvement Company',
            labelen: 'District Improvement Company'
        },
        { value: 'T2DF', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'T5ZE',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'UQWQ',
            labelcz: 'Cooperative Corporation',
            labelen: 'Cooperative Corporation'
        },
        {
            value: 'UZ83',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'V10Q',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'WQLU',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '3JTE',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: '9C19',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: '9EJ6',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'B8KO',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'HSEV',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '5E0K',
            labelcz: 'Benefit Professional Corporation',
            labelen: 'Benefit Professional Corporation'
        },
        {
            value: '7RLC',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'AVLE',
            labelcz: 'Non-profit Corporation',
            labelen: 'Non-profit Corporation'
        },
        {
            value: 'DRSE',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'FW66',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'MG8V',
            labelcz: 'L3C Low Profit LLC',
            labelen: 'L3C Low Profit LLC'
        },
        {
            value: 'N263',
            labelcz: 'Workers Cooperative',
            labelen: 'Workers Cooperative'
        },
        {
            value: 'QMI2',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        {
            value: 'RZ5R',
            labelcz: 'Professional Service Corporation',
            labelen: 'Professional Service Corporation'
        },
        {
            value: 'Z54A',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        { value: 'ZHZP', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: '11GD',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: '7QV2',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'DBGD',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'G0HE',
            labelcz: 'Statutory Close Corporation',
            labelen: 'Statutory Close Corporation'
        },
        {
            value: 'G6VI',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'N10D',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'PNSZ',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        {
            value: 'WTWK',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '15JS',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'C276',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'JZWN',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'UX5E',
            labelcz: 'Limited Liability Limited Partnership',
            labelen: 'Limited Liability Limited Partnership'
        },
        {
            value: 'Z9CH',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '7TJ1',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: '8MBD',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'DQUB',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'I2XB',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'QJ9F',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'RD1T',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: '9AAS',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'C5K7',
            labelcz: 'For-Profit Corporation',
            labelen: 'For-Profit Corporation'
        },
        {
            value: 'FE1L',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'MXWB',
            labelcz: 'Professional Association',
            labelen: 'Professional Association'
        },
        {
            value: 'OGSS',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'WYG5',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: '1CZS',
            labelcz: 'General Partnership',
            labelen: 'General Partnership'
        },
        {
            value: '2I4P',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: '3ZXC',
            labelcz: 'Limited Liability Company (LLC)',
            labelen: 'Limited Liability Company (LLC)'
        },
        {
            value: '7H0X',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        { value: 'B12O', labelcz: 'Business Trust', labelen: 'Business Trust' },
        { value: 'GIN3', labelcz: 'Benefit LLC', labelen: 'Benefit LLC' },
        {
            value: 'IDFN',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'NOBH',
            labelcz: 'Non-profit Corporation',
            labelen: 'Non-profit Corporation'
        },
        {
            value: 'Q1N4',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'T0XH',
            labelcz: 'Benefit Corporation',
            labelen: 'Benefit Corporation'
        },
        { value: 'UEKV', labelcz: 'Low Profit LLC', labelen: 'Low Profit LLC' },
        {
            value: 'YQLO',
            labelcz: 'Uniform Limited Cooperative Association',
            labelen: 'Uniform Limited Cooperative Association'
        },
        {
            value: '8XN0',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'GZMZ',
            labelcz: 'Professional Corporation',
            labelen: 'Professional Corporation'
        },
        {
            value: 'K4MF',
            labelcz: 'Professional Limited Liability Company',
            labelen: 'Professional Limited Liability Company'
        },
        { value: 'LPEE', labelcz: 'Cooperative', labelen: 'Cooperative' },
        {
            value: 'NYUD',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'OE6T',
            labelcz: 'Limited Liability Company (LLC)',
            labelen: 'Limited Liability Company (LLC)'
        },
        {
            value: 'PNZI',
            labelcz: 'Non-profit Corporation',
            labelen: 'Non-profit Corporation'
        },
        { value: 'R8O9', labelcz: 'Low Profit LLC', labelen: 'Low Profit LLC' },
        {
            value: 'TCC0',
            labelcz: 'Mutual Benefit Enterprise',
            labelen: 'Mutual Benefit Enterprise'
        },
        {
            value: 'UF6Y',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: '456O', labelcz: 'Partnership', labelen: 'Partnership' },
        {
            value: '4WN7',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: '8KA4',
            labelcz: 'Registered Limited Liability Partnership',
            labelen: 'Registered Limited Liability Partnership'
        },
        { value: 'BOEX', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'DQMV',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'HOV4',
            labelcz: 'Stock Corporation',
            labelen: 'Stock Corporation'
        },
        {
            value: 'PLMC',
            labelcz: 'Nonstock Corporation',
            labelen: 'Nonstock Corporation'
        },
        {
            value: 'F8DD',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'LBJ1',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'NHYA',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'RR8G',
            labelcz: 'Non-profit Corporation',
            labelen: 'Non-profit Corporation'
        },
        {
            value: 'RRXD',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: '74LJ',
            labelcz: 'Limited Partnership (including Limited Liability Limited Partnership)',
            labelen: 'Limited Partnership (including Limited Liability Limited Partnership)'
        },
        {
            value: 'CNQ3',
            labelcz: 'Business Corporation (including professional corporation)',
            labelen: 'Business Corporation (including professional corporation)'
        },
        {
            value: 'IPGV',
            labelcz: 'Limited Cooperative Association',
            labelen: 'Limited Cooperative Association'
        },
        {
            value: 'O35K',
            labelcz: 'General Cooperative Association',
            labelen: 'General Cooperative Association'
        },
        { value: 'SQOE', labelcz: 'Statutory Trust', labelen: 'Statutory Trust' },
        {
            value: 'TJ6V',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'VNIU',
            labelcz: 'Limited Liability Company (including professional LLC and series LLC)',
            labelen: 'Limited Liability Company (including professional LLC and series LLC)'
        },
        {
            value: 'ZJPG',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'DURX',
            labelcz: 'Voluntary Association',
            labelen: 'Voluntary Association'
        },
        {
            value: 'IJHI',
            labelcz: 'Corporation (for profit)',
            labelen: 'Corporation (for profit)'
        },
        { value: 'O9MN', labelcz: 'Business Trust', labelen: 'Business Trust' },
        {
            value: 'OJBU',
            labelcz: 'Unincorporated Non-Profit Association',
            labelen: 'Unincorporated Non-Profit Association'
        },
        {
            value: 'PXGA',
            labelcz: 'Corporation (non-profit)',
            labelen: 'Corporation (non-profit)'
        },
        {
            value: 'QDZK',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: 'RC5L',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'SUMS',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: '6S32',
            labelcz: 'Business Corporation',
            labelen: 'Business Corporation'
        },
        {
            value: 'C0CR',
            labelcz: 'Cooperative Association',
            labelen: 'Cooperative Association'
        },
        {
            value: 'EVBW',
            labelcz: 'Corporation Nonstock Nonprofit',
            labelen: 'Corporation Nonstock Nonprofit'
        },
        {
            value: 'M5RM',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'WNV6',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        {
            value: 'Z92A',
            labelcz: 'Limited Liability Partnership',
            labelen: 'Limited Liability Partnership'
        },
        {
            value: 'ZXZ7',
            labelcz: 'Common Law Trust (Business Trust)',
            labelen: 'Common Law Trust (Business Trust)'
        },
        {
            value: '1YA4',
            labelcz: 'Statutory Foundation',
            labelen: 'Statutory Foundation'
        },
        {
            value: '71ZI',
            labelcz: 'Registered Limited Liability Partnership',
            labelen: 'Registered Limited Liability Partnership'
        },
        {
            value: '9GXA',
            labelcz: 'Profit Corporation',
            labelen: 'Profit Corporation'
        },
        {
            value: 'NB58',
            labelcz: 'Limited Liability Company',
            labelen: 'Limited Liability Company'
        },
        {
            value: 'PUJR',
            labelcz: 'Nonprofit Corporation',
            labelen: 'Nonprofit Corporation'
        },
        {
            value: 'QR4Y',
            labelcz: 'Limited Partnership',
            labelen: 'Limited Partnership'
        },
        { value: 'RDQZ', labelcz: 'Statutory Trust', labelen: 'Statutory Trust' }
    ],
    VU: [
        { value: 'A35I', labelcz: 'Overseas Company', labelen: 'Overseas Company' },
        { value: 'JTJE', labelcz: 'Local Company', labelen: 'Local Company' },
        { value: 'WMJ9', labelcz: 'Foundation', labelen: 'Foundation' }
    ],
    VG: [
        {
            value: '6EH6',
            labelcz: 'company limited by shares',
            labelen: 'company limited by shares'
        },
        {
            value: 'BST2',
            labelcz: 'company limited by guarantee that is not authorised to issue shares',
            labelen: 'company limited by guarantee that is not authorised to issue shares'
        },
        {
            value: 'GLCI',
            labelcz: 'restricted purposes company',
            labelen: 'restricted purposes company'
        },
        {
            value: 'JS65',
            labelcz: 'unlimited company that is not authorised to issue shares',
            labelen: 'unlimited company that is not authorised to issue shares'
        },
        {
            value: 'N28C',
            labelcz: 'restricted purposes company segregated portfolio company',
            labelen: 'restricted purposes company segregated portfolio company'
        },
        {
            value: 'Q62B',
            labelcz: 'unlimited company that is authorised to issue shares',
            labelen: 'unlimited company that is authorised to issue shares'
        },
        {
            value: 'YOP9',
            labelcz: 'segregated portfolio company',
            labelen: 'segregated portfolio company'
        },
        {
            value: 'ZHED',
            labelcz: 'company limited by guarantee that is authorised to issue shares',
            labelen: 'company limited by guarantee that is authorised to issue shares'
        }
    ],
    VI: [
        {
            value: 'A30N',
            labelcz: 'Foreign Trade & Labor Corporation',
            labelen: 'Foreign Trade & Labor Corporation'
        },
        {
            value: 'AN8Z',
            labelcz: 'Foreign Limited Partnership / Limited Liability Limited Partnership',
            labelen: 'Foreign Limited Partnership / Limited Liability Limited Partnership'
        },
        {
            value: 'CHWX',
            labelcz: 'Domestic Limited Liability Company',
            labelen: 'Domestic Limited Liability Company'
        },
        {
            value: 'DMNZ',
            labelcz: 'Foreign Non-Profit Corporation',
            labelen: 'Foreign Non-Profit Corporation'
        },
        {
            value: 'MGUM',
            labelcz: 'Domestic Limited Partnership / Limited Liability Limited Partnership',
            labelen: 'Domestic Limited Partnership / Limited Liability Limited Partnership'
        },
        {
            value: 'MH3L',
            labelcz: 'Domestic Trade & Labor Corporation',
            labelen: 'Domestic Trade & Labor Corporation'
        },
        {
            value: 'NNLM',
            labelcz: 'Domestic Profit Corporation',
            labelen: 'Domestic Profit Corporation'
        },
        {
            value: 'PKZ2',
            labelcz: 'Domestic Non-Profit Corporation',
            labelen: 'Domestic Non-Profit Corporation'
        },
        {
            value: 'Q367',
            labelcz: 'Foreign Limited Liability Partnership',
            labelen: 'Foreign Limited Liability Partnership'
        },
        {
            value: 'SOX5',
            labelcz: 'Foreign Limited Liability Company',
            labelen: 'Foreign Limited Liability Company'
        },
        {
            value: 'TA9Z',
            labelcz: 'Domestic Limited Liability Partnership',
            labelen: 'Domestic Limited Liability Partnership'
        },
        {
            value: 'UZ9W',
            labelcz: 'Foreign Profit Corporation',
            labelen: 'Foreign Profit Corporation'
        }
    ]
};
